export const mapper = [
    {
      "��ȣ": 6911,
      "bar": "",
      "�װ����": "Korean Air",
      "bar__1": "Korean Air",
      "IATA": "KE",
      "bar__2": "KAL",
      "ICAO": "Republic of Korea",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 6910,
      "bar": "",
      "�װ����": "Asiana Airlines",
      "bar__1": "Asiana Airlines",
      "IATA": "OZ",
      "bar__2": "AAR",
      "ICAO": "Republic of Korea",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 6909,
      "bar": "",
      "�װ����": "Jeju Air",
      "bar__1": "Jeju Air",
      "IATA": "7C",
      "bar__2": "JJA",
      "ICAO": "Republic of Korea",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 6908,
      "bar": "",
      "�װ����": "Jin Air",
      "bar__1": "Jin Air",
      "IATA": "LJ",
      "bar__2": "JNA",
      "ICAO": "Republic of Korea",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 6907,
      "bar": "",
      "�װ����": "Air Busan",
      "bar__1": "Air Busan",
      "IATA": "BX",
      "bar__2": "ABL",
      "ICAO": "Republic of Korea",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 7062,
      "bar": "",
      "�װ����": "Air Incheon",
      "bar__1": "Air Incheon",
      "IATA": "KJ",
      "bar__2": "AIH",
      "ICAO": "Republic Of Korea",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 7089,
      "bar": "",
      "�װ����": "air seoul",
      "bar__1": "air seoul",
      "IATA": "RS",
      "bar__2": "ASV",
      "ICAO": "Republic of Korea",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8339,
      "bar": "",
      "�װ����": "Fly Gangwon",
      "bar__1": "Fly Gangwon",
      "IATA": "4V",
      "bar__2": "FGW",
      "ICAO": "Republic Of Korea",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 6905,
      "bar": "",
      "�װ����": "Tway Air",
      "bar__1": "Tway Air",
      "IATA": "TW",
      "bar__2": "TWB",
      "ICAO": "Republic of Korea",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 7867,
      "bar": "",
      "�װ����": "Air Premia",
      "bar__1": "Air Premia",
      "IATA": "YP",
      "bar__2": "APZ",
      "ICAO": "Republic Of Korea",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 7203,
      "bar": "",
      "�װ����": "Aero K",
      "bar__1": "Aero K",
      "IATA": "RF",
      "bar__2": "EOK",
      "ICAO": "Republic of Korea",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 7260,
      "bar": "",
      "�װ����": "Hi Air",
      "bar__1": "Hi Air",
      "IATA": "4H",
      "bar__2": "HGG",
      "ICAO": "Republic of Korea",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8429,
      "bar": "",
      "�װ����": "Guardians Airline",
      "bar__1": "Guardians Airline",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Republic Of Korea",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 6892,
      "bar": "",
      "�װ����": "Air Koryo",
      "bar__1": "Air Koryo",
      "IATA": "JS",
      "bar__2": "KOR",
      "ICAO": "Democratic People's Republic of Korea",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 7063,
      "bar": "",
      "�װ����": "Jetstar Japan",
      "bar__1": "Jetstar Japan",
      "IATA": "GK",
      "bar__2": "JJP",
      "ICAO": "Japan",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 7005,
      "bar": "",
      "�װ����": "ANA Wings",
      "bar__1": "ANA Wings",
      "IATA": "EH",
      "bar__2": "AKX",
      "ICAO": "Japan",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 6912,
      "bar": "",
      "�װ����": "Peach",
      "bar__1": "Peach",
      "IATA": "MM",
      "bar__2": "APJ",
      "ICAO": "Japan",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 6883,
      "bar": "",
      "�װ����": "Fuji Dream Airlines",
      "bar__1": "Fuji Dream Airlines",
      "IATA": "JH",
      "bar__2": "FDA",
      "ICAO": "Japan",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 6882,
      "bar": "",
      "�װ����": "Japan Transocean Air",
      "bar__1": "Japan Transocean Air",
      "IATA": "NU",
      "bar__2": "JTA",
      "ICAO": "Japan",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 6881,
      "bar": "",
      "�װ����": "Air Japan",
      "bar__1": "Air Japan",
      "IATA": "NQ",
      "bar__2": "AJX",
      "ICAO": "Japan",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 6880,
      "bar": "",
      "�װ����": "All Nippon Airways",
      "bar__1": "All Nippon Airways",
      "IATA": "NH",
      "bar__2": "ANA",
      "ICAO": "Japan",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 6879,
      "bar": "",
      "�װ����": "Nippon Cargo Airlines",
      "bar__1": "Nippon Cargo Airlines",
      "IATA": "KZ",
      "bar__2": "NCA",
      "ICAO": "Japan",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 6877,
      "bar": "",
      "�װ����": "Japan AirLines",
      "bar__1": "Japan AirLines",
      "IATA": "JL",
      "bar__2": "JAL",
      "ICAO": "Japan",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 6876,
      "bar": "",
      "�װ����": "Air Do",
      "bar__1": "Air Do",
      "IATA": "HD",
      "bar__2": "ADO",
      "ICAO": "Japan",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 6874,
      "bar": "",
      "�װ����": "Skymark Airlines",
      "bar__1": "Skymark Airlines",
      "IATA": "BC",
      "bar__2": "SKY",
      "ICAO": "Japan",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 6867,
      "bar": "",
      "�װ����": "IBEX Airlines",
      "bar__1": "IBEX Airlines",
      "IATA": "FW",
      "bar__2": "IBX",
      "ICAO": "Japan",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 6860,
      "bar": "",
      "�װ����": "Solaseed Air",
      "bar__1": "Solaseed Air",
      "IATA": "6J",
      "bar__2": "SNJ",
      "ICAO": "Japan",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 6846,
      "bar": "",
      "�װ����": "Amakusa Airlines",
      "bar__1": "Amakusa Airlines",
      "IATA": "MZ",
      "bar__2": "AHX",
      "ICAO": "Japan",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 6832,
      "bar": "",
      "�װ����": "Shanghai Airlines",
      "bar__1": "Shanghai Airlines",
      "IATA": "FM",
      "bar__2": "CSH",
      "ICAO": "China",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 6829,
      "bar": "",
      "�װ����": "Grand China Air",
      "bar__1": "Grand China Air",
      "IATA": "CN",
      "bar__2": "GDC",
      "ICAO": "China",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 6824,
      "bar": "",
      "�װ����": "Kunming Airlines",
      "bar__1": "Kunming Airlines",
      "IATA": "KY",
      "bar__2": "KNA",
      "ICAO": "China",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 6823,
      "bar": "",
      "�װ����": "Shenzhen Airlines",
      "bar__1": "Shenzhen Airlines",
      "IATA": "ZH",
      "bar__2": "CSZ",
      "ICAO": "China",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 6822,
      "bar": "",
      "�װ����": "Shandong Airlines",
      "bar__1": "Shandong Airlines",
      "IATA": "SC",
      "bar__2": "CDG",
      "ICAO": "China",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 6821,
      "bar": "",
      "�װ����": "China Eastern Airlines",
      "bar__1": "China Eastern Airlines",
      "IATA": "MU",
      "bar__2": "CES",
      "ICAO": "China",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 6820,
      "bar": "",
      "�װ����": "Xiamen Airlines",
      "bar__1": "Xiamen Airlines",
      "IATA": "MF",
      "bar__2": "CXA",
      "ICAO": "China",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 6817,
      "bar": "",
      "�װ����": "Hainan Airlines",
      "bar__1": "Hainan Airlines",
      "IATA": "HU",
      "bar__2": "CHH",
      "ICAO": "China",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 6816,
      "bar": "",
      "�װ����": "Juneyao Airlines",
      "bar__1": "Juneyao Airlines",
      "IATA": "HO",
      "bar__2": "DKH",
      "ICAO": "China",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 6814,
      "bar": "",
      "�װ����": "China Southern Airlines",
      "bar__1": "China Southern Airlines",
      "IATA": "CZ",
      "bar__2": "CSN",
      "ICAO": "China",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 6813,
      "bar": "",
      "�װ����": "Air China",
      "bar__1": "Air China",
      "IATA": "CA",
      "bar__2": "CCA",
      "ICAO": "China",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 6812,
      "bar": "",
      "�װ����": "OKAY Airways",
      "bar__1": "OKAY Airways",
      "IATA": "BK",
      "bar__2": "OKA",
      "ICAO": "China",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 6805,
      "bar": "",
      "�װ����": "China United Airlines",
      "bar__1": "China United Airlines",
      "IATA": "KN",
      "bar__2": "CUA",
      "ICAO": "China",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 6804,
      "bar": "",
      "�װ����": "West Air",
      "bar__1": "West Air",
      "IATA": "PN",
      "bar__2": "CHB",
      "ICAO": "China",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 6803,
      "bar": "",
      "�װ����": "Chongqing Airlines",
      "bar__1": "Chongqing Airlines",
      "IATA": "OQ",
      "bar__2": "CQN",
      "ICAO": "China",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 6801,
      "bar": "",
      "�װ����": "TianJin Airlines",
      "bar__1": "TianJin Airlines",
      "IATA": "GS",
      "bar__2": "GCR",
      "ICAO": "China",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 6796,
      "bar": "",
      "�װ����": "Donghai Airlines Co",
      "bar__1": "Donghai Airlines Co",
      "IATA": "DZ",
      "bar__2": "EPA",
      "ICAO": "China",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 6795,
      "bar": "",
      "�װ����": "Sichuan Airlines",
      "bar__1": "Sichuan Airlines",
      "IATA": "3U",
      "bar__2": "CSC",
      "ICAO": "China",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 6794,
      "bar": "",
      "�װ����": "Spring Airlines",
      "bar__1": "Spring Airlines",
      "IATA": "9C",
      "bar__2": "CQH",
      "ICAO": "China",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 6793,
      "bar": "",
      "�װ����": "Chengdu Airlines",
      "bar__1": "Chengdu Airlines",
      "IATA": "EU",
      "bar__2": "UEA",
      "ICAO": "China",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 6790,
      "bar": "",
      "�װ����": "SF Airlines Company",
      "bar__1": "SF Airlines Company",
      "IATA": "O3",
      "bar__2": "CSS",
      "ICAO": "China",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 6774,
      "bar": "",
      "�װ����": "Air Changan",
      "bar__1": "Air Changan",
      "IATA": "9H",
      "bar__2": "CGN",
      "ICAO": "China",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 6763,
      "bar": "",
      "�װ����": "Joy Air",
      "bar__1": "Joy Air",
      "IATA": "JR",
      "bar__2": "JOY",
      "ICAO": "China",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 6761,
      "bar": "",
      "�װ����": "Uni-Top Airlines",
      "bar__1": "Uni-Top Airlines",
      "IATA": "UW",
      "bar__2": "UTP",
      "ICAO": "China",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 6758,
      "bar": "",
      "�װ����": "Hebei Airlines",
      "bar__1": "Hebei Airlines",
      "IATA": "NS",
      "bar__2": "HBH",
      "ICAO": "China",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 6750,
      "bar": "",
      "�װ����": "Beijing Airlines",
      "bar__1": "Beijing Airlines",
      "IATA": "",
      "bar__2": "BJN",
      "ICAO": "China",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 6745,
      "bar": "",
      "�װ����": "HK Express",
      "bar__1": "HK Express",
      "IATA": "UO",
      "bar__2": "HKE",
      "ICAO": "Hong Kong",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 6742,
      "bar": "",
      "�װ����": "Cathay Pacific",
      "bar__1": "Cathay Pacific",
      "IATA": "CX",
      "bar__2": "CPA",
      "ICAO": "Hong Kong",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 6741,
      "bar": "",
      "�װ����": "Sky Shuttle Helicopters",
      "bar__1": "Sky Shuttle Helicopters",
      "IATA": "",
      "bar__2": "HHK",
      "ICAO": "Hong Kong",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 6740,
      "bar": "",
      "�װ����": "HongKong Airlines",
      "bar__1": "HongKong Airlines",
      "IATA": "HX",
      "bar__2": "CRK",
      "ICAO": "Hong Kong",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 6734,
      "bar": "",
      "�װ����": "Air Macau",
      "bar__1": "Air Macau",
      "IATA": "NX",
      "bar__2": "AMU",
      "ICAO": "Macao",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 6729,
      "bar": "",
      "�װ����": "EVA Airways",
      "bar__1": "EVA Airways",
      "IATA": "BR",
      "bar__2": "EVA",
      "ICAO": "Taiwan",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 6728,
      "bar": "",
      "�װ����": "Mandarin Airlines",
      "bar__1": "Mandarin Airlines",
      "IATA": "AE",
      "bar__2": "MDA",
      "ICAO": "Taiwan",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 6726,
      "bar": "",
      "�װ����": "UNI Air",
      "bar__1": "UNI Air",
      "IATA": "B7",
      "bar__2": "UIA",
      "ICAO": "Taiwan",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 6842,
      "bar": "",
      "�װ����": "EZNIS AIRWAYS",
      "bar__1": "EZNIS AIRWAYS",
      "IATA": "MG",
      "bar__2": "EZA",
      "ICAO": "Mongolia",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 6723,
      "bar": "",
      "�װ����": "Philippine Air Lines",
      "bar__1": "Philippine Air Lines",
      "IATA": "PR",
      "bar__2": "PAL",
      "ICAO": "Philippines",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 6721,
      "bar": "",
      "�װ����": "CEBU Pacific Air",
      "bar__1": "CEBU Pacific Air",
      "IATA": "5J",
      "bar__2": "CEB",
      "ICAO": "Philippines",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 6720,
      "bar": "",
      "�װ����": "PAL Express",
      "bar__1": "PAL Express",
      "IATA": "2P",
      "bar__2": "GAP",
      "ICAO": "Philippines",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 2642,
      "bar": "",
      "�װ����": "Pan Pacific Airlines",
      "bar__1": "Pan Pacific Airlines",
      "IATA": "8Y",
      "bar__2": "AAV",
      "ICAO": "Philippines",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 6966,
      "bar": "",
      "�װ����": "Scoot",
      "bar__1": "Scoot",
      "IATA": "TR",
      "bar__2": "TGW",
      "ICAO": "Singapore",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 6699,
      "bar": "",
      "�װ����": "Silkair",
      "bar__1": "Silkair",
      "IATA": "MI",
      "bar__2": "SLK",
      "ICAO": "Singapore",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 6698,
      "bar": "",
      "�װ����": "Jetstar Asia",
      "bar__1": "Jetstar Asia",
      "IATA": "3K",
      "bar__2": "JSA",
      "ICAO": "Singapore",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 7066,
      "bar": "",
      "�װ����": "Malindo Airways",
      "bar__1": "Malindo Airways",
      "IATA": "OD",
      "bar__2": "MXD",
      "ICAO": "Malaysia",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 6690,
      "bar": "",
      "�װ����": "Firefly",
      "bar__1": "Firefly",
      "IATA": "FY",
      "bar__2": "FFM",
      "ICAO": "Malaysia",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 6687,
      "bar": "",
      "�װ����": "Malaysian Airlines",
      "bar__1": "Malaysian Airlines",
      "IATA": "MH",
      "bar__2": "MAS",
      "ICAO": "Malaysia",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 6686,
      "bar": "",
      "�װ����": "Berjaya Air",
      "bar__1": "Berjaya Air",
      "IATA": "J8",
      "bar__2": "BVT",
      "ICAO": "Malaysia",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 6684,
      "bar": "",
      "�װ����": "Airasia X",
      "bar__1": "Airasia X",
      "IATA": "D7",
      "bar__2": "XAX",
      "ICAO": "Malaysia",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 6678,
      "bar": "",
      "�װ����": "Sabah Air",
      "bar__1": "Sabah Air",
      "IATA": "SA",
      "bar__2": "SAX",
      "ICAO": "Malaysia",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 6675,
      "bar": "",
      "�װ����": "My Jet Xpress Airlines",
      "bar__1": "My Jet Xpress Airlines",
      "IATA": "N7",
      "bar__2": "NEP",
      "ICAO": "Malaysia",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 6983,
      "bar": "",
      "�װ����": "Transnusa Air Services",
      "bar__1": "Transnusa Air Services",
      "IATA": "8B",
      "bar__2": "TNU",
      "ICAO": "Indonesia",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 6981,
      "bar": "",
      "�װ����": "Cardig Air",
      "bar__1": "Cardig Air",
      "IATA": "8F",
      "bar__2": "CAD",
      "ICAO": "Indonesia",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 6670,
      "bar": "",
      "�װ����": "Wings Air",
      "bar__1": "Wings Air",
      "IATA": "IW",
      "bar__2": "WON",
      "ICAO": "Indonesia",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 6666,
      "bar": "",
      "�װ����": "Indonesia AirAsia",
      "bar__1": "Indonesia AirAsia",
      "IATA": "QZ",
      "bar__2": "AWQ",
      "ICAO": "Indonesia",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 6665,
      "bar": "",
      "�װ����": "Garuda Indonesia Airways",
      "bar__1": "Garuda Indonesia Airways",
      "IATA": "GA",
      "bar__2": "GIA",
      "ICAO": "Indonesia",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 6655,
      "bar": "",
      "�װ����": "Sriwijaya Air",
      "bar__1": "Sriwijaya Air",
      "IATA": "SJ",
      "bar__2": "SJY",
      "ICAO": "Indonesia",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 6634,
      "bar": "",
      "�װ����": "Nusantara Air Charter",
      "bar__1": "Nusantara Air Charter",
      "IATA": "",
      "bar__2": "SJK",
      "ICAO": "Indonesia",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 6628,
      "bar": "",
      "�װ����": "Trigana Air Service",
      "bar__1": "Trigana Air Service",
      "IATA": "IL",
      "bar__2": "TGN",
      "ICAO": "Indonesia",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 6627,
      "bar": "",
      "�װ����": "Xpress air",
      "bar__1": "Xpress air",
      "IATA": "XN",
      "bar__2": "XAR",
      "ICAO": "Indonesia",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 6625,
      "bar": "",
      "�װ����": "Aviastar Mandiri",
      "bar__1": "Aviastar Mandiri",
      "IATA": "MV",
      "bar__2": "VIT",
      "ICAO": "Indonesia",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 6624,
      "bar": "",
      "�װ����": "Transwisata air",
      "bar__1": "Transwisata air",
      "IATA": "",
      "bar__2": "TWT",
      "ICAO": "Indonesia",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 6623,
      "bar": "",
      "�װ����": "Travira Air",
      "bar__1": "Travira Air",
      "IATA": "TR",
      "bar__2": "TVV",
      "ICAO": "Indonesia",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 6622,
      "bar": "",
      "�װ����": "Susi air",
      "bar__1": "Susi air",
      "IATA": "",
      "bar__2": "SQS",
      "ICAO": "Indonesia",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 6615,
      "bar": "",
      "�װ����": "Royal Brunei Airlines",
      "bar__1": "Royal Brunei Airlines",
      "IATA": "BI",
      "bar__2": "RBA",
      "ICAO": "Brunei",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 6972,
      "bar": "",
      "�װ����": "Bhutan Airlines",
      "bar__1": "Bhutan Airlines",
      "IATA": "B3",
      "bar__2": "BTN",
      "ICAO": "Bhutan",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 6614,
      "bar": "",
      "�װ����": "Druk Air",
      "bar__1": "Druk Air",
      "IATA": "KB",
      "bar__2": "DRK",
      "ICAO": "Bhutan",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 6596,
      "bar": "",
      "�װ����": "Sky Angkor airlines",
      "bar__1": "Sky Angkor airlines",
      "IATA": "ZA",
      "bar__2": "SWM",
      "ICAO": "Cambodia",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 6585,
      "bar": "",
      "�װ����": "Thai Airways International",
      "bar__1": "Thai Airways International",
      "IATA": "TG",
      "bar__2": "THA",
      "ICAO": "Thailand",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 6584,
      "bar": "",
      "�װ����": "Bangkok Airways",
      "bar__1": "Bangkok Airways",
      "IATA": "PG",
      "bar__2": "BKP",
      "ICAO": "Thailand",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 6580,
      "bar": "",
      "�װ����": "NOK Air",
      "bar__1": "NOK Air",
      "IATA": "DD",
      "bar__2": "NOK",
      "ICAO": "Thailand",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 6574,
      "bar": "",
      "�װ����": "Thai Air Asia",
      "bar__1": "Thai Air Asia",
      "IATA": "FD",
      "bar__2": "AIQ",
      "ICAO": "Thailand",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 3403,
      "bar": "",
      "�װ����": "Jet Asia Airways",
      "bar__1": "Jet Asia Airways",
      "IATA": "JF",
      "bar__2": "JAA",
      "ICAO": "Thailand",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 7067,
      "bar": "",
      "�װ����": "Golden Myanmar Airlines",
      "bar__1": "Golden Myanmar Airlines",
      "IATA": "Y5",
      "bar__2": "GMR",
      "ICAO": "Myanmar",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 6536,
      "bar": "",
      "�װ����": "Myanmar Airways International",
      "bar__1": "Myanmar Airways International",
      "IATA": "8M",
      "bar__2": "MMA",
      "ICAO": "Myanmar",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 6534,
      "bar": "",
      "�װ����": "Air KBZ",
      "bar__1": "Air KBZ",
      "IATA": "K7",
      "bar__2": "KBZ",
      "ICAO": "Myanmar",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 6533,
      "bar": "",
      "�װ����": "Yangon Airways",
      "bar__1": "Yangon Airways",
      "IATA": "YH",
      "bar__2": "FSC",
      "ICAO": "Myanmar",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 7068,
      "bar": "",
      "�װ����": "Novoair",
      "bar__1": "Novoair",
      "IATA": "VQ",
      "bar__2": "NVQ",
      "ICAO": "Bangladesh",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 7053,
      "bar": "",
      "�װ����": "Regent Airways",
      "bar__1": "Regent Airways",
      "IATA": "RX",
      "bar__2": "RGE",
      "ICAO": "Bangladesh",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 6527,
      "bar": "",
      "�װ����": "Biman Bangladesh Airlines",
      "bar__1": "Biman Bangladesh Airlines",
      "IATA": "BG",
      "bar__2": "BBC",
      "ICAO": "Bangladesh",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 6523,
      "bar": "",
      "�װ����": "United Airways Bangladesh",
      "bar__1": "United Airways Bangladesh",
      "IATA": "4H",
      "bar__2": "UBD",
      "ICAO": "Bangladesh",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 6514,
      "bar": "",
      "�װ����": "Saurya Airlines",
      "bar__1": "Saurya Airlines",
      "IATA": "S1",
      "bar__2": "SAU",
      "ICAO": "Nepal",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 6512,
      "bar": "",
      "�װ����": "Nepal Airlines",
      "bar__1": "Nepal Airlines",
      "IATA": "RA",
      "bar__2": "RNA",
      "ICAO": "Nepal",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 6985,
      "bar": "",
      "�װ����": "Quikjet Airlines",
      "bar__1": "Quikjet Airlines",
      "IATA": "QO",
      "bar__2": "FQA",
      "ICAO": "India",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 6502,
      "bar": "",
      "�װ����": "Air India",
      "bar__1": "Air India",
      "IATA": "AI",
      "bar__2": "AIC",
      "ICAO": "India",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 6499,
      "bar": "",
      "�װ����": "Air India Express",
      "bar__1": "Air India Express",
      "IATA": "IX",
      "bar__2": "AXB",
      "ICAO": "India",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 6495,
      "bar": "",
      "�װ����": "IndiGo",
      "bar__1": "IndiGo",
      "IATA": "6E",
      "bar__2": "IGO",
      "ICAO": "India",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 6490,
      "bar": "",
      "�װ����": "Spicejet",
      "bar__1": "Spicejet",
      "IATA": "SG",
      "bar__2": "SEJ",
      "ICAO": "India",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 6483,
      "bar": "",
      "�װ����": "Jagson Airlines",
      "bar__1": "Jagson Airlines",
      "IATA": "",
      "bar__2": "JGN",
      "ICAO": "India",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 6970,
      "bar": "",
      "�װ����": "Vietjet Air",
      "bar__1": "Vietjet Air",
      "IATA": "VJ",
      "bar__2": "VJC",
      "ICAO": "Viet Nam",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 6441,
      "bar": "",
      "�װ����": "Vietnam Airlines",
      "bar__1": "Vietnam Airlines",
      "IATA": "VU",
      "bar__2": "VAG",
      "ICAO": "Viet Nam",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 6440,
      "bar": "",
      "�װ����": "Jetstar Pacific",
      "bar__1": "Jetstar Pacific",
      "IATA": "BL",
      "bar__2": "PIC",
      "ICAO": "Viet Nam",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 6439,
      "bar": "",
      "�װ����": "Vietnam Air Services",
      "bar__1": "Vietnam Air Services",
      "IATA": "0V",
      "bar__2": "VFC",
      "ICAO": "Viet Nam",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 6433,
      "bar": "",
      "�װ����": "Lao Airlines",
      "bar__1": "Lao Airlines",
      "IATA": "QV",
      "bar__2": "LAO",
      "ICAO": "Laos",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 6428,
      "bar": "",
      "�װ����": "Srilankan Airlines",
      "bar__1": "Srilankan Airlines",
      "IATA": "UL",
      "bar__2": "ALK",
      "ICAO": "Sri Lanka",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 6426,
      "bar": "",
      "�װ����": "FITS Aviation",
      "bar__1": "FITS Aviation",
      "IATA": "8D",
      "bar__2": "EXV",
      "ICAO": "Sri Lanka",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 6425,
      "bar": "",
      "�װ����": "Lankan Cargo",
      "bar__1": "Lankan Cargo",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Sri Lanka",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 6420,
      "bar": "",
      "�װ����": "Maldivian",
      "bar__1": "Maldivian",
      "IATA": "Q2",
      "bar__2": "DQA",
      "ICAO": "Maldives",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 1180,
      "bar": "",
      "�װ����": "Turkmenistan Airlines",
      "bar__1": "Turkmenistan Airlines",
      "IATA": "T5",
      "bar__2": "TUA",
      "ICAO": "Turkmenistan",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 6232,
      "bar": "",
      "�װ����": "Air Astana",
      "bar__1": "Air Astana",
      "IATA": "KC",
      "bar__2": "KZR",
      "ICAO": "Kazakhstan",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 6228,
      "bar": "",
      "�װ����": "SCAT Airlines",
      "bar__1": "SCAT Airlines",
      "IATA": "DV",
      "bar__2": "VSV",
      "ICAO": "Kazakhstan",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 6205,
      "bar": "",
      "�װ����": "Bek Air",
      "bar__1": "Bek Air",
      "IATA": "Z9",
      "bar__2": "BEK",
      "ICAO": "Kazakhstan",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 6186,
      "bar": "",
      "�װ����": "East Wing",
      "bar__1": "East Wing",
      "IATA": "",
      "bar__2": "EWZ",
      "ICAO": "Kazakhstan",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 6159,
      "bar": "",
      "�װ����": "Jet airlines",
      "bar__1": "Jet airlines",
      "IATA": "",
      "bar__2": "SOZ",
      "ICAO": "Kazakhstan",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 6126,
      "bar": "",
      "�װ����": "Sky Kg Airlines",
      "bar__1": "Sky Kg Airlines",
      "IATA": "Y3",
      "bar__2": "KGK",
      "ICAO": "Kyrgyzstan",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 6113,
      "bar": "",
      "�װ����": "Uzbekistan Airways",
      "bar__1": "Uzbekistan Airways",
      "IATA": "HY",
      "bar__2": "UZB",
      "ICAO": "Uzbekistan",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 6111,
      "bar": "",
      "�װ����": "Avialeasing Aviation Company",
      "bar__1": "Avialeasing Aviation Company",
      "IATA": "V2",
      "bar__2": "TWN",
      "ICAO": "Uzbekistan",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 6105,
      "bar": "",
      "�װ����": "Azerbaijan Airlines",
      "bar__1": "Azerbaijan Airlines",
      "IATA": "J2",
      "bar__2": "AHY",
      "ICAO": "Azerbaijan",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 6415,
      "bar": "",
      "�װ����": "Express Freighters Australia",
      "bar__1": "Express Freighters Australia",
      "IATA": "",
      "bar__2": "EFA",
      "ICAO": "Australia",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 6410,
      "bar": "",
      "�װ����": "Skytrans",
      "bar__1": "Skytrans",
      "IATA": "QN",
      "bar__2": "SKP",
      "ICAO": "Australia",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 6409,
      "bar": "",
      "�װ����": "Skippers Aviation Pty",
      "bar__1": "Skippers Aviation Pty",
      "IATA": "HK",
      "bar__2": "",
      "ICAO": "Australia",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 6407,
      "bar": "",
      "�װ����": "Regional Express",
      "bar__1": "Regional Express",
      "IATA": "ZL",
      "bar__2": "RXA",
      "ICAO": "Australia",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 6397,
      "bar": "",
      "�װ����": "Airnorth",
      "bar__1": "Airnorth",
      "IATA": "TL",
      "bar__2": "ANO",
      "ICAO": "Australia",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 6396,
      "bar": "",
      "�װ����": "Qantas Airways",
      "bar__1": "Qantas Airways",
      "IATA": "QF",
      "bar__2": "QFA",
      "ICAO": "Australia",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 6394,
      "bar": "",
      "�װ����": "Nauru Air Corporation",
      "bar__1": "Nauru Air Corporation",
      "IATA": "ON",
      "bar__2": "RON",
      "ICAO": "Australia",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 6392,
      "bar": "",
      "�װ����": "Jetstar Airways",
      "bar__1": "Jetstar Airways",
      "IATA": "JQ",
      "bar__2": "JST",
      "ICAO": "Australia",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 6391,
      "bar": "",
      "�װ����": "Virgin Australia Regional Airlines",
      "bar__1": "Virgin Australia Regional Airlines",
      "IATA": "VA",
      "bar__2": "VOZ",
      "ICAO": "Australia",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 6345,
      "bar": "",
      "�װ����": "Eastern Australia Airlines",
      "bar__1": "Eastern Australia Airlines",
      "IATA": "QF",
      "bar__2": "SSQ",
      "ICAO": "Australia",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 6317,
      "bar": "",
      "�װ����": "Pacific Air Express Australia Pty",
      "bar__1": "Pacific Air Express Australia Pty",
      "IATA": "PE",
      "bar__2": "PAQ",
      "ICAO": "Australia",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 6315,
      "bar": "",
      "�װ����": "Sharp Airlines",
      "bar__1": "Sharp Airlines",
      "IATA": "SH",
      "bar__2": "",
      "ICAO": "Australia",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 6313,
      "bar": "",
      "�װ����": "Toll Aviation Pty",
      "bar__1": "Toll Aviation Pty",
      "IATA": "",
      "bar__2": "TFX",
      "ICAO": "Australia",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 6311,
      "bar": "",
      "�װ����": "Hinterland Aviation Pty",
      "bar__1": "Hinterland Aviation Pty",
      "IATA": "OI",
      "bar__2": "HND",
      "ICAO": "Australia",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 6307,
      "bar": "",
      "�װ����": "Sunair Aviation",
      "bar__1": "Sunair Aviation",
      "IATA": "ZU",
      "bar__2": "SAV",
      "ICAO": "New Zealand",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 6304,
      "bar": "",
      "�װ����": "Air New Zealand",
      "bar__1": "Air New Zealand",
      "IATA": "NZ",
      "bar__2": "ANZ",
      "ICAO": "New Zealand",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 6303,
      "bar": "",
      "�װ����": "Air Chathams",
      "bar__1": "Air Chathams",
      "IATA": "CV",
      "bar__2": "CVA",
      "ICAO": "New Zealand",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 6274,
      "bar": "",
      "�װ����": "Aircalin",
      "bar__1": "Aircalin",
      "IATA": "SB",
      "bar__2": "ACI",
      "ICAO": "New Caledonia",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 4947,
      "bar": "",
      "�װ����": "Air Caledonie",
      "bar__1": "Air Caledonie",
      "IATA": "TY",
      "bar__2": "TPC",
      "ICAO": "France",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 6270,
      "bar": "",
      "�װ����": "Air Niugini",
      "bar__1": "Air Niugini",
      "IATA": "PX",
      "bar__2": "ANG",
      "ICAO": "Papua New Guinea",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 6269,
      "bar": "",
      "�װ����": "PNG air",
      "bar__1": "PNG air",
      "IATA": "CG",
      "bar__2": "TOK",
      "ICAO": "Papua New Guinea",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 6268,
      "bar": "",
      "�װ����": "Solomon Airlines",
      "bar__1": "Solomon Airlines",
      "IATA": "IE",
      "bar__2": "SOL",
      "ICAO": "Solomon Islands",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 6264,
      "bar": "",
      "�װ����": "Air Marshall Islands",
      "bar__1": "Air Marshall Islands",
      "IATA": "CW",
      "bar__2": "CWM",
      "ICAO": "Marshall Islands",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 6262,
      "bar": "",
      "�װ����": "Fiji Airways",
      "bar__1": "Fiji Airways",
      "IATA": "FJ",
      "bar__2": "FJI",
      "ICAO": "Fiji",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 6260,
      "bar": "",
      "�װ����": "Fiji Link",
      "bar__1": "Fiji Link",
      "IATA": "FJ",
      "bar__2": "FJA",
      "ICAO": "Fiji",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 6256,
      "bar": "",
      "�װ����": "Air Tahiti",
      "bar__1": "Air Tahiti",
      "IATA": "VT",
      "bar__2": "VTA",
      "ICAO": "French Polynesia",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 6255,
      "bar": "",
      "�װ����": "Air Tahiti Nui",
      "bar__1": "Air Tahiti Nui",
      "IATA": "TN",
      "bar__2": "THT",
      "ICAO": "French Polynesia",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 6263,
      "bar": "",
      "�װ����": "Air Rarotonga",
      "bar__1": "Air Rarotonga",
      "IATA": "GZ",
      "bar__2": "RAR",
      "ICAO": "Cook Islands",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 6249,
      "bar": "",
      "�װ����": "Air Kiribati",
      "bar__1": "Air Kiribati",
      "IATA": "IK",
      "bar__2": "AKL",
      "ICAO": "Kiribati",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 6247,
      "bar": "",
      "�װ����": "Air Vanuatu",
      "bar__1": "Air Vanuatu",
      "IATA": "NF",
      "bar__2": "AVN",
      "ICAO": "Vanuatu",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 6914,
      "bar": "",
      "�װ����": "Globus",
      "bar__1": "Globus",
      "IATA": "GH",
      "bar__2": "GLP",
      "ICAO": "Russia",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 6099,
      "bar": "",
      "�װ����": "Rusjet",
      "bar__1": "Rusjet",
      "IATA": "",
      "bar__2": "RSJ",
      "ICAO": "Russia",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 6097,
      "bar": "",
      "�װ����": "Utair Aviation",
      "bar__1": "Utair Aviation",
      "IATA": "UT",
      "bar__2": "UTA",
      "ICAO": "Russia",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 6081,
      "bar": "",
      "�װ����": "Yamal Airlines",
      "bar__1": "Yamal Airlines",
      "IATA": "YC",
      "bar__2": "LLM",
      "ICAO": "Russia",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 6076,
      "bar": "",
      "�װ����": "Volga-Dnepr",
      "bar__1": "Volga-Dnepr",
      "IATA": "VI",
      "bar__2": "VDA",
      "ICAO": "Russia",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 6073,
      "bar": "",
      "�װ����": "Ural Airlines",
      "bar__1": "Ural Airlines",
      "IATA": "U6",
      "bar__2": "SVR",
      "ICAO": "Russia",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 6071,
      "bar": "",
      "�װ����": "Aeroflot",
      "bar__1": "Aeroflot",
      "IATA": "SU",
      "bar__2": "AFL",
      "ICAO": "Russia",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 6070,
      "bar": "",
      "�װ����": "S7 Airlines",
      "bar__1": "S7 Airlines",
      "IATA": "S7",
      "bar__2": "SBI",
      "ICAO": "Russia",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 6055,
      "bar": "",
      "�װ����": "Alrosa Avia",
      "bar__1": "Alrosa Avia",
      "IATA": "6R",
      "bar__2": "DRU",
      "ICAO": "Russia",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 6054,
      "bar": "",
      "�װ����": "Smartavia",
      "bar__1": "Smartavia",
      "IATA": "5N",
      "bar__2": "AUL",
      "ICAO": "Russia",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 6053,
      "bar": "",
      "�װ����": "Gazpromavia",
      "bar__1": "Gazpromavia",
      "IATA": "4G",
      "bar__2": "GZP",
      "ICAO": "Russia",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 6034,
      "bar": "",
      "�װ����": "Saratov Airlines",
      "bar__1": "Saratov Airlines",
      "IATA": "6W",
      "bar__2": "SOV",
      "ICAO": "Russia",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 6023,
      "bar": "",
      "�װ����": "IrAero",
      "bar__1": "IrAero",
      "IATA": "IO",
      "bar__2": "IAE",
      "ICAO": "Russia",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 5999,
      "bar": "",
      "�װ����": "Nefteyugansk Air Services",
      "bar__1": "Nefteyugansk Air Services",
      "IATA": "",
      "bar__2": "NFT",
      "ICAO": "Russia",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 5987,
      "bar": "",
      "�װ����": "Rusline",
      "bar__1": "Rusline",
      "IATA": "7R",
      "bar__2": "RLU",
      "ICAO": "Russia",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 5978,
      "bar": "",
      "�װ����": "Meridian Air",
      "bar__1": "Meridian Air",
      "IATA": "",
      "bar__2": "MMM",
      "ICAO": "Russia",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 5937,
      "bar": "",
      "�װ����": "Orel State Air Enterprise",
      "bar__1": "Orel State Air Enterprise",
      "IATA": "",
      "bar__2": "ORM",
      "ICAO": "Russia",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 5923,
      "bar": "",
      "�װ����": "Komiaviatrans",
      "bar__1": "Komiaviatrans",
      "IATA": "KO",
      "bar__2": "KMA",
      "ICAO": "Russia",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 5922,
      "bar": "",
      "�װ����": "Kosmos",
      "bar__1": "Kosmos",
      "IATA": "",
      "bar__2": "KSM",
      "ICAO": "Russia",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 5916,
      "bar": "",
      "�װ����": "UTair Cargo",
      "bar__1": "UTair Cargo",
      "IATA": "",
      "bar__2": "TUM",
      "ICAO": "Russia",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 5907,
      "bar": "",
      "�װ����": "NordStar Airlines",
      "bar__1": "NordStar Airlines",
      "IATA": "Y7",
      "bar__2": "TYA",
      "ICAO": "Russia",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 5895,
      "bar": "",
      "�װ����": "Krasavia",
      "bar__1": "Krasavia",
      "IATA": "KI",
      "bar__2": "SSJ",
      "ICAO": "Russia",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 5794,
      "bar": "",
      "�װ����": "Yakutia Airlines",
      "bar__1": "Yakutia Airlines",
      "IATA": "R3",
      "bar__2": "SYL",
      "ICAO": "Russia",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 5837,
      "bar": "",
      "�װ����": "Avion Express",
      "bar__1": "Avion Express",
      "IATA": "X9",
      "bar__2": "NVD",
      "ICAO": "Lithuania",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 5835,
      "bar": "",
      "�װ����": "Dot Lt",
      "bar__1": "Dot Lt",
      "IATA": "R6",
      "bar__2": "DNU",
      "ICAO": "Lithuania",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 5823,
      "bar": "",
      "�װ����": "Belavia",
      "bar__1": "Belavia",
      "IATA": "B2",
      "bar__2": "BRU",
      "ICAO": "Belarus",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 7087,
      "bar": "",
      "�װ����": "ZetAvia",
      "bar__1": "ZetAvia",
      "IATA": "ZK",
      "bar__2": "ZAV",
      "ICAO": "Ukraine",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 5806,
      "bar": "",
      "�װ����": "UM Airlines",
      "bar__1": "UM Airlines",
      "IATA": "UF",
      "bar__2": "UKM",
      "ICAO": "Ukraine",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 5805,
      "bar": "",
      "�װ����": "Ukraine International Airlines",
      "bar__1": "Ukraine International Airlines",
      "IATA": "PS",
      "bar__2": "AUI",
      "ICAO": "Ukraine",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 5798,
      "bar": "",
      "�װ����": "Challenge Aero",
      "bar__1": "Challenge Aero",
      "IATA": "",
      "bar__2": "CHG",
      "ICAO": "Ukraine",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 5795,
      "bar": "",
      "�װ����": "Motor Sich",
      "bar__1": "Motor Sich",
      "IATA": "M9",
      "bar__2": "MSI",
      "ICAO": "Ukraine",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 5791,
      "bar": "",
      "�װ����": "Yuzhmashavia",
      "bar__1": "Yuzhmashavia",
      "IATA": "2N",
      "bar__2": "UMK",
      "ICAO": "Ukraine",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 5786,
      "bar": "",
      "�װ����": "Columbus Avia",
      "bar__1": "Columbus Avia",
      "IATA": "",
      "bar__2": "CBS",
      "ICAO": "Ukraine",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 5727,
      "bar": "",
      "�װ����": "Windrose airlines",
      "bar__1": "Windrose airlines",
      "IATA": "7W",
      "bar__2": "WRC",
      "ICAO": "Ukraine",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 5717,
      "bar": "",
      "�װ����": "LOT Polish Airlines",
      "bar__1": "LOT Polish Airlines",
      "IATA": "LO",
      "bar__2": "LOT",
      "ICAO": "Poland",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 5672,
      "bar": "",
      "�װ����": "Air Highnesses",
      "bar__1": "Air Highnesses",
      "IATA": "",
      "bar__2": "HNS",
      "ICAO": "Armenia",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 5667,
      "bar": "",
      "�װ����": "Finnair",
      "bar__1": "Finnair",
      "IATA": "AY",
      "bar__2": "FIN",
      "ICAO": "Finland",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 5654,
      "bar": "",
      "�װ����": "Norwegian Air Shuttle",
      "bar__1": "Norwegian Air Shuttle",
      "IATA": "DY",
      "bar__2": "NAX",
      "ICAO": "Norway",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 5651,
      "bar": "",
      "�װ����": "Wideroe",
      "bar__1": "Wideroe",
      "IATA": "WF",
      "bar__2": "WIF",
      "ICAO": "Norway",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 5648,
      "bar": "",
      "�װ����": "Lufttransport",
      "bar__1": "Lufttransport",
      "IATA": "L5",
      "bar__2": "LTR",
      "ICAO": "Norway",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 5616,
      "bar": "",
      "�װ����": "Novair",
      "bar__1": "Novair",
      "IATA": "N9",
      "bar__2": "NVR",
      "ICAO": "Sweden",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 5607,
      "bar": "",
      "�װ����": "TUIfly Nordic",
      "bar__1": "TUIfly Nordic",
      "IATA": "6B",
      "bar__2": "BLX",
      "ICAO": "Sweden",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 5589,
      "bar": "",
      "�װ����": "Nord-Flyg",
      "bar__1": "Nord-Flyg",
      "IATA": "",
      "bar__2": "NEF",
      "ICAO": "Sweden",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 5543,
      "bar": "",
      "�װ����": "Atlantic Airways",
      "bar__1": "Atlantic Airways",
      "IATA": "RC",
      "bar__2": "FLI",
      "ICAO": "Faroe Islands",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 5540,
      "bar": "",
      "�װ����": "Icar Air",
      "bar__1": "Icar Air",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Bosnia and Herzegovina",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 5537,
      "bar": "",
      "�װ����": "Bulgaria Air",
      "bar__1": "Bulgaria Air",
      "IATA": "FB",
      "bar__2": "LZB",
      "ICAO": "Bulgaria",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 5504,
      "bar": "",
      "�װ����": "Cargo Air",
      "bar__1": "Cargo Air",
      "IATA": "",
      "bar__2": "CGF",
      "ICAO": "Bulgaria",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 5500,
      "bar": "",
      "�װ����": "Croatia Airlines",
      "bar__1": "Croatia Airlines",
      "IATA": "OU",
      "bar__2": "CTN",
      "ICAO": "Croatia",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 5484,
      "bar": "",
      "�װ����": "Georgian Airways",
      "bar__1": "Georgian Airways",
      "IATA": "A9",
      "bar__2": "TGZ",
      "ICAO": "Georgia",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 5464,
      "bar": "",
      "�װ����": "Vista Georgia",
      "bar__1": "Vista Georgia",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Georgia",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 5463,
      "bar": "",
      "�װ����": "South-East European Airlines",
      "bar__1": "South-East European Airlines",
      "IATA": "",
      "bar__2": "GGG",
      "ICAO": "Georgia",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 5449,
      "bar": "",
      "�װ����": "Job Air",
      "bar__1": "Job Air",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Czech Republic",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 5443,
      "bar": "",
      "�װ����": "Aerotaxi S.R.O.",
      "bar__1": "Aerotaxi S.R.O.",
      "IATA": "",
      "bar__2": "ITE",
      "ICAO": "Czech Republic",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 5423,
      "bar": "",
      "�װ����": "Silver Air",
      "bar__1": "Silver Air",
      "IATA": "",
      "bar__2": "SLD",
      "ICAO": "Czech Republic",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 5418,
      "bar": "",
      "�װ����": "Fair",
      "bar__1": "Fair",
      "IATA": "",
      "bar__2": "FAP",
      "ICAO": "Czech Republic",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 5413,
      "bar": "",
      "�װ����": "Wizz Air Hungary",
      "bar__1": "Wizz Air Hungary",
      "IATA": "W6",
      "bar__2": "WZZ",
      "ICAO": "Hungary",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 5408,
      "bar": "",
      "�װ����": "Budapest Aircraft Service",
      "bar__1": "Budapest Aircraft Service",
      "IATA": "RP",
      "bar__2": "BPS",
      "ICAO": "Hungary",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 5402,
      "bar": "",
      "�װ����": "ASL Airlines Hungary",
      "bar__1": "ASL Airlines Hungary",
      "IATA": "",
      "bar__2": "FAH",
      "ICAO": "Hungary",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 5376,
      "bar": "",
      "�װ����": "Tarom Romanian Air Transport",
      "bar__1": "Tarom Romanian Air Transport",
      "IATA": "RO",
      "bar__2": "ROT",
      "ICAO": "Romania",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 5375,
      "bar": "",
      "�װ����": "Blue Air",
      "bar__1": "Blue Air",
      "IATA": "0B",
      "bar__2": "BLA",
      "ICAO": "Romania",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 5361,
      "bar": "",
      "�װ����": "Air Bucharest",
      "bar__1": "Air Bucharest",
      "IATA": "",
      "bar__2": "BUR",
      "ICAO": "Romania",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 5359,
      "bar": "",
      "�װ����": "Montenegro Airlines",
      "bar__1": "Montenegro Airlines",
      "IATA": "YM",
      "bar__2": "MGX",
      "ICAO": "Serbia and Montenegro",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 5358,
      "bar": "",
      "�װ����": "Air Serbia",
      "bar__1": "Air Serbia",
      "IATA": "JU",
      "bar__2": "ASL",
      "ICAO": "Serbia and Montenegro",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 5338,
      "bar": "",
      "�װ����": "Air Transport Europe",
      "bar__1": "Air Transport Europe",
      "IATA": "",
      "bar__2": "EAT",
      "ICAO": "Slovakia",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 5328,
      "bar": "",
      "�װ����": "AirExplore",
      "bar__1": "AirExplore",
      "IATA": "ED",
      "bar__2": "AXE",
      "ICAO": "Slovakia",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 5323,
      "bar": "",
      "�װ����": "Aviofun",
      "bar__1": "Aviofun",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Slovenia",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 4296,
      "bar": "",
      "�װ����": "Luxair",
      "bar__1": "Luxair",
      "IATA": "LG",
      "bar__2": "LGL",
      "ICAO": "Luxembourg",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 5309,
      "bar": "",
      "�װ����": "Austrian Airlines",
      "bar__1": "Austrian Airlines",
      "IATA": "OS",
      "bar__2": "AUA",
      "ICAO": "Australia",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 5302,
      "bar": "",
      "�װ����": "Welcome Air",
      "bar__1": "Welcome Air",
      "IATA": "2W",
      "bar__2": "WLC",
      "ICAO": "Australia",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 5243,
      "bar": "",
      "�װ����": "TUI fly Belgium",
      "bar__1": "TUI fly Belgium",
      "IATA": "TB",
      "bar__2": "JAF",
      "ICAO": "Belgium",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 5214,
      "bar": "",
      "�װ����": "Brussels Airlines",
      "bar__1": "Brussels Airlines",
      "IATA": "SN",
      "bar__2": "BEL",
      "ICAO": "Belgium",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 6979,
      "bar": "",
      "�װ����": "Corendon Dutch Airlines",
      "bar__1": "Corendon Dutch Airlines",
      "IATA": "CD",
      "bar__2": "CND",
      "ICAO": "Netherlands",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 5207,
      "bar": "",
      "�װ����": "KLM Cityhopper",
      "bar__1": "KLM Cityhopper",
      "IATA": "WA",
      "bar__2": "KLC",
      "ICAO": "Netherlands",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 5206,
      "bar": "",
      "�װ����": "Tui Airlines Nederlands",
      "bar__1": "Tui Airlines Nederlands",
      "IATA": "OR",
      "bar__2": "TFL",
      "ICAO": "Netherlands",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 5205,
      "bar": "",
      "�װ����": "Martinair Holland",
      "bar__1": "Martinair Holland",
      "IATA": "MP",
      "bar__2": "MPH",
      "ICAO": "Netherlands",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 5204,
      "bar": "",
      "�װ����": "KLM Royal Dutch Airlines",
      "bar__1": "KLM Royal Dutch Airlines",
      "IATA": "KL",
      "bar__2": "KLM",
      "ICAO": "Netherlands",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 5193,
      "bar": "",
      "�װ����": "Chc Helicopters Netherlands",
      "bar__1": "Chc Helicopters Netherlands",
      "IATA": "",
      "bar__2": "HNL",
      "ICAO": "Netherlands",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 5147,
      "bar": "",
      "�װ����": "Sun-Air Of Scandinavia",
      "bar__1": "Sun-Air Of Scandinavia",
      "IATA": "EZ",
      "bar__2": "SUS",
      "ICAO": "Denmark",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 5146,
      "bar": "",
      "�װ����": "Danish Air Transport",
      "bar__1": "Danish Air Transport",
      "IATA": "DX",
      "bar__2": "DTR",
      "ICAO": "Denmark",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 5145,
      "bar": "",
      "�װ����": "SunClass Airlines",
      "bar__1": "SunClass Airlines",
      "IATA": "DK",
      "bar__2": "VKG",
      "ICAO": "Denmark",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 5137,
      "bar": "",
      "�װ����": "Ben Air",
      "bar__1": "Ben Air",
      "IATA": "",
      "bar__2": "BDI",
      "ICAO": "Denmark",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 5130,
      "bar": "",
      "�װ����": "Jet Time",
      "bar__1": "Jet Time",
      "IATA": "",
      "bar__2": "JTG",
      "ICAO": "Denmark",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 5125,
      "bar": "",
      "�װ����": "Flexflight",
      "bar__1": "Flexflight",
      "IATA": "W2",
      "bar__2": "FXT",
      "ICAO": "Denmark",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 7084,
      "bar": "",
      "�װ����": "HOP!",
      "bar__1": "HOP!",
      "IATA": "A5",
      "bar__2": "HOP",
      "ICAO": "France",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 4950,
      "bar": "",
      "�װ����": "AIR CORSICA",
      "bar__1": "AIR CORSICA",
      "IATA": "XK",
      "bar__2": "CCM",
      "ICAO": "France",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 4949,
      "bar": "",
      "�װ����": "Air Austral",
      "bar__1": "Air Austral",
      "IATA": "UU",
      "bar__2": "REU",
      "ICAO": "France",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 4946,
      "bar": "",
      "�װ����": "Twin Jet",
      "bar__1": "Twin Jet",
      "IATA": "T7",
      "bar__2": "TJT",
      "ICAO": "France",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 4945,
      "bar": "",
      "�װ����": "CorsAir International",
      "bar__1": "CorsAir International",
      "IATA": "SS",
      "bar__2": "CRL",
      "ICAO": "France",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 4941,
      "bar": "",
      "�װ����": "Air France",
      "bar__1": "Air France",
      "IATA": "AF",
      "bar__2": "AFR",
      "ICAO": "France",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 4897,
      "bar": "",
      "�װ����": "SAF Helicopteres",
      "bar__1": "SAF Helicopteres",
      "IATA": "",
      "bar__2": "SHP",
      "ICAO": "France",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 4876,
      "bar": "",
      "�װ����": "Pan Europeenne Air Service",
      "bar__1": "Pan Europeenne Air Service",
      "IATA": "",
      "bar__2": "PEA",
      "ICAO": "France",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 4858,
      "bar": "",
      "�װ����": "Transavia France",
      "bar__1": "Transavia France",
      "IATA": "TO",
      "bar__2": "TVF",
      "ICAO": "France",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 4855,
      "bar": "",
      "�װ����": "Air Loyaute",
      "bar__1": "Air Loyaute",
      "IATA": "",
      "bar__2": "RLY",
      "ICAO": "France",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 4832,
      "bar": "",
      "�װ����": "Air Dolomiti",
      "bar__1": "Air Dolomiti",
      "IATA": "EN",
      "bar__2": "DLA",
      "ICAO": "Italy",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 4829,
      "bar": "",
      "�װ����": "Blue Panorama Airlines Spa",
      "bar__1": "Blue Panorama Airlines Spa",
      "IATA": "BV",
      "bar__2": "BPA",
      "ICAO": "Italy",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 4828,
      "bar": "",
      "�װ����": "Alitalia",
      "bar__1": "Alitalia",
      "IATA": "AZ",
      "bar__2": "AZA",
      "ICAO": "Italy",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 4819,
      "bar": "",
      "�װ����": "Neos",
      "bar__1": "Neos",
      "IATA": "NO",
      "bar__2": "NOS",
      "ICAO": "Italy",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 4812,
      "bar": "",
      "�װ����": "Alitalia CityLiner",
      "bar__1": "Alitalia CityLiner",
      "IATA": "CT",
      "bar__2": "CYL",
      "ICAO": "Italy",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 4758,
      "bar": "",
      "�װ����": "Cargolux Italia",
      "bar__1": "Cargolux Italia",
      "IATA": "C8",
      "bar__2": "ICV",
      "ICAO": "Italy",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 7021,
      "bar": "",
      "�װ����": "MHS Aviation",
      "bar__1": "MHS Aviation",
      "IATA": "M2",
      "bar__2": "MHV",
      "ICAO": "Germany",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 5097,
      "bar": "",
      "�װ����": "Lufthansa Cargo",
      "bar__1": "Lufthansa Cargo",
      "IATA": "LH",
      "bar__2": "GEC",
      "ICAO": "Germany",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 5093,
      "bar": "",
      "�װ����": "Eurowings",
      "bar__1": "Eurowings",
      "IATA": "EW",
      "bar__2": "EWG",
      "ICAO": "Germany",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 5092,
      "bar": "",
      "�װ����": "Condor Flugdienst",
      "bar__1": "Condor Flugdienst",
      "IATA": "DE",
      "bar__2": "CFG",
      "ICAO": "Germany",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 5091,
      "bar": "",
      "�װ����": "Lufthansa CityLine",
      "bar__1": "Lufthansa CityLine",
      "IATA": "CL",
      "bar__2": "CLH",
      "ICAO": "Germany",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 5044,
      "bar": "",
      "�װ����": "Night Express",
      "bar__1": "Night Express",
      "IATA": "",
      "bar__2": "EXT",
      "ICAO": "Germany",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 4987,
      "bar": "",
      "�װ����": "air-taxi europe",
      "bar__1": "air-taxi europe",
      "IATA": "",
      "bar__2": "TWG",
      "ICAO": "Germany",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 4973,
      "bar": "",
      "�װ����": "AeroLogic",
      "bar__1": "AeroLogic",
      "IATA": "3S",
      "bar__2": "BOX",
      "ICAO": "Germany",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 6948,
      "bar": "",
      "�װ����": "People's",
      "bar__1": "People's",
      "IATA": "PE",
      "bar__2": "PEV",
      "ICAO": "Switzerland",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 4357,
      "bar": "",
      "�װ����": "Edelweiss Air",
      "bar__1": "Edelweiss Air",
      "IATA": "WK",
      "bar__2": "EDW",
      "ICAO": "Switzerland",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 4346,
      "bar": "",
      "�װ����": "Air Glaciers Sa",
      "bar__1": "Air Glaciers Sa",
      "IATA": "",
      "bar__2": "AGV",
      "ICAO": "Switzerland",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 6968,
      "bar": "",
      "�װ����": "Volotea",
      "bar__1": "Volotea",
      "IATA": "V7",
      "bar__2": "VOE",
      "ICAO": "Spain",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 4735,
      "bar": "",
      "�װ����": "Vueling Airlines",
      "bar__1": "Vueling Airlines",
      "IATA": "VY",
      "bar__2": "VLG",
      "ICAO": "Spain",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 4732,
      "bar": "",
      "�װ����": "Binter Canarias",
      "bar__1": "Binter Canarias",
      "IATA": "NT",
      "bar__2": "IBB",
      "ICAO": "Spain",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 4729,
      "bar": "",
      "�װ����": "Iberia Airline",
      "bar__1": "Iberia Airline",
      "IATA": "IB",
      "bar__2": "IBE",
      "ICAO": "Spain",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 4516,
      "bar": "",
      "�װ����": "Canary Fly",
      "bar__1": "Canary Fly",
      "IATA": "PM",
      "bar__2": "CNF",
      "ICAO": "Spain",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 4512,
      "bar": "",
      "�װ����": "Bestfly",
      "bar__1": "Bestfly",
      "IATA": "",
      "bar__2": "BEY",
      "ICAO": "Spain",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 4494,
      "bar": "",
      "�װ����": "TAP Express",
      "bar__1": "TAP Express",
      "IATA": "TP",
      "bar__2": "TAP",
      "ICAO": "Portugal",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 4491,
      "bar": "",
      "�װ����": "Portugalia",
      "bar__1": "Portugalia",
      "IATA": "NI",
      "bar__2": "PGA",
      "ICAO": "Portugal",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 4489,
      "bar": "",
      "�װ����": "Orbest",
      "bar__1": "Orbest",
      "IATA": "6O",
      "bar__2": "OBS",
      "ICAO": "Portugal",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 4451,
      "bar": "",
      "�װ����": "Air Malta",
      "bar__1": "Air Malta",
      "IATA": "KM",
      "bar__2": "AMC",
      "ICAO": "Malta",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 4437,
      "bar": "",
      "�װ����": "Sky Express",
      "bar__1": "Sky Express",
      "IATA": "GQ",
      "bar__2": "SEH",
      "ICAO": "Greece",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 4436,
      "bar": "",
      "�װ����": "Olympic Air",
      "bar__1": "Olympic Air",
      "IATA": "OA",
      "bar__2": "OAL",
      "ICAO": "Greece",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 4434,
      "bar": "",
      "�װ����": "Aegean Airlines",
      "bar__1": "Aegean Airlines",
      "IATA": "A3",
      "bar__2": "AEE",
      "ICAO": "Greece",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 4431,
      "bar": "",
      "�װ����": "Olympus airways",
      "bar__1": "Olympus airways",
      "IATA": "",
      "bar__2": "OLY",
      "ICAO": "Greece",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 4414,
      "bar": "",
      "�װ����": "Blue Bird Airways",
      "bar__1": "Blue Bird Airways",
      "IATA": "BZ",
      "bar__2": "BBG",
      "ICAO": "Greece",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 4408,
      "bar": "",
      "�װ����": "Turkish Airlines",
      "bar__1": "Turkish Airlines",
      "IATA": "TK",
      "bar__2": "THY",
      "ICAO": "Turkey",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 4407,
      "bar": "",
      "�װ����": "MNG Airlines Cargo",
      "bar__1": "MNG Airlines Cargo",
      "IATA": "MB",
      "bar__2": "MNB",
      "ICAO": "Turkey",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 4404,
      "bar": "",
      "�װ����": "Onur Air",
      "bar__1": "Onur Air",
      "IATA": "8Q",
      "bar__2": "OHY",
      "ICAO": "Turkey",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 4397,
      "bar": "",
      "�װ����": "ULS Airlines Cargo",
      "bar__1": "ULS Airlines Cargo",
      "IATA": "GO",
      "bar__2": "KZU",
      "ICAO": "Turkey",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 4396,
      "bar": "",
      "�װ����": "Pegasus Airlines",
      "bar__1": "Pegasus Airlines",
      "IATA": "PC",
      "bar__2": "PGT",
      "ICAO": "Turkey",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 4381,
      "bar": "",
      "�װ����": "Tailwind airliens",
      "bar__1": "Tailwind airliens",
      "IATA": "TI",
      "bar__2": "TWI",
      "ICAO": "Turkey",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 4379,
      "bar": "",
      "�װ����": "Pan Havacilik Ve Ticaret A.S.",
      "bar__1": "Pan Havacilik Ve Ticaret A.S.",
      "IATA": "",
      "bar__2": "PHT",
      "ICAO": "Turkey",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 4377,
      "bar": "",
      "�װ����": "AnadoluJet",
      "bar__1": "AnadoluJet",
      "IATA": "TK",
      "bar__2": "THY",
      "ICAO": "Turkey",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 5396,
      "bar": "",
      "�װ����": "Air Moldova",
      "bar__1": "Air Moldova",
      "IATA": "9U",
      "bar__2": "MLD",
      "ICAO": "Moldova",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 5388,
      "bar": "",
      "�װ����": "Moldova",
      "bar__1": "Moldova",
      "IATA": "",
      "bar__2": "MVG",
      "ICAO": "Moldova",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 5386,
      "bar": "",
      "�װ����": "Valan International Cargo Charter",
      "bar__1": "Valan International Cargo Charter",
      "IATA": "",
      "bar__2": "VLN",
      "ICAO": "Moldova",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 4282,
      "bar": "",
      "�װ����": "Air Iceland connect",
      "bar__1": "Air Iceland connect",
      "IATA": "NY",
      "bar__2": "FXI",
      "ICAO": "Iceland",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 4280,
      "bar": "",
      "�װ����": "Icelandair",
      "bar__1": "Icelandair",
      "IATA": "FI",
      "bar__2": "ICE",
      "ICAO": "Iceland",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 4279,
      "bar": "",
      "�װ����": "Air Atlanta Icelandic",
      "bar__1": "Air Atlanta Icelandic",
      "IATA": "CC",
      "bar__2": "ABD",
      "ICAO": "Iceland",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 4232,
      "bar": "",
      "�װ����": "Norlandair",
      "bar__1": "Norlandair",
      "IATA": "",
      "bar__2": "FNA",
      "ICAO": "Iceland",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 4264,
      "bar": "",
      "�װ����": "Cityjet",
      "bar__1": "Cityjet",
      "IATA": "WX",
      "bar__2": "BCY",
      "ICAO": "Ireland",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 4262,
      "bar": "",
      "�װ����": "Ryanair",
      "bar__1": "Ryanair",
      "IATA": "FR",
      "bar__2": "RYR",
      "ICAO": "Ireland",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 4261,
      "bar": "",
      "�װ����": "Aer Lingus",
      "bar__1": "Aer Lingus",
      "IATA": "EI",
      "bar__2": "EIN",
      "ICAO": "Ireland",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 4226,
      "bar": "",
      "�װ����": "Fleet Air International",
      "bar__1": "Fleet Air International",
      "IATA": "",
      "bar__2": "FRF",
      "ICAO": "Hungary",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 4122,
      "bar": "",
      "�װ����": "BA Cityflyer",
      "bar__1": "BA Cityflyer",
      "IATA": "CJ",
      "bar__2": "CFE",
      "ICAO": "United Kingdom",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 4074,
      "bar": "",
      "�װ����": "Virgin Atlantic Airways",
      "bar__1": "Virgin Atlantic Airways",
      "IATA": "VS",
      "bar__2": "VIR",
      "ICAO": "United Kingdom",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 4070,
      "bar": "",
      "�װ����": "Jet2.Com",
      "bar__1": "Jet2.Com",
      "IATA": "LS",
      "bar__2": "EXS",
      "ICAO": "United Kingdom",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 4069,
      "bar": "",
      "�װ����": "Aurigny Air Services",
      "bar__1": "Aurigny Air Services",
      "IATA": "GR",
      "bar__2": "AUR",
      "ICAO": "United Kingdom",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 4061,
      "bar": "",
      "�װ����": "British Airways",
      "bar__1": "British Airways",
      "IATA": "BA",
      "bar__2": "BAW",
      "ICAO": "United Kingdom",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 4047,
      "bar": "",
      "�װ����": "Eastern Airways",
      "bar__1": "Eastern Airways",
      "IATA": "T3",
      "bar__2": "EZE",
      "ICAO": "United Kingdom",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 4046,
      "bar": "",
      "�װ����": "Easyjet Airlines",
      "bar__1": "Easyjet Airlines",
      "IATA": "U2",
      "bar__2": "EZY",
      "ICAO": "United Kingdom",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 3696,
      "bar": "",
      "�װ����": "Vi Air Link",
      "bar__1": "Vi Air Link",
      "IATA": "V6",
      "bar__2": "VIL",
      "ICAO": "United Kingdom",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 3688,
      "bar": "",
      "�װ����": "Rvl Aviation",
      "bar__1": "Rvl Aviation",
      "IATA": "",
      "bar__2": "REV",
      "ICAO": "United Kingdom",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 3674,
      "bar": "",
      "�װ����": "Hebridean Air Services",
      "bar__1": "Hebridean Air Services",
      "IATA": "",
      "bar__2": "HBR",
      "ICAO": "United Kingdom",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 3638,
      "bar": "",
      "�װ����": "Air Tindi",
      "bar__1": "Air Tindi",
      "IATA": "8T",
      "bar__2": "TID",
      "ICAO": "Canada",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 3618,
      "bar": "",
      "�װ����": "Keewatin Air",
      "bar__1": "Keewatin Air",
      "IATA": "FK",
      "bar__2": "KEW",
      "ICAO": "Canada",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 3598,
      "bar": "",
      "�װ����": "KD air",
      "bar__1": "KD air",
      "IATA": "",
      "bar__2": "KDC",
      "ICAO": "Canada",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 3597,
      "bar": "",
      "�װ����": "Westjet Airlines",
      "bar__1": "Westjet Airlines",
      "IATA": "WS",
      "bar__2": "WJA",
      "ICAO": "Canada",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 3594,
      "bar": "",
      "�װ����": "Air Transat",
      "bar__1": "Air Transat",
      "IATA": "TS",
      "bar__2": "TSC",
      "ICAO": "Canada",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 3593,
      "bar": "",
      "�װ����": "Jazz",
      "bar__1": "Jazz",
      "IATA": "QK",
      "bar__2": "JZA",
      "ICAO": "Canada",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 3592,
      "bar": "",
      "�װ����": "Porter Airlines",
      "bar__1": "Porter Airlines",
      "IATA": "PD",
      "bar__2": "POE",
      "ICAO": "Canada",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 3588,
      "bar": "",
      "�װ����": "Bearskin Airlines",
      "bar__1": "Bearskin Airlines",
      "IATA": "JV",
      "bar__2": "BLS",
      "ICAO": "Canada",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 3586,
      "bar": "",
      "�װ����": "Northwestern Air Lease",
      "bar__1": "Northwestern Air Lease",
      "IATA": "J3",
      "bar__2": "PLR",
      "ICAO": "Canada",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 3583,
      "bar": "",
      "�װ����": "Air Canada",
      "bar__1": "Air Canada",
      "IATA": "AC",
      "bar__2": "ACA",
      "ICAO": "Canada",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 3581,
      "bar": "",
      "�װ����": "Pacific Coastal Airline",
      "bar__1": "Pacific Coastal Airline",
      "IATA": "8P",
      "bar__2": "PCO",
      "ICAO": "Canada",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 3576,
      "bar": "",
      "�װ����": "Air Inuit",
      "bar__1": "Air Inuit",
      "IATA": "3H",
      "bar__2": "AIE",
      "ICAO": "Canada",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 3573,
      "bar": "",
      "�װ����": "Air North",
      "bar__1": "Air North",
      "IATA": "4N",
      "bar__2": "ANT",
      "ICAO": "Canada",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 3571,
      "bar": "",
      "�װ����": "KF Aerospace",
      "bar__1": "KF Aerospace",
      "IATA": "FK",
      "bar__2": "KFA",
      "ICAO": "Canada",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 3555,
      "bar": "",
      "�װ����": "Air Nunavut",
      "bar__1": "Air Nunavut",
      "IATA": "",
      "bar__2": "BFF",
      "ICAO": "Canada",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 3522,
      "bar": "",
      "�װ����": "North Cariboo Air",
      "bar__1": "North Cariboo Air",
      "IATA": "",
      "bar__2": "NCB",
      "ICAO": "Canada",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 3519,
      "bar": "",
      "�װ����": "Nolinor Aviation",
      "bar__1": "Nolinor Aviation",
      "IATA": "N5",
      "bar__2": "NRL",
      "ICAO": "Canada",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 3508,
      "bar": "",
      "�װ����": "Morningstar Air express",
      "bar__1": "Morningstar Air express",
      "IATA": "",
      "bar__2": "MAL",
      "ICAO": "Canada",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 3502,
      "bar": "",
      "�װ����": "FIRST AIR",
      "bar__1": "FIRST AIR",
      "IATA": "7F",
      "bar__2": "FAB",
      "ICAO": "Canada",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 3485,
      "bar": "",
      "�װ����": "Skylink Express",
      "bar__1": "Skylink Express",
      "IATA": "",
      "bar__2": "SLQ",
      "ICAO": "Canada",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 3462,
      "bar": "",
      "�װ����": "West Wind Aviation",
      "bar__1": "West Wind Aviation",
      "IATA": "",
      "bar__2": "WEW",
      "ICAO": "Canada",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 3417,
      "bar": "",
      "�װ����": "Starlink Aviation",
      "bar__1": "Starlink Aviation",
      "IATA": "Q4",
      "bar__2": "TLK",
      "ICAO": "Canada",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 3416,
      "bar": "",
      "�װ����": "Skyservice Business Aviation",
      "bar__1": "Skyservice Business Aviation",
      "IATA": "",
      "bar__2": "SYB",
      "ICAO": "Canada",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 3412,
      "bar": "",
      "�װ����": "Northern Air",
      "bar__1": "Northern Air",
      "IATA": "",
      "bar__2": "NLI",
      "ICAO": "Canada",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 3407,
      "bar": "",
      "�װ����": "CHC Global Operations Canada",
      "bar__1": "CHC Global Operations Canada",
      "IATA": "",
      "bar__2": "HMB",
      "ICAO": "Canada",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 3405,
      "bar": "",
      "�װ����": "Enerjet",
      "bar__1": "Enerjet",
      "IATA": "",
      "bar__2": "ENJ",
      "ICAO": "Canada",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 7072,
      "bar": "",
      "�װ����": "Boutique Air",
      "bar__1": "Boutique Air",
      "IATA": "4B",
      "bar__2": "BTQ",
      "ICAO": "United States",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 7054,
      "bar": "",
      "�װ����": "Sunsplash Aviation",
      "bar__1": "Sunsplash Aviation",
      "IATA": "YH",
      "bar__2": "",
      "ICAO": "United States",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 7019,
      "bar": "",
      "�װ����": "Exec Airof Naples",
      "bar__1": "Exec Airof Naples",
      "IATA": "X7",
      "bar__2": "",
      "ICAO": "United States",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 6992,
      "bar": "",
      "�װ����": "Air Excursions",
      "bar__1": "Air Excursions",
      "IATA": "X4",
      "bar__2": "",
      "ICAO": "United States",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 3398,
      "bar": "",
      "�װ����": "Star Air Cargo",
      "bar__1": "Star Air Cargo",
      "IATA": "",
      "bar__2": "BRH",
      "ICAO": "South Africa",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 3395,
      "bar": "",
      "�װ����": "Harbour Air",
      "bar__1": "Harbour Air",
      "IATA": "YB",
      "bar__2": "",
      "ICAO": "Malta",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 3391,
      "bar": "",
      "�װ����": "Rainbow Air",
      "bar__1": "Rainbow Air",
      "IATA": "",
      "bar__2": "TZR",
      "ICAO": "United States",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 3386,
      "bar": "",
      "�װ����": "Reliant Air Charter",
      "bar__1": "Reliant Air Charter",
      "IATA": "",
      "bar__2": "RLI",
      "ICAO": "United States",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 3371,
      "bar": "",
      "�װ����": "Katmai Air",
      "bar__1": "Katmai Air",
      "IATA": "KT",
      "bar__2": "",
      "ICAO": "United States",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 3359,
      "bar": "",
      "�װ����": "Publiccharters.com",
      "bar__1": "Publiccharters.com",
      "IATA": "P1",
      "bar__2": "",
      "ICAO": "United States",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 3349,
      "bar": "",
      "�װ����": "Papillon Airways",
      "bar__1": "Papillon Airways",
      "IATA": "HI",
      "bar__2": "",
      "ICAO": "United States",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 3347,
      "bar": "",
      "�װ����": "Pacific Airways",
      "bar__1": "Pacific Airways",
      "IATA": "3F",
      "bar__2": "",
      "ICAO": "United States",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 3345,
      "bar": "",
      "�װ����": "Premier Trans Aire",
      "bar__1": "Premier Trans Aire",
      "IATA": "3X",
      "bar__2": "",
      "ICAO": "United States",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 3324,
      "bar": "",
      "�װ����": "Smokey Bay Air",
      "bar__1": "Smokey Bay Air",
      "IATA": "2E",
      "bar__2": "",
      "ICAO": "United States",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 3288,
      "bar": "",
      "�װ����": "Scenic Airlines",
      "bar__1": "Scenic Airlines",
      "IATA": "YR",
      "bar__2": "SCE",
      "ICAO": "United States",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 3277,
      "bar": "",
      "�װ����": "Air Wisconsin",
      "bar__1": "Air Wisconsin",
      "IATA": "ZW",
      "bar__2": "AWI",
      "ICAO": "United States",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 3273,
      "bar": "",
      "�װ����": "Mesa Airlines",
      "bar__1": "Mesa Airlines",
      "IATA": "YV",
      "bar__2": "ASH",
      "ICAO": "United States",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 3272,
      "bar": "",
      "�װ����": "Air Sunshine",
      "bar__1": "Air Sunshine",
      "IATA": "YI",
      "bar__2": "RSI",
      "ICAO": "United States",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 3265,
      "bar": "",
      "�װ����": "Southwest Airlines",
      "bar__1": "Southwest Airlines",
      "IATA": "WN",
      "bar__2": "SWA",
      "ICAO": "United States",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 3260,
      "bar": "",
      "�װ����": "United Airlines",
      "bar__1": "United Airlines",
      "IATA": "UA",
      "bar__2": "UAL",
      "ICAO": "United States",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 3255,
      "bar": "",
      "�װ����": "Horizon Air",
      "bar__1": "Horizon Air",
      "IATA": "QX",
      "bar__2": "QXE",
      "ICAO": "United States",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 3241,
      "bar": "",
      "�װ����": "Alaska Central Express",
      "bar__1": "Alaska Central Express",
      "IATA": "",
      "bar__2": "AER",
      "ICAO": "United States",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 3236,
      "bar": "",
      "�װ����": "Hawaiian Airlines",
      "bar__1": "Hawaiian Airlines",
      "IATA": "HA",
      "bar__2": "HAL",
      "ICAO": "United States",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 3235,
      "bar": "",
      "�װ����": "Gojet Airlines",
      "bar__1": "Gojet Airlines",
      "IATA": "G7",
      "bar__2": "GJS",
      "ICAO": "United States",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 3233,
      "bar": "",
      "�װ����": "Frontier Airlines",
      "bar__1": "Frontier Airlines",
      "IATA": "F9",
      "bar__2": "FFT",
      "ICAO": "United States",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 3231,
      "bar": "",
      "�װ����": "ExpressJet Airlines",
      "bar__1": "ExpressJet Airlines",
      "IATA": "EV",
      "bar__2": "ASQ",
      "ICAO": "United States",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 3229,
      "bar": "",
      "�װ����": "New England Airlines",
      "bar__1": "New England Airlines",
      "IATA": "EJ",
      "bar__2": "NEA",
      "ICAO": "United States",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 3228,
      "bar": "",
      "�װ����": "Delta Air Lines",
      "bar__1": "Delta Air Lines",
      "IATA": "DL",
      "bar__2": "DAL",
      "ICAO": "United States",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 3226,
      "bar": "",
      "�װ����": "Bemidji Airlines",
      "bar__1": "Bemidji Airlines",
      "IATA": "CH",
      "bar__2": "BMJ",
      "ICAO": "United States",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 3224,
      "bar": "",
      "�װ����": "Jetblue Airways",
      "bar__1": "Jetblue Airways",
      "IATA": "B6",
      "bar__2": "JBU",
      "ICAO": "United States",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 3221,
      "bar": "",
      "�װ����": "Alaska Airlines",
      "bar__1": "Alaska Airlines",
      "IATA": "AS",
      "bar__2": "ASA",
      "ICAO": "United States",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 3220,
      "bar": "",
      "�װ����": "American Airlines",
      "bar__1": "American Airlines",
      "IATA": "AA",
      "bar__2": "AAL",
      "ICAO": "United States",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 3217,
      "bar": "",
      "�װ����": "Cape Air",
      "bar__1": "Cape Air",
      "IATA": "9K",
      "bar__2": "KAP",
      "ICAO": "United States",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 3216,
      "bar": "",
      "�װ����": "Endeavor Air",
      "bar__1": "Endeavor Air",
      "IATA": "9E",
      "bar__2": "EDV",
      "ICAO": "United States",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 3215,
      "bar": "",
      "�װ����": "Bering Air",
      "bar__1": "Bering Air",
      "IATA": "8E",
      "bar__2": "BRG",
      "ICAO": "United States",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 3206,
      "bar": "",
      "�װ����": "Air Cargo Carriers",
      "bar__1": "Air Cargo Carriers",
      "IATA": "2Q",
      "bar__2": "SNC",
      "ICAO": "United States",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 3198,
      "bar": "",
      "�װ����": "Allegiant Air",
      "bar__1": "Allegiant Air",
      "IATA": "G4",
      "bar__2": "AAY",
      "ICAO": "United States",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 3193,
      "bar": "",
      "�װ����": "Atlas Air",
      "bar__1": "Atlas Air",
      "IATA": "5Y",
      "bar__2": "GTI",
      "ICAO": "United States",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 3185,
      "bar": "",
      "�װ����": "Compass Airlines",
      "bar__1": "Compass Airlines",
      "IATA": "CP",
      "bar__2": "CPZ",
      "ICAO": "United States",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 3170,
      "bar": "",
      "�װ����": "Grant Aviation",
      "bar__1": "Grant Aviation",
      "IATA": "GV",
      "bar__2": "GUN",
      "ICAO": "United States",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 3165,
      "bar": "",
      "�װ����": "Kenmore Air Harbor",
      "bar__1": "Kenmore Air Harbor",
      "IATA": "M5",
      "bar__2": "KEN",
      "ICAO": "United States",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 3151,
      "bar": "",
      "�װ����": "Northern Air Cargo",
      "bar__1": "Northern Air Cargo",
      "IATA": "NC",
      "bar__2": "NAC",
      "ICAO": "United States",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 3149,
      "bar": "",
      "�װ����": "Omni Air International",
      "bar__1": "Omni Air International",
      "IATA": "OY",
      "bar__2": "OAE",
      "ICAO": "United States",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 3145,
      "bar": "",
      "�װ����": "Piedmont Airlines",
      "bar__1": "Piedmont Airlines",
      "IATA": "PT",
      "bar__2": "PDT",
      "ICAO": "United States",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 3140,
      "bar": "",
      "�װ����": "Republic Airlines",
      "bar__1": "Republic Airlines",
      "IATA": "YX",
      "bar__2": "RPA",
      "ICAO": "United States",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 3133,
      "bar": "",
      "�װ����": "Spirit Airlines",
      "bar__1": "Spirit Airlines",
      "IATA": "NK",
      "bar__2": "NKS",
      "ICAO": "United States",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 3056,
      "bar": "",
      "�װ����": "Airlift Alaska",
      "bar__1": "Airlift Alaska",
      "IATA": "K2",
      "bar__2": "",
      "ICAO": "United States",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 2934,
      "bar": "",
      "�װ����": "North Star Air Cargo",
      "bar__1": "North Star Air Cargo",
      "IATA": "",
      "bar__2": "SBX",
      "ICAO": "United States",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 2888,
      "bar": "",
      "�װ����": "Ryan Air Services",
      "bar__1": "Ryan Air Services",
      "IATA": "7S",
      "bar__2": "RYA",
      "ICAO": "United States",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 2818,
      "bar": "",
      "�װ����": "Martinaire",
      "bar__1": "Martinaire",
      "IATA": "",
      "bar__2": "MRA",
      "ICAO": "United States",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 2727,
      "bar": "",
      "�װ����": "Bighorn Airways",
      "bar__1": "Bighorn Airways",
      "IATA": "",
      "bar__2": "BHR",
      "ICAO": "United States",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 2723,
      "bar": "",
      "�װ����": "Southeast Air",
      "bar__1": "Southeast Air",
      "IATA": "",
      "bar__2": "SEA",
      "ICAO": "United States",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 2580,
      "bar": "",
      "�װ����": "Winair",
      "bar__1": "Winair",
      "IATA": "WM",
      "bar__2": "WIA",
      "ICAO": "Netherlands",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 2485,
      "bar": "",
      "�װ����": "Commutair",
      "bar__1": "Commutair",
      "IATA": "C5",
      "bar__2": "UCA",
      "ICAO": "United States",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 2464,
      "bar": "",
      "�װ����": "Conquest Air Cargo",
      "bar__1": "Conquest Air Cargo",
      "IATA": "C4",
      "bar__2": "QAI",
      "ICAO": "United States",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 2314,
      "bar": "",
      "�װ����": "Pearson Aviation Corporation D/B/A Pac Air",
      "bar__1": "Pearson Aviation Corporation D/B/A Pac Air",
      "IATA": "",
      "bar__2": "PCR",
      "ICAO": "United States",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 2291,
      "bar": "",
      "�װ����": "World Atlantic Airlines",
      "bar__1": "World Atlantic Airlines",
      "IATA": "WL",
      "bar__2": "WAL",
      "ICAO": "United States",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 2250,
      "bar": "",
      "�װ����": "Desert Jet",
      "bar__1": "Desert Jet",
      "IATA": "",
      "bar__2": "DJR",
      "ICAO": "United States",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 3283,
      "bar": "",
      "�װ����": "National Airlines",
      "bar__1": "National Airlines",
      "IATA": "N8",
      "bar__2": "NCR",
      "ICAO": "United States",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 2227,
      "bar": "",
      "�װ����": "Locair",
      "bar__1": "Locair",
      "IATA": "",
      "bar__2": "LOC",
      "ICAO": "United States",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 2155,
      "bar": "",
      "�װ����": "Volaris",
      "bar__1": "Volaris",
      "IATA": "Y4",
      "bar__2": "VOI",
      "ICAO": "Mexico",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 2154,
      "bar": "",
      "�װ����": "Aeromar",
      "bar__1": "Aeromar",
      "IATA": "VW",
      "bar__2": "TAO",
      "ICAO": "Mexico",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 2150,
      "bar": "",
      "�װ����": "Mas air",
      "bar__1": "Mas air",
      "IATA": "M7",
      "bar__2": "MAA",
      "ICAO": "Mexico",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 2149,
      "bar": "",
      "�װ����": "Aeromexico",
      "bar__1": "Aeromexico",
      "IATA": "AM",
      "bar__2": "AMX",
      "ICAO": "Mexico",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 2148,
      "bar": "",
      "�װ����": "Aerounion",
      "bar__1": "Aerounion",
      "IATA": "6R",
      "bar__2": "TNO",
      "ICAO": "Mexico",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 2146,
      "bar": "",
      "�װ����": "Aeromexico Connect",
      "bar__1": "Aeromexico Connect",
      "IATA": "5D",
      "bar__2": "SLI",
      "ICAO": "Mexico",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 1724,
      "bar": "",
      "�װ����": "Interjet",
      "bar__1": "Interjet",
      "IATA": "4O",
      "bar__2": "AIJ",
      "ICAO": "Mexico",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 1716,
      "bar": "",
      "�װ����": "Transportes Aereos Terrestres",
      "bar__1": "Transportes Aereos Terrestres",
      "IATA": "",
      "bar__2": "TRX",
      "ICAO": "Mexico",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 1644,
      "bar": "",
      "�װ����": "Maya Island Air",
      "bar__1": "Maya Island Air",
      "IATA": "MY",
      "bar__2": "MYD",
      "ICAO": "Belize",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 1643,
      "bar": "",
      "�װ����": "Tropic Air",
      "bar__1": "Tropic Air",
      "IATA": "9N",
      "bar__2": "TOS",
      "ICAO": "Belize",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 1618,
      "bar": "",
      "�װ����": "Avianca El Salvador",
      "bar__1": "Avianca El Salvador",
      "IATA": "TA",
      "bar__2": "TAI",
      "ICAO": "El Salvador",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 1600,
      "bar": "",
      "�װ����": "Cubana de Aviacion",
      "bar__1": "Cubana de Aviacion",
      "IATA": "CU",
      "bar__2": "CUB",
      "ICAO": "Cuba",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 1596,
      "bar": "",
      "�װ����": "Cayman Airways",
      "bar__1": "Cayman Airways",
      "IATA": "KX",
      "bar__2": "CAY",
      "ICAO": "Cayman Islands",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 1589,
      "bar": "",
      "�װ����": "Bahamasair",
      "bar__1": "Bahamasair",
      "IATA": "UP",
      "bar__2": "BHS",
      "ICAO": "Bahamas",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 1588,
      "bar": "",
      "�װ����": "Southern Air Charter",
      "bar__1": "Southern Air Charter",
      "IATA": "PL",
      "bar__2": "SOA",
      "ICAO": "Bahamas",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 1575,
      "bar": "",
      "�װ����": "interCaribbean Airways",
      "bar__1": "interCaribbean Airways",
      "IATA": "JY",
      "bar__2": "IWY",
      "ICAO": "Turks and Caicos Islands",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 7075,
      "bar": "",
      "�װ����": "Sunrise Airways",
      "bar__1": "Sunrise Airways",
      "IATA": "S6",
      "bar__2": "KSZ",
      "ICAO": "Haiti",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 1520,
      "bar": "",
      "�װ����": "Air Century",
      "bar__1": "Air Century",
      "IATA": "Y2",
      "bar__2": "CEY",
      "ICAO": "Dominican Republic",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 1504,
      "bar": "",
      "�װ����": "Air Caraibes",
      "bar__1": "Air Caraibes",
      "IATA": "TX",
      "bar__2": "FWI",
      "ICAO": "Guadeloupe",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 1497,
      "bar": "",
      "�װ����": "Divi Divi Air",
      "bar__1": "Divi Divi Air",
      "IATA": "",
      "bar__2": "DVR",
      "ICAO": "Netherlands Antilles",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 1640,
      "bar": "",
      "�װ����": "Avianca Honduras",
      "bar__1": "Avianca Honduras",
      "IATA": "WC",
      "bar__2": "ISV",
      "ICAO": "Honduras",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 1624,
      "bar": "",
      "�װ����": "Avianca Guatemala",
      "bar__1": "Avianca Guatemala",
      "IATA": "GU",
      "bar__2": "GUG",
      "ICAO": "Guatemala",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 1621,
      "bar": "",
      "�װ����": "Transportes Aereos Guatemaltecos",
      "bar__1": "Transportes Aereos Guatemaltecos",
      "IATA": "5U",
      "bar__2": "TGU",
      "ICAO": "Guatemala",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 1519,
      "bar": "",
      "�װ����": "Anguilla Air Services",
      "bar__1": "Anguilla Air Services",
      "IATA": "Q3",
      "bar__2": "AXL",
      "ICAO": "Anguilla",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 1518,
      "bar": "",
      "�װ����": "Coastal Air Transport",
      "bar__1": "Coastal Air Transport",
      "IATA": "DQ",
      "bar__2": "TCL",
      "ICAO": "Virgin Islands, US",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 1517,
      "bar": "",
      "�װ����": "Seaborne Airlines",
      "bar__1": "Seaborne Airlines",
      "IATA": "BB",
      "bar__2": "SBS",
      "ICAO": "Virgin Islands, US",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 1208,
      "bar": "",
      "�װ����": "Laparkan Airways",
      "bar__1": "Laparkan Airways",
      "IATA": "LE",
      "bar__2": "",
      "ICAO": "Guyana",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 1491,
      "bar": "",
      "�װ����": "Aruba Airlines",
      "bar__1": "Aruba Airlines",
      "IATA": "AG",
      "bar__2": "ARU",
      "ICAO": "Aruba",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 1487,
      "bar": "",
      "�װ����": "Caribbean Airlines",
      "bar__1": "Caribbean Airlines",
      "IATA": "BW",
      "bar__2": "BWA",
      "ICAO": "Trinidad and Tobago",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 1482,
      "bar": "",
      "�װ����": "Copa Airlines",
      "bar__1": "Copa Airlines",
      "IATA": "CM",
      "bar__2": "CMP",
      "ICAO": "Panama",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 6986,
      "bar": "",
      "�װ����": "Estelar Latinoamerica",
      "bar__1": "Estelar Latinoamerica",
      "IATA": "",
      "bar__2": "ETR",
      "ICAO": "Venezuela",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 1473,
      "bar": "",
      "�װ����": "Vensecar Internacional",
      "bar__1": "Vensecar Internacional",
      "IATA": "V4",
      "bar__2": "VEC",
      "ICAO": "Venezuela",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 1470,
      "bar": "",
      "�װ����": "LASER",
      "bar__1": "LASER",
      "IATA": "QL",
      "bar__2": "LER",
      "ICAO": "Venezuela",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 1467,
      "bar": "",
      "�װ����": "CONVIASA",
      "bar__1": "CONVIASA",
      "IATA": "V0",
      "bar__2": "VCV",
      "ICAO": "Venezuela",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 1466,
      "bar": "",
      "�װ����": "Aeropostal",
      "bar__1": "Aeropostal",
      "IATA": "VH",
      "bar__2": "ALV",
      "ICAO": "Venezuela",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 1449,
      "bar": "",
      "�װ����": "Aerotecnica",
      "bar__1": "Aerotecnica",
      "IATA": "",
      "bar__2": "DUG",
      "ICAO": "Venezuela",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 6969,
      "bar": "",
      "�װ����": "Viva Colombia",
      "bar__1": "Viva Colombia",
      "IATA": "VH",
      "bar__2": "VVC",
      "ICAO": "Colombia",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 1436,
      "bar": "",
      "�װ����": "SATENA",
      "bar__1": "SATENA",
      "IATA": "9R",
      "bar__2": "NSE",
      "ICAO": "Colombia",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 1435,
      "bar": "",
      "�װ����": "Copa Airlines Colombia",
      "bar__1": "Copa Airlines Colombia",
      "IATA": "P5",
      "bar__2": "RPB",
      "ICAO": "Colombia",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 1433,
      "bar": "",
      "�װ����": "Avianca",
      "bar__1": "Avianca",
      "IATA": "AV",
      "bar__2": "AVA",
      "ICAO": "Colombia",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 1416,
      "bar": "",
      "�װ����": "Lineas Aereas Suramericanas",
      "bar__1": "Lineas Aereas Suramericanas",
      "IATA": "4L",
      "bar__2": "LAU",
      "ICAO": "Colombia",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 1404,
      "bar": "",
      "�װ����": "Easyfly",
      "bar__1": "Easyfly",
      "IATA": "VE",
      "bar__2": "EFY",
      "ICAO": "Colombia",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 1394,
      "bar": "",
      "�װ����": "DHL Ecuador",
      "bar__1": "DHL Ecuador",
      "IATA": "7T",
      "bar__2": "RTM",
      "ICAO": "Ecuador",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 1360,
      "bar": "",
      "�װ����": "Latam Cargo Brasil",
      "bar__1": "Latam Cargo Brasil",
      "IATA": "M3",
      "bar__2": "LTG",
      "ICAO": "Brazil",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 1356,
      "bar": "",
      "�װ����": "GOL Intelligent Airlines",
      "bar__1": "GOL Intelligent Airlines",
      "IATA": "G3",
      "bar__2": "GLO",
      "ICAO": "Brazil",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 1323,
      "bar": "",
      "�װ����": "Azul Brazilian Airline",
      "bar__1": "Azul Brazilian Airline",
      "IATA": "AD",
      "bar__2": "AZU",
      "ICAO": "Brazil",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 1318,
      "bar": "",
      "�װ����": "Azul Connecta",
      "bar__1": "Azul Connecta",
      "IATA": "2F",
      "bar__2": "OWT",
      "ICAO": "Brazil",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 1304,
      "bar": "",
      "�װ����": "Avianca Peru",
      "bar__1": "Avianca Peru",
      "IATA": "T0",
      "bar__2": "IPU",
      "ICAO": "Peru",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 1292,
      "bar": "",
      "�װ����": "Aerolineas Argentinas",
      "bar__1": "Aerolineas Argentinas",
      "IATA": "AR",
      "bar__2": "ARG",
      "ICAO": "Argentina",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 7050,
      "bar": "",
      "�װ����": "Boliviana de Aviacion",
      "bar__1": "Boliviana de Aviacion",
      "IATA": "OB",
      "bar__2": "BOV",
      "ICAO": "Bolivia",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 1232,
      "bar": "",
      "�װ����": "Amaszonas",
      "bar__1": "Amaszonas",
      "IATA": "Z8",
      "bar__2": "AZN",
      "ICAO": "Bolivia",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 1220,
      "bar": "",
      "�װ����": "Surinam Airways",
      "bar__1": "Surinam Airways",
      "IATA": "PY",
      "bar__2": "SLM",
      "ICAO": "Suriname",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 6946,
      "bar": "",
      "�װ����": "Sol del Paraguay Lineas Aereas",
      "bar__1": "Sol del Paraguay Lineas Aereas",
      "IATA": "",
      "bar__2": "SGU",
      "ICAO": "Paraguay",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 1212,
      "bar": "",
      "�װ����": "TAM Airlines Paraguay",
      "bar__1": "TAM Airlines Paraguay",
      "IATA": "PZ",
      "bar__2": "LAP",
      "ICAO": "Paraguay",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 6479,
      "bar": "",
      "�װ����": "Vision Air International",
      "bar__1": "Vision Air International",
      "IATA": "",
      "bar__2": "VIS",
      "ICAO": "Pakistan",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 6476,
      "bar": "",
      "�װ����": "Pakistan International Airlines Corporation",
      "bar__1": "Pakistan International Airlines Corporation",
      "IATA": "PK",
      "bar__2": "PIA",
      "ICAO": "Pakistan",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 6475,
      "bar": "",
      "�װ����": "Shaheen Air International",
      "bar__1": "Shaheen Air International",
      "IATA": "NL",
      "bar__2": "SAI",
      "ICAO": "Pakistan",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 6473,
      "bar": "",
      "�װ����": "Airblue",
      "bar__1": "Airblue",
      "IATA": "PA",
      "bar__2": "ABQ",
      "ICAO": "Pakistan",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 6472,
      "bar": "",
      "�װ����": "Askari Aviation",
      "bar__1": "Askari Aviation",
      "IATA": "4K",
      "bar__2": "AAS",
      "ICAO": "Pakistan",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 6442,
      "bar": "",
      "�װ����": "Air Eagle",
      "bar__1": "Air Eagle",
      "IATA": "",
      "bar__2": "EGA",
      "ICAO": "Pakistan",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 1176,
      "bar": "",
      "�װ����": "Ariana Afghan Airlines",
      "bar__1": "Ariana Afghan Airlines",
      "IATA": "FG",
      "bar__2": "AFG",
      "ICAO": "Afghanistan",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 1174,
      "bar": "",
      "�װ����": "Kam Air",
      "bar__1": "Kam Air",
      "IATA": "RQ",
      "bar__2": "KMF",
      "ICAO": "Afghanistan",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 1168,
      "bar": "",
      "�װ����": "Kabul Air",
      "bar__1": "Kabul Air",
      "IATA": "",
      "bar__2": "KBL",
      "ICAO": "Afghanistan",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 1164,
      "bar": "",
      "�װ����": "Kish Air",
      "bar__1": "Kish Air",
      "IATA": "Y9",
      "bar__2": "IRK",
      "ICAO": "Iran",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 1163,
      "bar": "",
      "�װ����": "Mahan Air",
      "bar__1": "Mahan Air",
      "IATA": "W5",
      "bar__2": "IRM",
      "ICAO": "Iran",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 1162,
      "bar": "",
      "�װ����": "Caspian Airlines",
      "bar__1": "Caspian Airlines",
      "IATA": "RV",
      "bar__2": "CPN",
      "ICAO": "Iran",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 1160,
      "bar": "",
      "�װ����": "Iran Air",
      "bar__1": "Iran Air",
      "IATA": "IR",
      "bar__2": "IRA",
      "ICAO": "Iran",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 1159,
      "bar": "",
      "�װ����": "Iran Aseman Airline",
      "bar__1": "Iran Aseman Airline",
      "IATA": "EP",
      "bar__2": "IRC",
      "ICAO": "Iran",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 1142,
      "bar": "",
      "�װ����": "Qeshm Air",
      "bar__1": "Qeshm Air",
      "IATA": "QB",
      "bar__2": "QSM",
      "ICAO": "Iran",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 1139,
      "bar": "",
      "�װ����": "Taban Air",
      "bar__1": "Taban Air",
      "IATA": "HH",
      "bar__2": "TBN",
      "ICAO": "Iran",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 1137,
      "bar": "",
      "�װ����": "Tehran Airline",
      "bar__1": "Tehran Airline",
      "IATA": "",
      "bar__2": "THR",
      "ICAO": "Iran",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 1134,
      "bar": "",
      "�װ����": "Meraj Airlines",
      "bar__1": "Meraj Airlines",
      "IATA": "JI",
      "bar__2": "MRJ",
      "ICAO": "Iran",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 1133,
      "bar": "",
      "�װ����": "ATA Airlines",
      "bar__1": "ATA Airlines",
      "IATA": "I3",
      "bar__2": "TBZ",
      "ICAO": "Iran",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 1131,
      "bar": "",
      "�װ����": "Yas Air Wsh",
      "bar__1": "Yas Air Wsh",
      "IATA": "",
      "bar__2": "MHD",
      "ICAO": "Iran",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 1130,
      "bar": "",
      "�װ����": "Sahand Airlines",
      "bar__1": "Sahand Airlines",
      "IATA": "",
      "bar__2": "IRS",
      "ICAO": "Iran",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 1128,
      "bar": "",
      "�װ����": "Kuwait Airways Corporation",
      "bar__1": "Kuwait Airways Corporation",
      "IATA": "KU",
      "bar__2": "KAC",
      "ICAO": "Kuwait",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 1127,
      "bar": "",
      "�װ����": "Jazeera Airways",
      "bar__1": "Jazeera Airways",
      "IATA": "J9",
      "bar__2": "JZR",
      "ICAO": "Kuwait",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 1123,
      "bar": "",
      "�װ����": "Iraqi Airways",
      "bar__1": "Iraqi Airways",
      "IATA": "IA",
      "bar__2": "IAW",
      "ICAO": "Iraq",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 1121,
      "bar": "",
      "�װ����": "Cham Wings Airlines",
      "bar__1": "Cham Wings Airlines",
      "IATA": "6Q",
      "bar__2": "SAW",
      "ICAO": "Syria",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 1115,
      "bar": "",
      "�װ����": "Middle East Airlines - Airliban",
      "bar__1": "Middle East Airlines - Airliban",
      "IATA": "ME",
      "bar__2": "MEA",
      "ICAO": "Lebanon",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 1095,
      "bar": "",
      "�װ����": "El Al",
      "bar__1": "El Al",
      "IATA": "LY",
      "bar__2": "ELY",
      "ICAO": "Israel",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 1094,
      "bar": "",
      "�װ����": "Arkia Israel Inland Airlines",
      "bar__1": "Arkia Israel Inland Airlines",
      "IATA": "IZ",
      "bar__2": "AIZ",
      "ICAO": "Israel",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 1093,
      "bar": "",
      "�װ����": "Israir",
      "bar__1": "Israir",
      "IATA": "6H",
      "bar__2": "ISR",
      "ICAO": "Israel",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 1092,
      "bar": "",
      "�װ����": "CAL Cargo Airlines",
      "bar__1": "CAL Cargo Airlines",
      "IATA": "5C",
      "bar__2": "ICL",
      "ICAO": "Israel",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 1091,
      "bar": "",
      "�װ����": "Sun d'Or International Airlines",
      "bar__1": "Sun d'Or International Airlines",
      "IATA": "LY",
      "bar__2": "ERO",
      "ICAO": "Israel",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 1065,
      "bar": "",
      "�װ����": "Palestinian Airlines",
      "bar__1": "Palestinian Airlines",
      "IATA": "PF",
      "bar__2": "PNW",
      "ICAO": "Egypt",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 1062,
      "bar": "",
      "�װ����": "Royal Jordanian",
      "bar__1": "Royal Jordanian",
      "IATA": "RJ",
      "bar__2": "RJA",
      "ICAO": "Jordan",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 1052,
      "bar": "",
      "�װ����": "Transworld Air freighters",
      "bar__1": "Transworld Air freighters",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Jordan",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 1051,
      "bar": "",
      "�װ����": "Oman Air",
      "bar__1": "Oman Air",
      "IATA": "WY",
      "bar__2": "OMA",
      "ICAO": "Oman",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 1044,
      "bar": "",
      "�װ����": "Saudia Airlines",
      "bar__1": "Saudia Airlines",
      "IATA": "SV",
      "bar__2": "SVA",
      "ICAO": "Saudi Arabia",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 1042,
      "bar": "",
      "�װ����": "Flynas",
      "bar__1": "Flynas",
      "IATA": "XY",
      "bar__2": "KNE",
      "ICAO": "Saudi Arabia",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 7041,
      "bar": "",
      "�װ����": "AirGlow Aviation Services",
      "bar__1": "AirGlow Aviation Services",
      "IATA": "GL",
      "bar__2": "",
      "ICAO": "United Arab Emirates",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 1033,
      "bar": "",
      "�װ����": "Empire Aviation Group",
      "bar__1": "Empire Aviation Group",
      "IATA": "",
      "bar__2": "MJE",
      "ICAO": "United Arab Emirates",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 1031,
      "bar": "",
      "�װ����": "Daallo Airlines",
      "bar__1": "Daallo Airlines",
      "IATA": "D3",
      "bar__2": "DAO",
      "ICAO": "United Arab Emirates",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 1022,
      "bar": "",
      "�װ����": "Air Arabia",
      "bar__1": "Air Arabia",
      "IATA": "G9",
      "bar__2": "ABY",
      "ICAO": "United Arab Emirates",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 1021,
      "bar": "",
      "�װ����": "Etihad Airways",
      "bar__1": "Etihad Airways",
      "IATA": "EY",
      "bar__2": "ETD",
      "ICAO": "United Arab Emirates",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 1020,
      "bar": "",
      "�װ����": "Emirates Airline",
      "bar__1": "Emirates Airline",
      "IATA": "EK",
      "bar__2": "UAE",
      "ICAO": "United Arab Emirates",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 996,
      "bar": "",
      "�װ����": "Flydubai",
      "bar__1": "Flydubai",
      "IATA": "FZ",
      "bar__2": "FDB",
      "ICAO": "United Arab Emirates",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 992,
      "bar": "",
      "�װ����": "Rotana Jet Aviation",
      "bar__1": "Rotana Jet Aviation",
      "IATA": "RG",
      "bar__2": "RJD",
      "ICAO": "United Arab Emirates",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 982,
      "bar": "",
      "�װ����": "Yemenia",
      "bar__1": "Yemenia",
      "IATA": "IY",
      "bar__2": "IYE",
      "ICAO": "Yemen",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 980,
      "bar": "",
      "�װ����": "Felix Airways",
      "bar__1": "Felix Airways",
      "IATA": "FO",
      "bar__2": "FXX",
      "ICAO": "Yemen",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 979,
      "bar": "",
      "�װ����": "Gulf Air",
      "bar__1": "Gulf Air",
      "IATA": "GF",
      "bar__2": "GFA",
      "ICAO": "Bahrain",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 966,
      "bar": "",
      "�װ����": "Qatar Airways",
      "bar__1": "Qatar Airways",
      "IATA": "QR",
      "bar__2": "QTR",
      "ICAO": "Qatar",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 962,
      "bar": "",
      "�װ����": "Air Algerie",
      "bar__1": "Air Algerie",
      "IATA": "AH",
      "bar__2": "DAH",
      "ICAO": "Algeria",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 957,
      "bar": "",
      "�װ����": "Egypt Air Express",
      "bar__1": "Egypt Air Express",
      "IATA": "",
      "bar__2": "MSE",
      "ICAO": "Egypt",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 953,
      "bar": "",
      "�װ����": "Egypt Air",
      "bar__1": "Egypt Air",
      "IATA": "MS",
      "bar__2": "MSR",
      "ICAO": "Egypt",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 952,
      "bar": "",
      "�װ����": "Air Sinai",
      "bar__1": "Air Sinai",
      "IATA": "4D",
      "bar__2": "ASD",
      "ICAO": "Egypt",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 927,
      "bar": "",
      "�װ����": "National Aviation Company",
      "bar__1": "National Aviation Company",
      "IATA": "",
      "bar__2": "GTY",
      "ICAO": "Egypt",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 926,
      "bar": "",
      "�װ����": "Midwest Airlines",
      "bar__1": "Midwest Airlines",
      "IATA": "",
      "bar__2": "MWA",
      "ICAO": "Egypt",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 916,
      "bar": "",
      "�װ����": "Air Arabia Egypt",
      "bar__1": "Air Arabia Egypt",
      "IATA": "E5",
      "bar__2": "RBG",
      "ICAO": "Egypt",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 913,
      "bar": "",
      "�װ����": "Nile Air",
      "bar__1": "Nile Air",
      "IATA": "NP",
      "bar__2": "NIA",
      "ICAO": "Egypt",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 911,
      "bar": "",
      "�װ����": "Almasria Universal Airlines",
      "bar__1": "Almasria Universal Airlines",
      "IATA": "UJ",
      "bar__2": "LMU",
      "ICAO": "Egypt",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 907,
      "bar": "",
      "�װ����": "Royal Air Maroc - Compagnie Nationale De Transports Aeriens",
      "bar__1": "Royal Air Maroc - Compagnie Nationale De Transports Aeriens",
      "IATA": "AT",
      "bar__2": "RAM",
      "ICAO": "Morocco",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 903,
      "bar": "",
      "�װ����": "Air Arabia Maroc",
      "bar__1": "Air Arabia Maroc",
      "IATA": "3O",
      "bar__2": "MAC",
      "ICAO": "Morocco",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 902,
      "bar": "",
      "�װ����": "Royal Air Maroc Express",
      "bar__1": "Royal Air Maroc Express",
      "IATA": "",
      "bar__2": "RXP",
      "ICAO": "Morocco",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 901,
      "bar": "",
      "�װ����": "Buraq Air",
      "bar__1": "Buraq Air",
      "IATA": "UZ",
      "bar__2": "BRQ",
      "ICAO": "Libya",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 900,
      "bar": "",
      "�װ����": "Libyan Airlines",
      "bar__1": "Libyan Airlines",
      "IATA": "LN",
      "bar__2": "LAA",
      "ICAO": "Libya",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 873,
      "bar": "",
      "�װ����": "Petroair",
      "bar__1": "Petroair",
      "IATA": "",
      "bar__2": "PEO",
      "ICAO": "Libya",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 867,
      "bar": "",
      "�װ����": "Nova Airline",
      "bar__1": "Nova Airline",
      "IATA": "O9",
      "bar__2": "NOV",
      "ICAO": "Sudan",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 866,
      "bar": "",
      "�װ����": "Sudan Airways",
      "bar__1": "Sudan Airways",
      "IATA": "SD",
      "bar__2": "SUD",
      "ICAO": "Sudan",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 845,
      "bar": "",
      "�װ����": "Blue Bird Aviation",
      "bar__1": "Blue Bird Aviation",
      "IATA": "",
      "bar__2": "BLB",
      "ICAO": "Sudan",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 836,
      "bar": "",
      "�װ����": "El magal Aviation Services",
      "bar__1": "El magal Aviation Services",
      "IATA": "",
      "bar__2": "MGG",
      "ICAO": "Sudan",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 820,
      "bar": "",
      "�װ����": "Sun Air",
      "bar__1": "Sun Air",
      "IATA": "",
      "bar__2": "SNR",
      "ICAO": "Sudan",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 817,
      "bar": "",
      "�װ����": "Alfa Airlines",
      "bar__1": "Alfa Airlines",
      "IATA": "",
      "bar__2": "AAJ",
      "ICAO": "Sudan",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 813,
      "bar": "",
      "�װ����": "Tunis Air",
      "bar__1": "Tunis Air",
      "IATA": "TU",
      "bar__2": "TAR",
      "ICAO": "Tunisia",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 811,
      "bar": "",
      "�װ����": "Nouvel Air Tunisie",
      "bar__1": "Nouvel Air Tunisie",
      "IATA": "BJ",
      "bar__2": "LBT",
      "ICAO": "Tunisia",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 805,
      "bar": "",
      "�װ����": "TAAG Angola Airlines",
      "bar__1": "TAAG Angola Airlines",
      "IATA": "DT",
      "bar__2": "DTA",
      "ICAO": "Angola",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 7080,
      "bar": "",
      "�װ����": "Camair-Co",
      "bar__1": "Camair-Co",
      "IATA": "QC",
      "bar__2": "CRC",
      "ICAO": "Cameroon",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 720,
      "bar": "",
      "�װ����": "Cetraca Air Service",
      "bar__1": "Cetraca Air Service",
      "IATA": "",
      "bar__2": "CER",
      "ICAO": "Democratic Republic of Congo",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 685,
      "bar": "",
      "�װ����": "Nouvelle Air Affaires Gabon",
      "bar__1": "Nouvelle Air Affaires Gabon",
      "IATA": "",
      "bar__2": "NVS",
      "ICAO": "Gabon",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 673,
      "bar": "",
      "�װ����": "Scd Aviation",
      "bar__1": "Scd Aviation",
      "IATA": "",
      "bar__2": "SCY",
      "ICAO": "Gabon",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 645,
      "bar": "",
      "�װ����": "Ethiopian Airlines",
      "bar__1": "Ethiopian Airlines",
      "IATA": "ET",
      "bar__2": "ETH",
      "ICAO": "Ethiopia",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 613,
      "bar": "",
      "�װ����": "Fly540",
      "bar__1": "Fly540",
      "IATA": "5H",
      "bar__2": "FFV",
      "ICAO": "Kenya",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 612,
      "bar": "",
      "�װ����": "Kenya Airways",
      "bar__1": "Kenya Airways",
      "IATA": "KQ",
      "bar__2": "KQA",
      "ICAO": "Kenya",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 609,
      "bar": "",
      "�װ����": "Astral Aviation",
      "bar__1": "Astral Aviation",
      "IATA": "8V",
      "bar__2": "ACP",
      "ICAO": "Kenya",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 592,
      "bar": "",
      "�װ����": "Pan African Airways",
      "bar__1": "Pan African Airways",
      "IATA": "",
      "bar__2": "ODM",
      "ICAO": "Kenya",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 589,
      "bar": "",
      "�װ����": "Mombasa Air Safari",
      "bar__1": "Mombasa Air Safari",
      "IATA": "",
      "bar__2": "RRV",
      "ICAO": "Kenya",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 583,
      "bar": "",
      "�װ����": "Aberdair Aviation",
      "bar__1": "Aberdair Aviation",
      "IATA": "",
      "bar__2": "BDV",
      "ICAO": "Kenya",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 581,
      "bar": "",
      "�װ����": "Aerospace Consortium",
      "bar__1": "Aerospace Consortium",
      "IATA": "",
      "bar__2": "AKQ",
      "ICAO": "Kenya",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 580,
      "bar": "",
      "�װ����": "Air Madagascar",
      "bar__1": "Air Madagascar",
      "IATA": "MD",
      "bar__2": "MDG",
      "ICAO": "Madagascar",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 575,
      "bar": "",
      "�װ����": "Ulendo Airlink",
      "bar__1": "Ulendo Airlink",
      "IATA": "W4",
      "bar__2": "NYS",
      "ICAO": "Malawi",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 572,
      "bar": "",
      "�װ����": "Air Mauritius",
      "bar__1": "Air Mauritius",
      "IATA": "MK",
      "bar__2": "MAU",
      "ICAO": "Mauritius",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 570,
      "bar": "",
      "�װ����": "Pan African Airlines",
      "bar__1": "Pan African Airlines",
      "IATA": "PF",
      "bar__2": "",
      "ICAO": "Nigeria",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 564,
      "bar": "",
      "�װ����": "Mozambique Expresso",
      "bar__1": "Mozambique Expresso",
      "IATA": "",
      "bar__2": "MXE",
      "ICAO": "Mozambique",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 563,
      "bar": "",
      "�װ����": "Kaya Airlines",
      "bar__1": "Kaya Airlines",
      "IATA": "",
      "bar__2": "KYY",
      "ICAO": "Mozambique",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 560,
      "bar": "",
      "�װ����": "Rwandair Express",
      "bar__1": "Rwandair Express",
      "IATA": "WB",
      "bar__2": "RWD",
      "ICAO": "Rwanda",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 556,
      "bar": "",
      "�װ����": "Air Seychelles",
      "bar__1": "Air Seychelles",
      "IATA": "HM",
      "bar__2": "SEY",
      "ICAO": "Seychelles",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 553,
      "bar": "",
      "�װ����": "Air Tanzania",
      "bar__1": "Air Tanzania",
      "IATA": "TC",
      "bar__2": "ATC",
      "ICAO": "Tanzania",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 552,
      "bar": "",
      "�װ����": "Precision Air Services",
      "bar__1": "Precision Air Services",
      "IATA": "PW",
      "bar__2": "PRF",
      "ICAO": "Tanzania",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 551,
      "bar": "",
      "�װ����": "ZanAir",
      "bar__1": "ZanAir",
      "IATA": "B4",
      "bar__2": "TAN",
      "ICAO": "Tanzania",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 543,
      "bar": "",
      "�װ����": "Auric Air Services",
      "bar__1": "Auric Air Services",
      "IATA": "UI",
      "bar__2": "AUK",
      "ICAO": "Tanzania",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 535,
      "bar": "",
      "�װ����": "Uganda Airlines",
      "bar__1": "Uganda Airlines",
      "IATA": "UR",
      "bar__2": "UGD",
      "ICAO": "Uganda",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 512,
      "bar": "",
      "�װ����": "Proflight Zambia",
      "bar__1": "Proflight Zambia",
      "IATA": "P0",
      "bar__2": "PFZ",
      "ICAO": "Zambia",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 496,
      "bar": "",
      "�װ����": "Air Zimbabwe",
      "bar__1": "Air Zimbabwe",
      "IATA": "UM",
      "bar__2": "AZW",
      "ICAO": "Zimbabwe",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 478,
      "bar": "",
      "�װ����": "Air Burkina",
      "bar__1": "Air Burkina",
      "IATA": "2J",
      "bar__2": "VBW",
      "ICAO": "Burkina Faso",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 441,
      "bar": "",
      "�װ����": "Royal Air",
      "bar__1": "Royal Air",
      "IATA": "",
      "bar__2": "RGG",
      "ICAO": "Gambia",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 6953,
      "bar": "",
      "�װ����": "Africa World Airlines",
      "bar__1": "Africa World Airlines",
      "IATA": "AW",
      "bar__2": "AFW",
      "ICAO": "Ghana",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 6977,
      "bar": "",
      "�װ����": "Mauritania Airlines International",
      "bar__1": "Mauritania Airlines International",
      "IATA": "L6",
      "bar__2": "MAI",
      "ICAO": "Mauritania",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 334,
      "bar": "",
      "�װ����": "Med-View Airlines",
      "bar__1": "Med-View Airlines",
      "IATA": "VL",
      "bar__2": "MEV",
      "ICAO": "Nigeria",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 329,
      "bar": "",
      "�װ����": "Dana Air",
      "bar__1": "Dana Air",
      "IATA": "9J",
      "bar__2": "DAN",
      "ICAO": "Nigeria",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 319,
      "bar": "",
      "�װ����": "Overland Airways",
      "bar__1": "Overland Airways",
      "IATA": "OF",
      "bar__2": "OLA",
      "ICAO": "Nigeria",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 197,
      "bar": "",
      "�װ����": "ASKY Airlines",
      "bar__1": "ASKY Airlines",
      "IATA": "KP",
      "bar__2": "SKK",
      "ICAO": "Togo",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 196,
      "bar": "",
      "�װ����": "Air Botswana",
      "bar__1": "Air Botswana",
      "IATA": "BP",
      "bar__2": "BOT",
      "ICAO": "Botswana",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 195,
      "bar": "",
      "�װ����": "Air Namibia",
      "bar__1": "Air Namibia",
      "IATA": "SW",
      "bar__2": "NMB",
      "ICAO": "Namibia",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 170,
      "bar": "",
      "�װ����": "Federal Airlines",
      "bar__1": "Federal Airlines",
      "IATA": "7V",
      "bar__2": "FDR",
      "ICAO": "South Africa",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 169,
      "bar": "",
      "�װ����": "Airlink",
      "bar__1": "Airlink",
      "IATA": "4Z",
      "bar__2": "LNK",
      "ICAO": "South Africa",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 145,
      "bar": "",
      "�װ����": "Norse Air Charter",
      "bar__1": "Norse Air Charter",
      "IATA": "",
      "bar__2": "NRX",
      "ICAO": "South Africa",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 100,
      "bar": "",
      "�װ����": "MANGO",
      "bar__1": "MANGO",
      "IATA": "JE",
      "bar__2": "MNO",
      "ICAO": "South Africa",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 80,
      "bar": "",
      "�װ����": "Africa Charter Airlines Cc",
      "bar__1": "Africa Charter Airlines Cc",
      "IATA": "",
      "bar__2": "FSK",
      "ICAO": "South Africa",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 75,
      "bar": "",
      "�װ����": "CFA Air Charter",
      "bar__1": "CFA Air Charter",
      "IATA": "",
      "bar__2": "CFX",
      "ICAO": "South Africa",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 71,
      "bar": "",
      "�װ����": "Allegiance Air",
      "bar__1": "Allegiance Air",
      "IATA": "",
      "bar__2": "ANJ",
      "ICAO": "South Africa",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 4267,
      "bar": "",
      "�װ����": "Air Greenland",
      "bar__1": "Air Greenland",
      "IATA": "GL",
      "bar__2": "GRL",
      "ICAO": "Greenland",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 740,
      "bar": "",
      "�װ����": "Trans Air Congo",
      "bar__1": "Trans Air Congo",
      "IATA": "Q8",
      "bar__2": "TSG",
      "ICAO": "Republic of the Congo",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 693,
      "bar": "",
      "�װ����": "Cronos Airlines",
      "bar__1": "Cronos Airlines",
      "IATA": "C8",
      "bar__2": "CRA",
      "ICAO": "Equatorial Guinea",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 692,
      "bar": "",
      "�װ����": "Ceiba Intercontinental",
      "bar__1": "Ceiba Intercontinental",
      "IATA": "C2",
      "bar__2": "CEL",
      "ICAO": "Equatorial Guinea",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 646,
      "bar": "",
      "�װ����": "Eritrean Airlines",
      "bar__1": "Eritrean Airlines",
      "IATA": "B8",
      "bar__2": "ERT",
      "ICAO": "Eritrea",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 617,
      "bar": "",
      "�װ����": "Inter Iles Air",
      "bar__1": "Inter Iles Air",
      "IATA": "",
      "bar__2": "IIA",
      "ICAO": "Comoros",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 481,
      "bar": "",
      "�װ����": "Cotair",
      "bar__1": "Cotair",
      "IATA": "",
      "bar__2": "COB",
      "ICAO": "Benin",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 664,
      "bar": "",
      "�װ����": "STP Airways",
      "bar__1": "STP Airways",
      "IATA": "8F",
      "bar__2": "STP",
      "ICAO": "Sao Tome and Principe",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 3402,
      "bar": "",
      "�װ����": "Air Saint Pierre",
      "bar__1": "Air Saint Pierre",
      "IATA": "PJ",
      "bar__2": "SPM",
      "ICAO": "France",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 9328,
      "bar": "",
      "�װ����": "21 Air",
      "bar__1": "21 Air",
      "IATA": "2I",
      "bar__2": "CSB",
      "ICAO": "United States",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 7732,
      "bar": "",
      "�װ����": "40 Mile Air",
      "bar__1": "40 Mile Air",
      "IATA": "Q5",
      "bar__2": "MLA",
      "ICAO": "United States",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 7733,
      "bar": "",
      "�װ����": "748 Air Services",
      "bar__1": "748 Air Services",
      "IATA": "",
      "bar__2": "IHO",
      "ICAO": "Kenya",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 7107,
      "bar": "",
      "�װ����": "9 Air",
      "bar__1": "9 Air",
      "IATA": "AQ",
      "bar__2": "JYH",
      "ICAO": "China",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 7771,
      "bar": "",
      "�װ����": "Aerolimusine",
      "bar__1": "Aerolimusine",
      "IATA": "",
      "bar__2": "LIN",
      "ICAO": "Russia",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 7772,
      "bar": "",
      "�װ����": "Aerolineas Especiales de Colombia",
      "bar__1": "Aerolineas Especiales de Colombia",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Colombia",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 7773,
      "bar": "",
      "�װ����": "Aerolineas Sosa",
      "bar__1": "Aerolineas Sosa",
      "IATA": "SO",
      "bar__2": "NSO",
      "ICAO": "Honduras",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 7774,
      "bar": "",
      "�װ����": "Aerolineas Vive Peru",
      "bar__1": "Aerolineas Vive Peru",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Peru",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 7734,
      "bar": "",
      "�װ����": "AB Aviation",
      "bar__1": "AB Aviation",
      "IATA": "Y6",
      "bar__2": "CIK",
      "ICAO": "Comoros",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 7735,
      "bar": "",
      "�װ����": "Abu Dhabi Aviation",
      "bar__1": "Abu Dhabi Aviation",
      "IATA": "",
      "bar__2": "AXU",
      "ICAO": "United Arab Emirates",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 7736,
      "bar": "",
      "�װ����": "ABX Air",
      "bar__1": "ABX Air",
      "IATA": "GB",
      "bar__2": "ABX",
      "ICAO": "United States",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 7737,
      "bar": "",
      "�װ����": "Academy Airlines",
      "bar__1": "Academy Airlines",
      "IATA": "",
      "bar__2": "ACD",
      "ICAO": "United States",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 7741,
      "bar": "",
      "�װ����": "Aer Caribe",
      "bar__1": "Aer Caribe",
      "IATA": "JK",
      "bar__2": "ACL",
      "ICAO": "Colombia",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 7742,
      "bar": "",
      "�װ����": "Aer Caribe Peru",
      "bar__1": "Aer Caribe Peru",
      "IATA": "",
      "bar__2": "CPR",
      "ICAO": "Peru",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 7744,
      "bar": "",
      "�װ����": "AERO - Mapiex Aero",
      "bar__1": "AERO - Mapiex Aero",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Panama",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 7746,
      "bar": "",
      "�װ����": "Aero Andino SA",
      "bar__1": "Aero Andino SA",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Peru",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 7747,
      "bar": "",
      "�װ����": "Aero Biniza",
      "bar__1": "Aero Biniza",
      "IATA": "",
      "bar__2": "BZS",
      "ICAO": "Mexico",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 7748,
      "bar": "",
      "�װ����": "Aero Charter UKRAINE",
      "bar__1": "Aero Charter UKRAINE",
      "IATA": "DW",
      "bar__2": "UCR",
      "ICAO": "Ukraine",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 7745,
      "bar": "",
      "�װ����": "Aero Contractors",
      "bar__1": "Aero Contractors",
      "IATA": "NG",
      "bar__2": "NIG",
      "ICAO": "Nigeria",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 7749,
      "bar": "",
      "�װ����": "Aero Cuahonte",
      "bar__1": "Aero Cuahonte",
      "IATA": "",
      "bar__2": "CUO",
      "ICAO": "Mexico",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 7750,
      "bar": "",
      "�װ����": "Aero JBR",
      "bar__1": "Aero JBR",
      "IATA": "",
      "bar__2": "AJB",
      "ICAO": "Mexico",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 7751,
      "bar": "",
      "�װ����": "Aero Mongolia",
      "bar__1": "Aero Mongolia",
      "IATA": "M0",
      "bar__2": "MNG",
      "ICAO": "Mongolia",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 7752,
      "bar": "",
      "�װ����": "Aero Owen",
      "bar__1": "Aero Owen",
      "IATA": "",
      "bar__2": "OWN",
      "ICAO": "Mexico",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 7753,
      "bar": "",
      "�װ����": "Aero Service ASF",
      "bar__1": "Aero Service ASF",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Senegal",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 7754,
      "bar": "",
      "�װ����": "Aero Transporte SA",
      "bar__1": "Aero Transporte SA",
      "IATA": "",
      "bar__2": "AMP",
      "ICAO": "Peru",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 7755,
      "bar": "",
      "�װ����": "Aero Tranzit",
      "bar__1": "Aero Tranzit",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Russia",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 7756,
      "bar": "",
      "�װ����": "Aerobell Air Charter",
      "bar__1": "Aerobell Air Charter",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Costa Rica",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 7757,
      "bar": "",
      "�װ����": "AeroBratsk",
      "bar__1": "AeroBratsk",
      "IATA": "",
      "bar__2": "BRP",
      "ICAO": "Russia",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 7758,
      "bar": "",
      "�װ����": "Aerocardal",
      "bar__1": "Aerocardal",
      "IATA": "",
      "bar__2": "CDA",
      "ICAO": "Chile",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 7759,
      "bar": "",
      "�װ����": "Aerocaribe de Honduras",
      "bar__1": "Aerocaribe de Honduras",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Honduras",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 7760,
      "bar": "",
      "�װ����": "AeroDavinci",
      "bar__1": "AeroDavinci",
      "IATA": "",
      "bar__2": "DVI",
      "ICAO": "Mexico",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 9330,
      "bar": "",
      "�װ����": "Aerodesierto SA",
      "bar__1": "Aerodesierto SA",
      "IATA": "",
      "bar__2": "DTO",
      "ICAO": "Chile",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 7761,
      "bar": "",
      "�װ����": "Aerodiana",
      "bar__1": "Aerodiana",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Peru",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 7762,
      "bar": "",
      "�װ����": "AeroDomca",
      "bar__1": "AeroDomca",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Dominican Republic",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 7763,
      "bar": "",
      "�װ����": "AeroEjecutiva",
      "bar__1": "AeroEjecutiva",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Chile",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 7764,
      "bar": "",
      "�װ����": "Aeroeste",
      "bar__1": "Aeroeste",
      "IATA": "",
      "bar__2": "ROE",
      "ICAO": "Bolivia",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 7765,
      "bar": "",
      "�װ����": "Aeroferinco",
      "bar__1": "Aeroferinco",
      "IATA": "",
      "bar__2": "FEO",
      "ICAO": "Mexico",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 7766,
      "bar": "",
      "�װ����": "Aero-Fret Business",
      "bar__1": "Aero-Fret Business",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Republic of the Congo",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 7767,
      "bar": "",
      "�װ����": "Aerofuturo",
      "bar__1": "Aerofuturo",
      "IATA": "",
      "bar__2": "FUT",
      "ICAO": "Mexico",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 7768,
      "bar": "",
      "�װ����": "Aerogaviota",
      "bar__1": "Aerogaviota",
      "IATA": "KG",
      "bar__2": "GTV",
      "ICAO": "Cuba",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 7769,
      "bar": "",
      "�װ����": "AeroGeo",
      "bar__1": "AeroGeo",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Russia",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 7791,
      "bar": "",
      "�װ����": "Aerovias Caribe Express",
      "bar__1": "Aerovias Caribe Express",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Venezuela",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 7792,
      "bar": "",
      "�װ����": "Aerovias DAP",
      "bar__1": "Aerovias DAP",
      "IATA": "V5",
      "bar__2": "DAP",
      "ICAO": "Chile",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 9332,
      "bar": "",
      "�װ����": "Aerovias Internacionales del Uruguay",
      "bar__1": "Aerovias Internacionales del Uruguay",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Uruguay",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 7793,
      "bar": "",
      "�װ����": "Aerovis Airlines",
      "bar__1": "Aerovis Airlines",
      "IATA": "V6",
      "bar__2": "VIZ",
      "ICAO": "Ukraine",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 7795,
      "bar": "",
      "�װ����": "Afra Airways",
      "bar__1": "Afra Airways",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Burundi",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 7796,
      "bar": "",
      "�װ����": "Africa Air Assistance",
      "bar__1": "Africa Air Assistance",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Senegal",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 7797,
      "bar": "",
      "�װ����": "African Express Airways",
      "bar__1": "African Express Airways",
      "IATA": "XU",
      "bar__2": "AXK",
      "ICAO": "Kenya",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 7798,
      "bar": "",
      "�װ����": "Africa's Connection",
      "bar__1": "Africa's Connection",
      "IATA": "",
      "bar__2": "ACH",
      "ICAO": "Sao Tome and Principe",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 7799,
      "bar": "",
      "�װ����": "Afrijet Business Service",
      "bar__1": "Afrijet Business Service",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Gabon",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 7800,
      "bar": "",
      "�װ����": "Afriqiyah Airways",
      "bar__1": "Afriqiyah Airways",
      "IATA": "8U",
      "bar__2": "AAW",
      "ICAO": "Libya",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 7801,
      "bar": "",
      "�װ����": "AG Air",
      "bar__1": "AG Air",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Chad",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 7802,
      "bar": "",
      "�װ����": "AHS Air International",
      "bar__1": "AHS Air International",
      "IATA": "",
      "bar__2": "AHS",
      "ICAO": "Pakistan",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 7803,
      "bar": "",
      "�װ����": "Air 26",
      "bar__1": "Air 26",
      "IATA": "",
      "bar__2": "DCD",
      "ICAO": "Angola",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 7804,
      "bar": "",
      "�װ����": "Air Aktobe",
      "bar__1": "Air Aktobe",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Kazakhstan",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 7805,
      "bar": "",
      "�װ����": "Air Albania",
      "bar__1": "Air Albania",
      "IATA": "ZB",
      "bar__2": "ABN",
      "ICAO": "Albania",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 7806,
      "bar": "",
      "�װ����": "Air Alderney",
      "bar__1": "Air Alderney",
      "IATA": "",
      "bar__2": "",
      "ICAO": "United Kingdom",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 7807,
      "bar": "",
      "�װ����": "Air Alize",
      "bar__1": "Air Alize",
      "IATA": "",
      "bar__2": "",
      "ICAO": "New Caledonia",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 7147,
      "bar": "",
      "�װ����": "Air Alsie",
      "bar__1": "Air Alsie",
      "IATA": "6I",
      "bar__2": "MMD",
      "ICAO": "Denmark",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 7808,
      "bar": "",
      "�װ����": "Air Andorra",
      "bar__1": "Air Andorra",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Spain",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 7809,
      "bar": "",
      "�װ����": "Air Antilles Express",
      "bar__1": "Air Antilles Express",
      "IATA": "3S",
      "bar__2": "GUY",
      "ICAO": "France",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 7826,
      "bar": "",
      "�װ����": "Air Europa",
      "bar__1": "Air Europa",
      "IATA": "UX",
      "bar__2": "AEA",
      "ICAO": "Spain",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 7827,
      "bar": "",
      "�װ����": "Air Europa Cargo",
      "bar__1": "Air Europa Cargo",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Spain",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 7829,
      "bar": "",
      "�װ����": "Air Excel",
      "bar__1": "Air Excel",
      "IATA": "",
      "bar__2": "XLL",
      "ICAO": "Tanzania",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 7830,
      "bar": "",
      "�װ����": "Air Express Algeria",
      "bar__1": "Air Express Algeria",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Algeria",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 7831,
      "bar": "",
      "�װ����": "Air Falcon",
      "bar__1": "Air Falcon",
      "IATA": "",
      "bar__2": "FPK",
      "ICAO": "Pakistan",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 7832,
      "bar": "",
      "�װ����": "Air Flamenco",
      "bar__1": "Air Flamenco",
      "IATA": "F4",
      "bar__2": "WAF",
      "ICAO": "Puerto Rico",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 9336,
      "bar": "",
      "�װ����": "Air Georgia",
      "bar__1": "Air Georgia",
      "IATA": "DA",
      "bar__2": "AGF",
      "ICAO": "Georgia",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 7834,
      "bar": "",
      "�װ����": "Air Ghana",
      "bar__1": "Air Ghana",
      "IATA": "",
      "bar__2": "GHN",
      "ICAO": "Ghana",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 7810,
      "bar": "",
      "�װ����": "Air Belgium",
      "bar__1": "Air Belgium",
      "IATA": "KF",
      "bar__2": "ABB",
      "ICAO": "Belgium",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 9333,
      "bar": "",
      "�װ����": "Air Borealis",
      "bar__1": "Air Borealis",
      "IATA": "",
      "bar__2": "LBR",
      "ICAO": "Canada",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 7811,
      "bar": "",
      "�װ����": "Air Bravo Corporation",
      "bar__1": "Air Bravo Corporation",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Canada",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 7812,
      "bar": "",
      "�װ����": "Air Bright",
      "bar__1": "Air Bright",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Bulgaria",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 7813,
      "bar": "",
      "�װ����": "Air Cairo",
      "bar__1": "Air Cairo",
      "IATA": "SM",
      "bar__2": "MSC",
      "ICAO": "Egypt",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 7814,
      "bar": "",
      "�װ����": "Air Canada Jetz",
      "bar__1": "Air Canada Jetz",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Canada",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 7220,
      "bar": "",
      "�װ����": "Air Canada Rouge",
      "bar__1": "Air Canada Rouge",
      "IATA": "RV",
      "bar__2": "ROU",
      "ICAO": "Canada",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 7815,
      "bar": "",
      "�װ����": "Air Cargo",
      "bar__1": "Air Cargo",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Malawi",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 7145,
      "bar": "",
      "�װ����": "Air Cargo Global",
      "bar__1": "Air Cargo Global",
      "IATA": "CW",
      "bar__2": "CCC",
      "ICAO": "Slovakia",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 9334,
      "bar": "",
      "�װ����": "Air Cargo Malawi",
      "bar__1": "Air Cargo Malawi",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Malawi",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 7816,
      "bar": "",
      "�װ����": "Air Cargo Mongolia",
      "bar__1": "Air Cargo Mongolia",
      "IATA": "",
      "bar__2": "MGC",
      "ICAO": "Mongolia",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 7817,
      "bar": "",
      "�װ����": "Air China Cargo",
      "bar__1": "Air China Cargo",
      "IATA": "CA",
      "bar__2": "CAO",
      "ICAO": "China",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 7818,
      "bar": "",
      "�װ����": "Air Choice One",
      "bar__1": "Air Choice One",
      "IATA": "3E",
      "bar__2": "ACO",
      "ICAO": "United States",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 7819,
      "bar": "",
      "�װ����": "Air Class Lineas Aereas",
      "bar__1": "Air Class Lineas Aereas",
      "IATA": "VZ",
      "bar__2": "QCL",
      "ICAO": "Uruguay",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 9335,
      "bar": "",
      "�װ����": "Air Clipper",
      "bar__1": "Air Clipper",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Republic Of Korea",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 7820,
      "bar": "",
      "�װ����": "Air Congo International",
      "bar__1": "Air Congo International",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Republic of the Congo",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 7821,
      "bar": "",
      "�װ����": "Air Corail",
      "bar__1": "Air Corail",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Comoros",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 7822,
      "bar": "",
      "�װ����": "Air Cote d'Ivoire",
      "bar__1": "Air Cote d'Ivoire",
      "IATA": "HF",
      "bar__2": "VRE",
      "ICAO": "Cote d'Ivoire",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 7823,
      "bar": "",
      "�װ����": "Air Creebec",
      "bar__1": "Air Creebec",
      "IATA": "YN",
      "bar__2": "CRQ",
      "ICAO": "Canada",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 7825,
      "bar": "",
      "�װ����": "Air Djibouti",
      "bar__1": "Air Djibouti",
      "IATA": "IV",
      "bar__2": "DJU",
      "ICAO": "Djibouti",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 7775,
      "bar": "",
      "�װ����": "Aerolink Air Services",
      "bar__1": "Aerolink Air Services",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Australia",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 7776,
      "bar": "",
      "�װ����": "Aeromas",
      "bar__1": "Aeromas",
      "IATA": "",
      "bar__2": "MSM",
      "ICAO": "Uruguay",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 7777,
      "bar": "",
      "�װ����": "Aeromaster Airways",
      "bar__1": "Aeromaster Airways",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Ecuador",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 7778,
      "bar": "",
      "�װ����": "Aeromet",
      "bar__1": "Aeromet",
      "IATA": "",
      "bar__2": "MTE",
      "ICAO": "Chile",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 7780,
      "bar": "",
      "�װ����": "Aeromoscovia",
      "bar__1": "Aeromoscovia",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Russia",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 7781,
      "bar": "",
      "�װ����": "Aeronaves Peruanas Air Cargo",
      "bar__1": "Aeronaves Peruanas Air Cargo",
      "IATA": "",
      "bar__2": "WPL",
      "ICAO": "Peru",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 7782,
      "bar": "",
      "�װ����": "Aeronaves TSM",
      "bar__1": "Aeronaves TSM",
      "IATA": "",
      "bar__2": "VTM",
      "ICAO": "Mexico",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 7783,
      "bar": "",
      "�װ����": "AeroPacifico",
      "bar__1": "AeroPacifico",
      "IATA": "",
      "bar__2": "TFO",
      "ICAO": "Mexico",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 7784,
      "bar": "",
      "�װ����": "Aeropacifico - Aeroservicios de la Costa",
      "bar__1": "Aeropacifico - Aeroservicios de la Costa",
      "IATA": "",
      "bar__2": "TAA",
      "ICAO": "Mexico",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 9331,
      "bar": "",
      "�װ����": "Aeroregional",
      "bar__1": "Aeroregional",
      "IATA": "",
      "bar__2": "RER",
      "ICAO": "Ecuador",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 7785,
      "bar": "",
      "�װ����": "Aeroservicios Empresariales",
      "bar__1": "Aeroservicios Empresariales",
      "IATA": "",
      "bar__2": "EMS",
      "ICAO": "Mexico",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 7786,
      "bar": "",
      "�װ����": "Aerostan",
      "bar__1": "Aerostan",
      "IATA": "",
      "bar__2": "BSC",
      "ICAO": "Kyrgyzstan",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 7787,
      "bar": "",
      "�װ����": "Aerosucre Colombia",
      "bar__1": "Aerosucre Colombia",
      "IATA": "6N",
      "bar__2": "KRE",
      "ICAO": "Colombia",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 7789,
      "bar": "",
      "�װ����": "Aerotaxi de Valledupar",
      "bar__1": "Aerotaxi de Valledupar",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Colombia",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 7790,
      "bar": "",
      "�װ����": "Aerotrans Cargo",
      "bar__1": "Aerotrans Cargo",
      "IATA": "F5",
      "bar__2": "ATG",
      "ICAO": "Moldova",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 7847,
      "bar": "",
      "�װ����": "Air Lada",
      "bar__1": "Air Lada",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Spain",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 7842,
      "bar": "",
      "�װ����": "Air Juan",
      "bar__1": "Air Juan",
      "IATA": "AO",
      "bar__2": "",
      "ICAO": "Philippines",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 7843,
      "bar": "",
      "�װ����": "Air Kasai",
      "bar__1": "Air Kasai",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Democratic Republic of Congo",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 7844,
      "bar": "",
      "�װ����": "Air Kasai",
      "bar__1": "Air Kasai",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Democratic Republic of the Congo",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 7845,
      "bar": "",
      "�װ����": "Air Katanga",
      "bar__1": "Air Katanga",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Democratic Republic of Congo",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 7846,
      "bar": "",
      "�װ����": "Air Kerala",
      "bar__1": "Air Kerala",
      "IATA": "",
      "bar__2": "",
      "ICAO": "India",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 7100,
      "bar": "",
      "�װ����": "Air Guilin",
      "bar__1": "Air Guilin",
      "IATA": "GT",
      "bar__2": "CGH",
      "ICAO": "China",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 7838,
      "bar": "",
      "�װ����": "Air Hong Kong",
      "bar__1": "Air Hong Kong",
      "IATA": "LD",
      "bar__2": "AHK",
      "ICAO": "Hong Kong",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 7839,
      "bar": "",
      "�װ����": "Air Horizont",
      "bar__1": "Air Horizont",
      "IATA": "",
      "bar__2": "HAT",
      "ICAO": "Spain",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 7840,
      "bar": "",
      "�װ����": "Air Iglesias",
      "bar__1": "Air Iglesias",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Venezuela",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 7943,
      "bar": "",
      "�װ����": "Air India Regional",
      "bar__1": "Air India Regional",
      "IATA": "9I",
      "bar__2": "LLR",
      "ICAO": "India",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 7888,
      "bar": "",
      "�װ����": "Air Wakaya",
      "bar__1": "Air Wakaya",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Fiji",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 7890,
      "bar": "",
      "�װ����": "Air West Cargo",
      "bar__1": "Air West Cargo",
      "IATA": "",
      "bar__2": "AWZ",
      "ICAO": "Sudan",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 7891,
      "bar": "",
      "�װ����": "Air Whitsunday Seaplanes",
      "bar__1": "Air Whitsunday Seaplanes",
      "IATA": "",
      "bar__2": "RWS",
      "ICAO": "Australia",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 7924,
      "bar": "",
      "�װ����": "Airwing",
      "bar__1": "Airwing",
      "IATA": "",
      "bar__2": "NWG",
      "ICAO": "Norway",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 7925,
      "bar": "",
      "�װ����": "Airwork",
      "bar__1": "Airwork",
      "IATA": "",
      "bar__2": "AWK",
      "ICAO": "New Zealand",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 7926,
      "bar": "",
      "�װ����": "AIS Airlines",
      "bar__1": "AIS Airlines",
      "IATA": "",
      "bar__2": "PNX",
      "ICAO": "Netherlands",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 7927,
      "bar": "",
      "�װ����": "AIST M Airclub",
      "bar__1": "AIST M Airclub",
      "IATA": "",
      "bar__2": "ISM",
      "ICAO": "Russia",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 7928,
      "bar": "",
      "�װ����": "Aklak",
      "bar__1": "Aklak",
      "IATA": "6L",
      "bar__2": "AKK",
      "ICAO": "Canada",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 7929,
      "bar": "",
      "�װ����": "Al Bayraq",
      "bar__1": "Al Bayraq",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Saudi Arabia",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 7930,
      "bar": "",
      "�װ����": "ALADA",
      "bar__1": "ALADA",
      "IATA": "",
      "bar__2": "RAD",
      "ICAO": "Angola",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 7932,
      "bar": "",
      "�װ����": "AlbaStar",
      "bar__1": "AlbaStar",
      "IATA": "AP",
      "bar__2": "LAV",
      "ICAO": "Spain",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 7972,
      "bar": "",
      "�װ����": "Amur Airlines",
      "bar__1": "Amur Airlines",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Russia",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 7854,
      "bar": "",
      "�װ����": "Air Liaison",
      "bar__1": "Air Liaison",
      "IATA": "",
      "bar__2": "LIZ",
      "ICAO": "Canada",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 7892,
      "bar": "",
      "�װ����": "Air X Charter",
      "bar__1": "Air X Charter",
      "IATA": "",
      "bar__2": "AXY",
      "ICAO": "Malta",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 7893,
      "bar": "",
      "�װ����": "Air Ylang",
      "bar__1": "Air Ylang",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Comoros",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 7894,
      "bar": "",
      "�װ����": "Air2",
      "bar__1": "Air2",
      "IATA": "",
      "bar__2": "",
      "ICAO": "France",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 7895,
      "bar": "",
      "�װ����": "AirAsia",
      "bar__1": "AirAsia",
      "IATA": "AK",
      "bar__2": "AXM",
      "ICAO": "Malaysia",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 7896,
      "bar": "",
      "�װ����": "AirAsia Cambodia",
      "bar__1": "AirAsia Cambodia",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Cambodia",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 7124,
      "bar": "",
      "�װ����": "AirAsia India",
      "bar__1": "AirAsia India",
      "IATA": "I5",
      "bar__2": "IAD",
      "ICAO": "India",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 7933,
      "bar": "",
      "�װ����": "Albatros Airlines",
      "bar__1": "Albatros Airlines",
      "IATA": "",
      "bar__2": "GAL",
      "ICAO": "Venezuela",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 7730,
      "bar": "",
      "�װ����": "Albawings",
      "bar__1": "Albawings",
      "IATA": "2B",
      "bar__2": "AWT",
      "ICAO": "Albania",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 7934,
      "bar": "",
      "�װ����": "Alberta Central Airways",
      "bar__1": "Alberta Central Airways",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Canada",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 7935,
      "bar": "",
      "�װ����": "Alcon Servicios Aereos",
      "bar__1": "Alcon Servicios Aereos",
      "IATA": "",
      "bar__2": "AOA",
      "ICAO": "Mexico",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 7973,
      "bar": "",
      "�װ����": "Anda Air",
      "bar__1": "Anda Air",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Ukraine",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 7974,
      "bar": "",
      "�װ����": "Andes Lineas Aereas",
      "bar__1": "Andes Lineas Aereas",
      "IATA": "OY",
      "bar__2": "ANS",
      "ICAO": "Argentina",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 9340,
      "bar": "",
      "�װ����": "Andorra Airlines",
      "bar__1": "Andorra Airlines",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Spain",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 7975,
      "bar": "",
      "�װ����": "Angara Airlines",
      "bar__1": "Angara Airlines",
      "IATA": "2G",
      "bar__2": "AGU",
      "ICAO": "Russia",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 7976,
      "bar": "",
      "�װ����": "Angel Airways",
      "bar__1": "Angel Airways",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Bangladesh",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 7977,
      "bar": "",
      "�װ����": "Anglia Airways",
      "bar__1": "Anglia Airways",
      "IATA": "",
      "bar__2": "",
      "ICAO": "United Kingdom",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 7978,
      "bar": "",
      "�װ����": "Angola Air Charter",
      "bar__1": "Angola Air Charter",
      "IATA": "",
      "bar__2": "AGO",
      "ICAO": "Angola",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 9341,
      "bar": "",
      "�װ����": "Animawings",
      "bar__1": "Animawings",
      "IATA": "A2",
      "bar__2": "AWG",
      "ICAO": "Romania",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 7898,
      "bar": "",
      "�װ����": "AirAsia SriLanka",
      "bar__1": "AirAsia SriLanka",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Sri Lanka",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 7899,
      "bar": "",
      "�װ����": "Airbahn",
      "bar__1": "Airbahn",
      "IATA": "",
      "bar__2": "",
      "ICAO": "United States",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 7900,
      "bar": "",
      "�װ����": "airBaltic",
      "bar__1": "airBaltic",
      "IATA": "BT",
      "bar__2": "BTI",
      "ICAO": "Latvia",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 7901,
      "bar": "",
      "�װ����": "AirBridgeCargo Airlines",
      "bar__1": "AirBridgeCargo Airlines",
      "IATA": "RU",
      "bar__2": "ABW",
      "ICAO": "Russia",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 7902,
      "bar": "",
      "�װ����": "Airbus Transport International",
      "bar__1": "Airbus Transport International",
      "IATA": "4Y",
      "bar__2": "BGA",
      "ICAO": "France",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 7936,
      "bar": "",
      "�װ����": "Alexandria Airlines",
      "bar__1": "Alexandria Airlines",
      "IATA": "",
      "bar__2": "KHH",
      "ICAO": "Egypt",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 7979,
      "bar": "",
      "�װ����": "Antonov Airlines",
      "bar__1": "Antonov Airlines",
      "IATA": "",
      "bar__2": "ADB",
      "ICAO": "Ukraine",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 7980,
      "bar": "",
      "�װ����": "APEL Colombia",
      "bar__1": "APEL Colombia",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Colombia",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 7981,
      "bar": "",
      "�װ����": "APG Airlines",
      "bar__1": "APG Airlines",
      "IATA": "GP",
      "bar__2": "RIV",
      "ICAO": "France",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 7982,
      "bar": "",
      "�װ����": "Aqua Airlines",
      "bar__1": "Aqua Airlines",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Italy",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 9342,
      "bar": "",
      "�װ����": "Aquiline Austria",
      "bar__1": "Aquiline Austria",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Austria",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 7983,
      "bar": "",
      "�װ����": "Arab Wings",
      "bar__1": "Arab Wings",
      "IATA": "",
      "bar__2": "AWS",
      "ICAO": "Jordan",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 7904,
      "bar": "",
      "�װ����": "AirCruising Australia",
      "bar__1": "AirCruising Australia",
      "IATA": "",
      "bar__2": "AIX",
      "ICAO": "Australia",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 7905,
      "bar": "",
      "�װ����": "Airest",
      "bar__1": "Airest",
      "IATA": "",
      "bar__2": "AEG",
      "ICAO": "Estonia",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 7984,
      "bar": "",
      "�װ����": "Arctic Air Service",
      "bar__1": "Arctic Air Service",
      "IATA": "",
      "bar__2": "",
      "ICAO": "United States",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 7985,
      "bar": "",
      "�װ����": "Arctic Airlink",
      "bar__1": "Arctic Airlink",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Finland",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 7986,
      "bar": "",
      "�װ����": "Arctic Airways",
      "bar__1": "Arctic Airways",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Greenland",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 7987,
      "bar": "",
      "�װ����": "Arcus Air",
      "bar__1": "Arcus Air",
      "IATA": "ZE",
      "bar__2": "AZE",
      "ICAO": "Germany",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 7988,
      "bar": "",
      "�װ����": "ARGO",
      "bar__1": "ARGO",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Russia",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 7989,
      "bar": "",
      "�װ����": "Aria Air",
      "bar__1": "Aria Air",
      "IATA": "",
      "bar__2": "IRX",
      "ICAO": "Iran",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 7991,
      "bar": "",
      "�װ����": "Arik Air",
      "bar__1": "Arik Air",
      "IATA": "W3",
      "bar__2": "ARA",
      "ICAO": "Nigeria",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 7856,
      "bar": "",
      "�װ����": "Air Majoro",
      "bar__1": "Air Majoro",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Peru",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 7937,
      "bar": "",
      "�װ����": "AliBlue Malta",
      "bar__1": "AliBlue Malta",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Malta",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 7938,
      "bar": "",
      "�װ����": "Alidaunia",
      "bar__1": "Alidaunia",
      "IATA": "D4",
      "bar__2": "LID",
      "ICAO": "Italy",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 7939,
      "bar": "",
      "�װ����": "Alieurope",
      "bar__1": "Alieurope",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Malta",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 7992,
      "bar": "",
      "�װ����": "ARjet Airlines",
      "bar__1": "ARjet Airlines",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Argentina",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 7993,
      "bar": "",
      "�װ����": "Ark Airways",
      "bar__1": "Ark Airways",
      "IATA": "ZQ",
      "bar__2": "ARQ",
      "ICAO": "Armenia",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 7994,
      "bar": "",
      "�װ����": "Arkas",
      "bar__1": "Arkas",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Colombia",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 7857,
      "bar": "",
      "�װ����": "Air Maleo",
      "bar__1": "Air Maleo",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Indonesia",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 7940,
      "bar": "",
      "�װ����": "Alkan Air",
      "bar__1": "Alkan Air",
      "IATA": "",
      "bar__2": "AKN",
      "ICAO": "Canada",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 7941,
      "bar": "",
      "�װ����": "All West Freight",
      "bar__1": "All West Freight",
      "IATA": "",
      "bar__2": "",
      "ICAO": "United States",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 7942,
      "bar": "",
      "�װ����": "Allegiance Airways - Gabon",
      "bar__1": "Allegiance Airways - Gabon",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Gabon",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 7944,
      "bar": "",
      "�װ����": "Alliance Air Charter",
      "bar__1": "Alliance Air Charter",
      "IATA": "",
      "bar__2": "TTX",
      "ICAO": "United States",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 7945,
      "bar": "",
      "�װ����": "Alliance Airlines",
      "bar__1": "Alliance Airlines",
      "IATA": "QQ",
      "bar__2": "UTY",
      "ICAO": "Australia",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 7858,
      "bar": "",
      "�װ����": "Air Manas",
      "bar__1": "Air Manas",
      "IATA": "ZM",
      "bar__2": "MBB",
      "ICAO": "Kyrgyzstan",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 7859,
      "bar": "",
      "�װ����": "Air Mancora",
      "bar__1": "Air Mancora",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Peru",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 7860,
      "bar": "",
      "�װ����": "Air Mediterranean",
      "bar__1": "Air Mediterranean",
      "IATA": "MV",
      "bar__2": "MAR",
      "ICAO": "Greece",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 7906,
      "bar": "",
      "�װ����": "Airfast Indonesia",
      "bar__1": "Airfast Indonesia",
      "IATA": "FS",
      "bar__2": "AFE",
      "ICAO": "Indonesia",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 9339,
      "bar": "",
      "�װ����": "AirGeoSky",
      "bar__1": "AirGeoSky",
      "IATA": "D4",
      "bar__2": "GEL",
      "ICAO": "Georgia",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 7946,
      "bar": "",
      "�װ����": "Alliance Airlines",
      "bar__1": "Alliance Airlines",
      "IATA": "3A",
      "bar__2": "",
      "ICAO": "United States",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 7947,
      "bar": "",
      "�װ����": "ALLibo Air Cargo",
      "bar__1": "ALLibo Air Cargo",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Libya",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 7948,
      "bar": "",
      "�װ����": "Allied Air",
      "bar__1": "Allied Air",
      "IATA": "4W",
      "bar__2": "AJK",
      "ICAO": "Nigeria",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 7951,
      "bar": "",
      "�װ����": "Aloha Air Cargo",
      "bar__1": "Aloha Air Cargo",
      "IATA": "KH",
      "bar__2": "AAH",
      "ICAO": "United States",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 7952,
      "bar": "",
      "�װ����": "Alok Air",
      "bar__1": "Alok Air",
      "IATA": "",
      "bar__2": "LOK",
      "ICAO": "Sudan",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 7848,
      "bar": "",
      "�װ����": "Air Lanna",
      "bar__1": "Air Lanna",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Thailand",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 7849,
      "bar": "",
      "�װ����": "Air LEAP",
      "bar__1": "Air LEAP",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Norway",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 7861,
      "bar": "",
      "�װ����": "Air Million Cargo Charter",
      "bar__1": "Air Million Cargo Charter",
      "IATA": "",
      "bar__2": "",
      "ICAO": "South Africa",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 7907,
      "bar": "",
      "�װ����": "Airgreen SrL",
      "bar__1": "Airgreen SrL",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Italy",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 7908,
      "bar": "",
      "�װ����": "Airinter 1",
      "bar__1": "Airinter 1",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Chad",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 7909,
      "bar": "",
      "�װ����": "AirJet",
      "bar__1": "AirJet",
      "IATA": "",
      "bar__2": "MBC",
      "ICAO": "Angola",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 7954,
      "bar": "",
      "�װ����": "Alpha Star Aviation",
      "bar__1": "Alpha Star Aviation",
      "IATA": "",
      "bar__2": "STT",
      "ICAO": "Saudi Arabia",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 7955,
      "bar": "",
      "�װ����": "Alpine Air Express",
      "bar__1": "Alpine Air Express",
      "IATA": "5A",
      "bar__2": "AIP",
      "ICAO": "United States",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 7864,
      "bar": "",
      "�װ����": "Air Ouest",
      "bar__1": "Air Ouest",
      "IATA": "",
      "bar__2": "",
      "ICAO": "France",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 7865,
      "bar": "",
      "�װ����": "Air Panama",
      "bar__1": "Air Panama",
      "IATA": "7P",
      "bar__2": "PST",
      "ICAO": "Panama",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 7866,
      "bar": "",
      "�װ����": "Air Peace",
      "bar__1": "Air Peace",
      "IATA": "P4",
      "bar__2": "APK",
      "ICAO": "Nigeria",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 7868,
      "bar": "",
      "�װ����": "Air Prishtina",
      "bar__1": "Air Prishtina",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Kosovo",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 7869,
      "bar": "",
      "�װ����": "Air Republiq",
      "bar__1": "Air Republiq",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Philippines",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 7870,
      "bar": "",
      "�װ����": "Air Safaris",
      "bar__1": "Air Safaris",
      "IATA": "",
      "bar__2": "SRI",
      "ICAO": "New Zealand",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 7871,
      "bar": "",
      "�װ����": "Air Scandic",
      "bar__1": "Air Scandic",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Finland",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 7872,
      "bar": "",
      "�װ����": "Air Senegal",
      "bar__1": "Air Senegal",
      "IATA": "HC",
      "bar__2": "SZN",
      "ICAO": "Senegal",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 7910,
      "bar": "",
      "�װ����": "AirKenya EXPRESS",
      "bar__1": "AirKenya EXPRESS",
      "IATA": "P2",
      "bar__2": "XAK",
      "ICAO": "Kenya",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 7956,
      "bar": "",
      "�װ����": "Alpine Lakes Air",
      "bar__1": "Alpine Lakes Air",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Canada",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 7850,
      "bar": "",
      "�װ����": "Air Leasing Cameroon",
      "bar__1": "Air Leasing Cameroon",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Cameroon",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 7873,
      "bar": "",
      "�װ����": "Air SGS",
      "bar__1": "Air SGS",
      "IATA": "",
      "bar__2": "",
      "ICAO": "India",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 7874,
      "bar": "",
      "�װ����": "Air Shuttle",
      "bar__1": "Air Shuttle",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Ghana",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 7875,
      "bar": "",
      "�װ����": "Air Sial",
      "bar__1": "Air Sial",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Pakistan",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 7876,
      "bar": "",
      "�װ����": "Air Siem Reap",
      "bar__1": "Air Siem Reap",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Cambodia",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 7878,
      "bar": "",
      "�װ����": "Air South Charter",
      "bar__1": "Air South Charter",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Australia",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 7958,
      "bar": "",
      "�װ����": "Altai Airlines",
      "bar__1": "Altai Airlines",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Russia",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 7959,
      "bar": "",
      "�װ����": "Aluu Airlines",
      "bar__1": "Aluu Airlines",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Greenland",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 7960,
      "bar": "",
      "�װ����": "Amal",
      "bar__1": "Amal",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Malaysia",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 7961,
      "bar": "",
      "�װ����": "Amapola Flyg",
      "bar__1": "Amapola Flyg",
      "IATA": "HP",
      "bar__2": "APF",
      "ICAO": "Sweden",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 7879,
      "bar": "",
      "�װ����": "Air St. Kitts/Nevis",
      "bar__1": "Air St. Kitts/Nevis",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Saint Kitts and Nevis",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 7911,
      "bar": "",
      "�װ����": "Airline 4.0",
      "bar__1": "Airline 4.0",
      "IATA": "",
      "bar__2": "",
      "ICAO": "United States",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 7913,
      "bar": "",
      "�װ����": "Airly",
      "bar__1": "Airly",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Australia",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 7914,
      "bar": "",
      "�װ����": "AirMark Asia",
      "bar__1": "AirMark Asia",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Singapore",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 7915,
      "bar": "",
      "�װ����": "Airnavia",
      "bar__1": "Airnavia",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Denmark",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 7916,
      "bar": "",
      "�װ����": "AirNet Express",
      "bar__1": "AirNet Express",
      "IATA": "",
      "bar__2": "USC",
      "ICAO": "United States",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 7918,
      "bar": "",
      "�װ����": "Airpac Airlines",
      "bar__1": "Airpac Airlines",
      "IATA": "",
      "bar__2": "APC",
      "ICAO": "United States",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 7962,
      "bar": "",
      "�װ����": "Amaszonas Uruguay",
      "bar__1": "Amaszonas Uruguay",
      "IATA": "Z7",
      "bar__2": "AUZ",
      "ICAO": "Uruguay",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 7963,
      "bar": "",
      "�װ����": "Amazon Air",
      "bar__1": "Amazon Air",
      "IATA": "",
      "bar__2": "",
      "ICAO": "United States",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 7964,
      "bar": "",
      "�װ����": "Amazon Sky",
      "bar__1": "Amazon Sky",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Peru",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 7965,
      "bar": "",
      "�װ����": "Amazonair",
      "bar__1": "Amazonair",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Venezuela",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 7851,
      "bar": "",
      "�װ����": "Air Lebanon",
      "bar__1": "Air Lebanon",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Lebanon",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 9337,
      "bar": "",
      "�װ����": "Air Taxi India",
      "bar__1": "Air Taxi India",
      "IATA": "",
      "bar__2": "FAT",
      "ICAO": "India",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 7881,
      "bar": "",
      "�װ����": "Air Tetiaroa",
      "bar__1": "Air Tetiaroa",
      "IATA": "",
      "bar__2": "",
      "ICAO": "French Polynesia",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 9338,
      "bar": "",
      "�װ����": "Air Thanlwin",
      "bar__1": "Air Thanlwin",
      "IATA": "ST",
      "bar__2": "RTL",
      "ICAO": "Myanmar",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 7882,
      "bar": "",
      "�װ����": "Air Traffic Nairobi",
      "bar__1": "Air Traffic Nairobi",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Kenya",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 7883,
      "bar": "",
      "�װ����": "Air Transport International",
      "bar__1": "Air Transport International",
      "IATA": "8C",
      "bar__2": "ATN",
      "ICAO": "United States",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 7919,
      "bar": "",
      "�װ����": "Airsokol",
      "bar__1": "Airsokol",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Russia",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 7966,
      "bar": "",
      "�װ����": "AMC Airlines",
      "bar__1": "AMC Airlines",
      "IATA": "YJ",
      "bar__2": "AMV",
      "ICAO": "Egypt",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 7146,
      "bar": "",
      "�װ����": "Amelia Information",
      "bar__1": "Amelia Information",
      "IATA": "NL",
      "bar__2": "AEH",
      "ICAO": "Slovenia",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 7967,
      "bar": "",
      "�װ����": "American Jet",
      "bar__1": "American Jet",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Argentina",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 7968,
      "bar": "",
      "�װ����": "Ameriflight",
      "bar__1": "Ameriflight",
      "IATA": "A8",
      "bar__2": "AMF",
      "ICAO": "United States",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 7969,
      "bar": "",
      "�װ����": "Amerijet International",
      "bar__1": "Amerijet International",
      "IATA": "M6",
      "bar__2": "AJT",
      "ICAO": "United States",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 7104,
      "bar": "",
      "�װ����": "Air Travel",
      "bar__1": "Air Travel",
      "IATA": "A6",
      "bar__2": "OTC",
      "ICAO": "China",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 7884,
      "bar": "",
      "�װ����": "Air Tropiques",
      "bar__1": "Air Tropiques",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Democratic Republic of Congo",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 7885,
      "bar": "",
      "�װ����": "Air Trust",
      "bar__1": "Air Trust",
      "IATA": "",
      "bar__2": "RTR",
      "ICAO": "Kazakhstan",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 7886,
      "bar": "",
      "�װ����": "Air Tsolak",
      "bar__1": "Air Tsolak",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Russia",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 7887,
      "bar": "",
      "�װ����": "Air Urga",
      "bar__1": "Air Urga",
      "IATA": "3N",
      "bar__2": "URG",
      "ICAO": "Ukraine",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 7920,
      "bar": "",
      "�װ����": "AirSWIFT",
      "bar__1": "AirSWIFT",
      "IATA": "T6",
      "bar__2": "ATX",
      "ICAO": "Philippines",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 7921,
      "bar": "",
      "�װ����": "AirTaxi Sudan",
      "bar__1": "AirTaxi Sudan",
      "IATA": "",
      "bar__2": "WAM",
      "ICAO": "Sudan",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 7922,
      "bar": "",
      "�װ����": "Air-Tec Africa ACMI Leasing",
      "bar__1": "Air-Tec Africa ACMI Leasing",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Mauritius",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 7923,
      "bar": "",
      "�װ����": "Airwaves",
      "bar__1": "Airwaves",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Greece",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 7970,
      "bar": "",
      "�װ����": "Ameristar Charters",
      "bar__1": "Ameristar Charters",
      "IATA": "",
      "bar__2": "",
      "ICAO": "United States",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 7971,
      "bar": "",
      "�װ����": "Ameristar Jet Charter",
      "bar__1": "Ameristar Jet Charter",
      "IATA": "7Z",
      "bar__2": "AJI",
      "ICAO": "United States",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 9351,
      "bar": "",
      "�װ����": "Comores Aviation",
      "bar__1": "Comores Aviation",
      "IATA": "",
      "bar__2": "KMZ",
      "ICAO": "Comoros",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8201,
      "bar": "",
      "�װ����": "Compagnie Aerienne Maouene",
      "bar__1": "Compagnie Aerienne Maouene",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Republic of the Congo",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8202,
      "bar": "",
      "�װ����": "Conair Aviation",
      "bar__1": "Conair Aviation",
      "IATA": "",
      "bar__2": "FGD",
      "ICAO": "Canada",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8203,
      "bar": "",
      "�װ����": "Concors Company",
      "bar__1": "Concors Company",
      "IATA": "",
      "bar__2": "COS",
      "ICAO": "Latvia",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 7181,
      "bar": "",
      "�װ����": "Congo Airways",
      "bar__1": "Congo Airways",
      "IATA": "8Z",
      "bar__2": "CGA",
      "ICAO": "Democratic Republic of Congo",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8204,
      "bar": "",
      "�װ����": "Connect Cargo",
      "bar__1": "Connect Cargo",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Brazil",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8205,
      "bar": "",
      "�װ����": "Constanta Airlines",
      "bar__1": "Constanta Airlines",
      "IATA": "",
      "bar__2": "UZA",
      "ICAO": "Ukraine",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8206,
      "bar": "",
      "�װ����": "Contour Airlines",
      "bar__1": "Contour Airlines",
      "IATA": "LF",
      "bar__2": "VTE",
      "ICAO": "United States",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8207,
      "bar": "",
      "�װ����": "Converse Air",
      "bar__1": "Converse Air",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Russia",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8208,
      "bar": "",
      "�װ����": "Corendon Airlines",
      "bar__1": "Corendon Airlines",
      "IATA": "XC",
      "bar__2": "CAI",
      "ICAO": "Turkey",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8209,
      "bar": "",
      "�װ����": "Corendon Airlines Europe",
      "bar__1": "Corendon Airlines Europe",
      "IATA": "XR",
      "bar__2": "CXI",
      "ICAO": "Malta",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8210,
      "bar": "",
      "�װ����": "CorpJet",
      "bar__1": "CorpJet",
      "IATA": "",
      "bar__2": "BWE",
      "ICAO": "United States",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8212,
      "bar": "",
      "�װ����": "Corporate Air",
      "bar__1": "Corporate Air",
      "IATA": "",
      "bar__2": "CPT",
      "ICAO": "United States",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8213,
      "bar": "",
      "�װ����": "Cosmos Air Cargo",
      "bar__1": "Cosmos Air Cargo",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Colombia",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8214,
      "bar": "",
      "�װ����": "Costa Airlines",
      "bar__1": "Costa Airlines",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Venezuela",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8215,
      "bar": "",
      "�װ����": "Costa Rica Green Airways",
      "bar__1": "Costa Rica Green Airways",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Croatia",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8641,
      "bar": "",
      "�װ����": "Lijiang Airlines",
      "bar__1": "Lijiang Airlines",
      "IATA": "",
      "bar__2": "",
      "ICAO": "China",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8642,
      "bar": "",
      "�װ����": "Lima Airlines",
      "bar__1": "Lima Airlines",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Peru",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8644,
      "bar": "",
      "�װ����": "Linea de Aeroservicios",
      "bar__1": "Linea de Aeroservicios",
      "IATA": "",
      "bar__2": "LSE",
      "ICAO": "Chile",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8645,
      "bar": "",
      "�װ����": "Lineas Aereas del Sur",
      "bar__1": "Lineas Aereas del Sur",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Argentina",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8646,
      "bar": "",
      "�װ����": "Lineas Aereas Orientales",
      "bar__1": "Lineas Aereas Orientales",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Bolivia",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8647,
      "bar": "",
      "�װ����": "Lineas Aereas Peninsulares",
      "bar__1": "Lineas Aereas Peninsulares",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Spain",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8336,
      "bar": "",
      "�װ����": "Link Airways",
      "bar__1": "Link Airways",
      "IATA": "FC",
      "bar__2": "",
      "ICAO": "Australia",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 7132,
      "bar": "",
      "�װ����": "Link PNG",
      "bar__1": "Link PNG",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Papua New Guinea",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 6660,
      "bar": "",
      "�װ����": "Lion Airlines",
      "bar__1": "Lion Airlines",
      "IATA": "JT",
      "bar__2": "LNI",
      "ICAO": "Indonesia",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8648,
      "bar": "",
      "�װ����": "Lipetsk Avia",
      "bar__1": "Lipetsk Avia",
      "IATA": "",
      "bar__2": "LIP",
      "ICAO": "Russia",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8649,
      "bar": "",
      "�װ����": "Llanera Aviation SA",
      "bar__1": "Llanera Aviation SA",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Colombia",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8650,
      "bar": "",
      "�װ����": "Loganair",
      "bar__1": "Loganair",
      "IATA": "LM",
      "bar__2": "LOG",
      "ICAO": "United Kingdom",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8651,
      "bar": "",
      "�װ����": "Logistic Air",
      "bar__1": "Logistic Air",
      "IATA": "",
      "bar__2": "",
      "ICAO": "United States",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8652,
      "bar": "",
      "�װ����": "Lone Star Overnight",
      "bar__1": "Lone Star Overnight",
      "IATA": "",
      "bar__2": "",
      "ICAO": "United States",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8653,
      "bar": "",
      "�װ����": "Longhao Airlines",
      "bar__1": "Longhao Airlines",
      "IATA": "GI",
      "bar__2": "LHA",
      "ICAO": "China",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 7102,
      "bar": "",
      "�װ����": "Longjian Airline",
      "bar__1": "Longjian Airline",
      "IATA": "LT",
      "bar__2": "SNG",
      "ICAO": "China",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8654,
      "bar": "",
      "�װ����": "Loong Airlines",
      "bar__1": "Loong Airlines",
      "IATA": "GJ",
      "bar__2": "CDC",
      "ICAO": "China",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8655,
      "bar": "",
      "�װ����": "LOT Charters",
      "bar__1": "LOT Charters",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Poland",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8656,
      "bar": "",
      "�װ����": "LR Airlines",
      "bar__1": "LR Airlines",
      "IATA": "",
      "bar__2": "LRB",
      "ICAO": "Czech Republic",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8657,
      "bar": "",
      "�װ����": "LTyou",
      "bar__1": "LTyou",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Germany",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8658,
      "bar": "",
      "�װ����": "Lucky Air",
      "bar__1": "Lucky Air",
      "IATA": "8L",
      "bar__2": "LKE",
      "ICAO": "China",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8659,
      "bar": "",
      "�װ����": "Lufthansa",
      "bar__1": "Lufthansa",
      "IATA": "LH",
      "bar__2": "DLH",
      "ICAO": "Germany",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8660,
      "bar": "",
      "�װ����": "Lukiaviatrans",
      "bar__1": "Lukiaviatrans",
      "IATA": "",
      "bar__2": "LKV",
      "ICAO": "Russia",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8661,
      "bar": "",
      "�װ����": "Lukoil Avia",
      "bar__1": "Lukoil Avia",
      "IATA": "",
      "bar__2": "LUK",
      "ICAO": "Russia",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 9378,
      "bar": "",
      "�װ����": "Lulutai Airlines",
      "bar__1": "Lulutai Airlines",
      "IATA": "L8",
      "bar__2": "",
      "ICAO": "Tonga",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8662,
      "bar": "",
      "�װ����": "Lumiwings",
      "bar__1": "Lumiwings",
      "IATA": "",
      "bar__2": "LWI",
      "ICAO": "Greece",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8663,
      "bar": "",
      "�װ����": "Lydd Air",
      "bar__1": "Lydd Air",
      "IATA": "",
      "bar__2": "LYD",
      "ICAO": "France",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8664,
      "bar": "",
      "�װ����": "Lynden Air Cargo",
      "bar__1": "Lynden Air Cargo",
      "IATA": "L2",
      "bar__2": "LYC",
      "ICAO": "United States",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 9379,
      "bar": "",
      "�װ����": "M Jets International",
      "bar__1": "M Jets International",
      "IATA": "",
      "bar__2": "KXP",
      "ICAO": "Malaysia",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8665,
      "bar": "",
      "�װ����": "Mack Air",
      "bar__1": "Mack Air",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Botswana",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8666,
      "bar": "",
      "�װ����": "Madagasikara Airways",
      "bar__1": "Madagasikara Airways",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Madagascar",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 9085,
      "bar": "",
      "�װ����": "StarTrack",
      "bar__1": "StarTrack",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Australia",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 9086,
      "bar": "",
      "�װ����": "State Air",
      "bar__1": "State Air",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Russia",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 9088,
      "bar": "",
      "�װ����": "Subic International Air Charter",
      "bar__1": "Subic International Air Charter",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Philippines",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 9089,
      "bar": "",
      "�װ����": "Suburban Air Freight",
      "bar__1": "Suburban Air Freight",
      "IATA": "",
      "bar__2": "SUB",
      "ICAO": "United States",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 9090,
      "bar": "",
      "�װ����": "Suhura Airways",
      "bar__1": "Suhura Airways",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Somalia",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 9091,
      "bar": "",
      "�װ����": "Sukhoi Multipurpose Aircompany",
      "bar__1": "Sukhoi Multipurpose Aircompany",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Russia",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 9092,
      "bar": "",
      "�װ����": "Summit Air",
      "bar__1": "Summit Air",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Nepal",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 9093,
      "bar": "",
      "�װ����": "Summit Air Charters",
      "bar__1": "Summit Air Charters",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Canada",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 9094,
      "bar": "",
      "�װ����": "Summit Aviation Pvt",
      "bar__1": "Summit Aviation Pvt",
      "IATA": "",
      "bar__2": "",
      "ICAO": "India",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 9096,
      "bar": "",
      "�װ����": "Sun Country Airlines",
      "bar__1": "Sun Country Airlines",
      "IATA": "SY",
      "bar__2": "SCX",
      "ICAO": "United States",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 9098,
      "bar": "",
      "�װ����": "Sundair",
      "bar__1": "Sundair",
      "IATA": "SR",
      "bar__2": "SDR",
      "ICAO": "Germany",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 9099,
      "bar": "",
      "�װ����": "Sundance Air",
      "bar__1": "Sundance Air",
      "IATA": "",
      "bar__2": "SUV",
      "ICAO": "Venezuela",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 9100,
      "bar": "",
      "�װ����": "Sunday Airlines",
      "bar__1": "Sunday Airlines",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Kazakhstan",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 9101,
      "bar": "",
      "�װ����": "SunExpress",
      "bar__1": "SunExpress",
      "IATA": "XQ",
      "bar__2": "SXS",
      "ICAO": "Turkey",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 9103,
      "bar": "",
      "�װ����": "Sunkar Air",
      "bar__1": "Sunkar Air",
      "IATA": "",
      "bar__2": "KAM",
      "ICAO": "Kazakhstan",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 9104,
      "bar": "",
      "�װ����": "Sunstate Airlines",
      "bar__1": "Sunstate Airlines",
      "IATA": "QF",
      "bar__2": "QLK",
      "ICAO": "Australia",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 9105,
      "bar": "",
      "�װ����": "Sunwing Airlines",
      "bar__1": "Sunwing Airlines",
      "IATA": "WG",
      "bar__2": "SWG",
      "ICAO": "Canada",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 9106,
      "bar": "",
      "�װ����": "Suparna Airlines",
      "bar__1": "Suparna Airlines",
      "IATA": "Y8",
      "bar__2": "YZR",
      "ICAO": "China",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 9107,
      "bar": "",
      "�װ����": "Superior Airways",
      "bar__1": "Superior Airways",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Canada",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 9108,
      "bar": "",
      "�װ����": "Surf Air",
      "bar__1": "Surf Air",
      "IATA": "",
      "bar__2": "URF",
      "ICAO": "United States",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 9109,
      "bar": "",
      "�װ����": "Sustut Air",
      "bar__1": "Sustut Air",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Canada",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 9111,
      "bar": "",
      "�װ����": "SVG Air",
      "bar__1": "SVG Air",
      "IATA": "",
      "bar__2": "SVD",
      "ICAO": "Saint Vincent and the Grenadines",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 9112,
      "bar": "",
      "�װ����": "SW Italia",
      "bar__1": "SW Italia",
      "IATA": "IU",
      "bar__2": "CSW",
      "ICAO": "Italy",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 9113,
      "bar": "",
      "�װ����": "Swala Aviation",
      "bar__1": "Swala Aviation",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Republic of the Congo",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 9114,
      "bar": "",
      "�װ����": "Swanberg Air",
      "bar__1": "Swanberg Air",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Canada",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 9116,
      "bar": "",
      "�װ����": "Swiftair",
      "bar__1": "Swiftair",
      "IATA": "WT",
      "bar__2": "SWT",
      "ICAO": "Spain",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 9117,
      "bar": "",
      "�װ����": "Swiftair Hellas",
      "bar__1": "Swiftair Hellas",
      "IATA": "",
      "bar__2": "MDF",
      "ICAO": "Greece",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 9118,
      "bar": "",
      "�װ����": "SWISS",
      "bar__1": "SWISS",
      "IATA": "LX",
      "bar__2": "SWR",
      "ICAO": "Switzerland",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 9119,
      "bar": "",
      "�װ����": "Swiss Skies",
      "bar__1": "Swiss Skies",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Switzerland",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 9120,
      "bar": "",
      "�װ����": "Swoop",
      "bar__1": "Swoop",
      "IATA": "WO",
      "bar__2": "WSW",
      "ICAO": "Canada",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 9121,
      "bar": "",
      "�װ����": "SXM Airways",
      "bar__1": "SXM Airways",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Saint Martin",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 9122,
      "bar": "",
      "�װ����": "Sylt Air",
      "bar__1": "Sylt Air",
      "IATA": "7E",
      "bar__2": "AWU",
      "ICAO": "Germany",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 9123,
      "bar": "",
      "�װ����": "Synergy Aviation",
      "bar__1": "Synergy Aviation",
      "IATA": "YD",
      "bar__2": "SYG",
      "ICAO": "United Kingdom",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 9124,
      "bar": "",
      "�װ����": "Syrian Airlines",
      "bar__1": "Syrian Airlines",
      "IATA": "RB",
      "bar__2": "SYR",
      "ICAO": "Syria",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8030,
      "bar": "",
      "�װ����": "Avialift Vladivostok",
      "bar__1": "Avialift Vladivostok",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Russia",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8032,
      "bar": "",
      "�װ����": "Avianca Cargo",
      "bar__1": "Avianca Cargo",
      "IATA": "QT",
      "bar__2": "TPA",
      "ICAO": "Colombia",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8033,
      "bar": "",
      "�װ����": "Avianca Costa Rica",
      "bar__1": "Avianca Costa Rica",
      "IATA": "LR",
      "bar__2": "LRC",
      "ICAO": "Croatia",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8034,
      "bar": "",
      "�װ����": "Avianca Ecuador",
      "bar__1": "Avianca Ecuador",
      "IATA": "2K",
      "bar__2": "GLG",
      "ICAO": "Ecuador",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8035,
      "bar": "",
      "�װ����": "Aviaobshchemash",
      "bar__1": "Aviaobshchemash",
      "IATA": "",
      "bar__2": "OBM",
      "ICAO": "Russia",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8036,
      "bar": "",
      "�װ����": "Aviashelf",
      "bar__1": "Aviashelf",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Russia",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8216,
      "bar": "",
      "�װ����": "Coturisca SA",
      "bar__1": "Coturisca SA",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Dominican Republic",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8217,
      "bar": "",
      "�װ����": "Courtesy Air",
      "bar__1": "Courtesy Air",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Canada",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8218,
      "bar": "",
      "�װ����": "Coyne Airways",
      "bar__1": "Coyne Airways",
      "IATA": "7C",
      "bar__2": "COY",
      "ICAO": "United Kingdom",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8219,
      "bar": "",
      "�װ����": "Cruzeiro Taxi Aereo",
      "bar__1": "Cruzeiro Taxi Aereo",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Brazil",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8220,
      "bar": "",
      "�װ����": "Crystal AirCruises",
      "bar__1": "Crystal AirCruises",
      "IATA": "",
      "bar__2": "",
      "ICAO": "United States",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8221,
      "bar": "",
      "�װ����": "Crystal Luxury Air",
      "bar__1": "Crystal Luxury Air",
      "IATA": "",
      "bar__2": "",
      "ICAO": "United States",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8222,
      "bar": "",
      "�װ����": "CSA Air",
      "bar__1": "CSA Air",
      "IATA": "",
      "bar__2": "IRO",
      "ICAO": "United States",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8223,
      "bar": "",
      "�װ����": "CV Cargo",
      "bar__1": "CV Cargo",
      "IATA": "",
      "bar__2": "GSE",
      "ICAO": "Colombia",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8224,
      "bar": "",
      "�װ����": "Cygnus Air",
      "bar__1": "Cygnus Air",
      "IATA": "",
      "bar__2": "RGN",
      "ICAO": "Spain",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8225,
      "bar": "",
      "�װ����": "Czech Airlines",
      "bar__1": "Czech Airlines",
      "IATA": "OK",
      "bar__2": "CSA",
      "ICAO": "Czech Republic",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8226,
      "bar": "",
      "�װ����": "DAC Aviation",
      "bar__1": "DAC Aviation",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Kenya",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8227,
      "bar": "",
      "�װ����": "Daily Air",
      "bar__1": "Daily Air",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Taiwan",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8228,
      "bar": "",
      "�װ����": "Dalian Airlines",
      "bar__1": "Dalian Airlines",
      "IATA": "CA",
      "bar__2": "CCD",
      "ICAO": "China",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8229,
      "bar": "",
      "�װ����": "Damal Airlines",
      "bar__1": "Damal Airlines",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Central African Republic",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8230,
      "bar": "",
      "�װ����": "Dauria",
      "bar__1": "Dauria",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Russia",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8231,
      "bar": "",
      "�װ����": "DC Aviation",
      "bar__1": "DC Aviation",
      "IATA": "",
      "bar__2": "DCS",
      "ICAO": "Germany",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8232,
      "bar": "",
      "�װ����": "Deccan Charters",
      "bar__1": "Deccan Charters",
      "IATA": "NS",
      "bar__2": "DKN",
      "ICAO": "India",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8233,
      "bar": "",
      "�װ����": "Delbitur",
      "bar__1": "Delbitur",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Uruguay",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8234,
      "bar": "",
      "�װ����": "Delcar Express",
      "bar__1": "Delcar Express",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Paraguay",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8235,
      "bar": "",
      "�װ����": "Delta K",
      "bar__1": "Delta K",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Russia",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8236,
      "bar": "",
      "�װ����": "Delta World Charter",
      "bar__1": "Delta World Charter",
      "IATA": "",
      "bar__2": "",
      "ICAO": "United Arab Emirates",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8237,
      "bar": "",
      "�װ����": "Denver Air Connection",
      "bar__1": "Denver Air Connection",
      "IATA": "",
      "bar__2": "",
      "ICAO": "United States",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8238,
      "bar": "",
      "�װ����": "Deraya Air Taxi",
      "bar__1": "Deraya Air Taxi",
      "IATA": "",
      "bar__2": "DRY",
      "ICAO": "Indonesia",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8239,
      "bar": "",
      "�װ����": "Desert Air",
      "bar__1": "Desert Air",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Namibia",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8240,
      "bar": "",
      "�װ����": "Destination Air",
      "bar__1": "Destination Air",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Thailand",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8241,
      "bar": "",
      "�װ����": "Dexter",
      "bar__1": "Dexter",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Russia",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8242,
      "bar": "",
      "�װ����": "DHL Aero Expreso",
      "bar__1": "DHL Aero Expreso",
      "IATA": "D5",
      "bar__2": "DAE",
      "ICAO": "Panama",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8243,
      "bar": "",
      "�װ����": "DHL Air UK",
      "bar__1": "DHL Air UK",
      "IATA": "D0",
      "bar__2": "DHK",
      "ICAO": "United Kingdom",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8244,
      "bar": "",
      "�װ����": "DHL de Guatemala",
      "bar__1": "DHL de Guatemala",
      "IATA": "L3",
      "bar__2": "JOS",
      "ICAO": "Guatemala",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8245,
      "bar": "",
      "�װ����": "DHL International Aviation ME",
      "bar__1": "DHL International Aviation ME",
      "IATA": "ES",
      "bar__2": "DHX",
      "ICAO": "Bahrain",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8246,
      "bar": "",
      "�װ����": "Diexim Expresso",
      "bar__1": "Diexim Expresso",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Angola",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8247,
      "bar": "",
      "�װ����": "Dimonim Air",
      "bar__1": "Dimonim Air",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Indonesia",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8667,
      "bar": "",
      "�װ����": "MAE Jet Charters",
      "bar__1": "MAE Jet Charters",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Bahrain",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8668,
      "bar": "",
      "�װ����": "Magma Aviation",
      "bar__1": "Magma Aviation",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Belgium",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8669,
      "bar": "",
      "�װ����": "Magnicharters",
      "bar__1": "Magnicharters",
      "IATA": "",
      "bar__2": "GMT",
      "ICAO": "Mexico",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8670,
      "bar": "",
      "�װ����": "Mahogany Air",
      "bar__1": "Mahogany Air",
      "IATA": "",
      "bar__2": "HOG",
      "ICAO": "Zambia",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8671,
      "bar": "",
      "�װ����": "MAIS Mozambican Airlines",
      "bar__1": "MAIS Mozambican Airlines",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Mozambique",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8672,
      "bar": "",
      "�װ����": "Major's Air Services",
      "bar__1": "Major's Air Services",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Bahamas",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8673,
      "bar": "",
      "�װ����": "Makalu Air",
      "bar__1": "Makalu Air",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Nepal",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 7183,
      "bar": "",
      "�װ����": "Malawian AIrlines",
      "bar__1": "Malawian AIrlines",
      "IATA": "3W",
      "bar__2": "MWI",
      "ICAO": "Malawi",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8674,
      "bar": "",
      "�װ����": "Maldivian Air Taxi",
      "bar__1": "Maldivian Air Taxi",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Maldives",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8676,
      "bar": "",
      "�װ����": "Mani Air Fret",
      "bar__1": "Mani Air Fret",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Republic of the Congo",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 7120,
      "bar": "",
      "�װ����": "Mann Yadanarpon Airlines",
      "bar__1": "Mann Yadanarpon Airlines",
      "IATA": "7Y",
      "bar__2": "MYP",
      "ICAO": "Myanmar",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8677,
      "bar": "",
      "�װ����": "Manta Air",
      "bar__1": "Manta Air",
      "IATA": "NR",
      "bar__2": "MAV",
      "ICAO": "Maldives",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8678,
      "bar": "",
      "�װ����": "MAP Linhas Aereas",
      "bar__1": "MAP Linhas Aereas",
      "IATA": "7M",
      "bar__2": "PAM",
      "ICAO": "Brazil",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8679,
      "bar": "",
      "�װ����": "Maria da Gloria Transportes Aereos",
      "bar__1": "Maria da Gloria Transportes Aereos",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Brazil",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8680,
      "bar": "",
      "�װ����": "Maroomba Airlines",
      "bar__1": "Maroomba Airlines",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Australia",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 9380,
      "bar": "",
      "�װ����": "Mars Avia",
      "bar__1": "Mars Avia",
      "IATA": "",
      "bar__2": "MRS",
      "ICAO": "Armenia",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8681,
      "bar": "",
      "�װ����": "Marsrosto",
      "bar__1": "Marsrosto",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Russia",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8682,
      "bar": "",
      "�װ����": "MASwings",
      "bar__1": "MASwings",
      "IATA": "MY",
      "bar__2": "MWG",
      "ICAO": "Malaysia",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8683,
      "bar": "",
      "�װ����": "Maverick Airlines",
      "bar__1": "Maverick Airlines",
      "IATA": "",
      "bar__2": "",
      "ICAO": "United States",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8684,
      "bar": "",
      "�װ����": "Maverick Helicopters",
      "bar__1": "Maverick Helicopters",
      "IATA": "",
      "bar__2": "",
      "ICAO": "United States",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8685,
      "bar": "",
      "�װ����": "Max Air",
      "bar__1": "Max Air",
      "IATA": "VM",
      "bar__2": "NGL",
      "ICAO": "Nigeria",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 9125,
      "bar": "",
      "�װ����": "TAAN",
      "bar__1": "TAAN",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Venezuela",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 9126,
      "bar": "",
      "�װ����": "TAC - Transporte Aereo De Colombia",
      "bar__1": "TAC - Transporte Aereo De Colombia",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Colombia",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 9127,
      "bar": "",
      "�װ����": "TACA Peru",
      "bar__1": "TACA Peru",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Peru",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 9128,
      "bar": "",
      "�װ����": "Tahiti Air Charter",
      "bar__1": "Tahiti Air Charter",
      "IATA": "",
      "bar__2": "",
      "ICAO": "French Polynesia",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 9129,
      "bar": "",
      "�װ����": "Tahiti Seaplanes",
      "bar__1": "Tahiti Seaplanes",
      "IATA": "",
      "bar__2": "",
      "ICAO": "French Polynesia",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 9130,
      "bar": "",
      "�װ����": "Take Air",
      "bar__1": "Take Air",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Belgium",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 9131,
      "bar": "",
      "�װ����": "Talofa Airways",
      "bar__1": "Talofa Airways",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Samoa",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 9132,
      "bar": "",
      "�װ����": "Tanana Air Service",
      "bar__1": "Tanana Air Service",
      "IATA": "Z3",
      "bar__2": "TNR",
      "ICAO": "United States",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 9133,
      "bar": "",
      "�װ����": "TAPC Aviatrans",
      "bar__1": "TAPC Aviatrans",
      "IATA": "",
      "bar__2": "CTP",
      "ICAO": "Uzbekistan",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 9134,
      "bar": "",
      "�װ����": "TAPSA - Transportes Aereos Petroleros",
      "bar__1": "TAPSA - Transportes Aereos Petroleros",
      "IATA": "",
      "bar__2": "TPS",
      "ICAO": "Argentina",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 9135,
      "bar": "",
      "�װ����": "Taquan Air",
      "bar__1": "Taquan Air",
      "IATA": "K3",
      "bar__2": "TQN",
      "ICAO": "United States",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 7161,
      "bar": "",
      "�װ����": "TAR Aerolineas",
      "bar__1": "TAR Aerolineas",
      "IATA": "YQ",
      "bar__2": "LCT",
      "ICAO": "Mexico",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 9136,
      "bar": "",
      "�װ����": "Tara Air",
      "bar__1": "Tara Air",
      "IATA": "TB",
      "bar__2": "TRA",
      "ICAO": "Nepal",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 9137,
      "bar": "",
      "�װ����": "Tara Helicopter Company",
      "bar__1": "Tara Helicopter Company",
      "IATA": "",
      "bar__2": "IRR",
      "ICAO": "Iran",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 9138,
      "bar": "",
      "�װ����": "Tarco Airlines",
      "bar__1": "Tarco Airlines",
      "IATA": "3T",
      "bar__2": "TQQ",
      "ICAO": "Sudan",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 9140,
      "bar": "",
      "�װ����": "Tasman Cargo Airlines",
      "bar__1": "Tasman Cargo Airlines",
      "IATA": "HJ",
      "bar__2": "TMN",
      "ICAO": "Australia",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 9141,
      "bar": "",
      "�װ����": "Tassili Airlines",
      "bar__1": "Tassili Airlines",
      "IATA": "SF",
      "bar__2": "DTH",
      "ICAO": "Algeria",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 9142,
      "bar": "",
      "�װ����": "Tatra Jet",
      "bar__1": "Tatra Jet",
      "IATA": "",
      "bar__2": "TTJ",
      "ICAO": "Slovakia",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 9143,
      "bar": "",
      "�װ����": "Tausani Airlines",
      "bar__1": "Tausani Airlines",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Samoa",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 9144,
      "bar": "",
      "�װ����": "Tawakal Airlines",
      "bar__1": "Tawakal Airlines",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Kenya",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 9145,
      "bar": "",
      "�װ����": "Taxi Aereo Geral",
      "bar__1": "Taxi Aereo Geral",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Brazil",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 9146,
      "bar": "",
      "�װ����": "Tayaran Jet",
      "bar__1": "Tayaran Jet",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Bulgaria",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 9147,
      "bar": "",
      "�װ����": "Tbilaviamsheni Georgia",
      "bar__1": "Tbilaviamsheni Georgia",
      "IATA": "L6",
      "bar__2": "",
      "ICAO": "Georgia",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 9148,
      "bar": "",
      "�װ����": "Tbilisi Airlines",
      "bar__1": "Tbilisi Airlines",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Georgia",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 9149,
      "bar": "",
      "�װ����": "Tchadia Airlines",
      "bar__1": "Tchadia Airlines",
      "IATA": "OT",
      "bar__2": "CDO",
      "ICAO": "Chad",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 9150,
      "bar": "",
      "�װ����": "Tenir Airlines",
      "bar__1": "Tenir Airlines",
      "IATA": "",
      "bar__2": "TEB",
      "ICAO": "Kyrgyzstan",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 9152,
      "bar": "",
      "�װ����": "Texas Air Shuttle",
      "bar__1": "Texas Air Shuttle",
      "IATA": "",
      "bar__2": "",
      "ICAO": "United States",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 9153,
      "bar": "",
      "�װ����": "Texas Sky Airways",
      "bar__1": "Texas Sky Airways",
      "IATA": "",
      "bar__2": "",
      "ICAO": "United States",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 9154,
      "bar": "",
      "�װ����": "Texel Air",
      "bar__1": "Texel Air",
      "IATA": "",
      "bar__2": "XLR",
      "ICAO": "Bahrain",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 9155,
      "bar": "",
      "�װ����": "Tez Jet Airlines",
      "bar__1": "Tez Jet Airlines",
      "IATA": "",
      "bar__2": "TEZ",
      "ICAO": "Kyrgyzstan",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 7118,
      "bar": "",
      "�װ����": "Thai AirAsia X",
      "bar__1": "Thai AirAsia X",
      "IATA": "XJ",
      "bar__2": "TAX",
      "ICAO": "Thailand",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 9156,
      "bar": "",
      "�װ����": "Thai Express Air",
      "bar__1": "Thai Express Air",
      "IATA": "",
      "bar__2": "TXZ",
      "ICAO": "Thailand",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 7116,
      "bar": "",
      "�װ����": "Thai Lion Air",
      "bar__1": "Thai Lion Air",
      "IATA": "SL",
      "bar__2": "TLM",
      "ICAO": "Thailand",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8037,
      "bar": "",
      "�װ����": "Aviastar-TU",
      "bar__1": "Aviastar-TU",
      "IATA": "4B",
      "bar__2": "TUP",
      "ICAO": "Russia",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8038,
      "bar": "",
      "�װ����": "Aviation Assistance International",
      "bar__1": "Aviation Assistance International",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Kenya",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8039,
      "bar": "",
      "�װ����": "Aviatrans",
      "bar__1": "Aviatrans",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Sudan",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 7168,
      "bar": "",
      "�װ����": "Aviatsa",
      "bar__1": "Aviatsa",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Honduras",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8040,
      "bar": "",
      "�װ����": "AVIC Cargo Airlines",
      "bar__1": "AVIC Cargo Airlines",
      "IATA": "",
      "bar__2": "",
      "ICAO": "China",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8041,
      "bar": "",
      "�װ����": "Avioandes",
      "bar__1": "Avioandes",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Ecuador",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8042,
      "bar": "",
      "�װ����": "Aviolet",
      "bar__1": "Aviolet",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Serbia",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8248,
      "bar": "",
      "�װ����": "Direct Avia",
      "bar__1": "Direct Avia",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Russia",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8250,
      "bar": "",
      "�װ����": "Dodson International Charter",
      "bar__1": "Dodson International Charter",
      "IATA": "",
      "bar__2": "",
      "ICAO": "South Africa",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8252,
      "bar": "",
      "�װ����": "Domrey Angkor Airlines",
      "bar__1": "Domrey Angkor Airlines",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Cambodia",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8253,
      "bar": "",
      "�װ����": "Douniah Airlines",
      "bar__1": "Douniah Airlines",
      "IATA": "DH",
      "bar__2": "",
      "ICAO": "Mali",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8254,
      "bar": "",
      "�װ����": "Dove Air Services",
      "bar__1": "Dove Air Services",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Sudan",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8255,
      "bar": "",
      "�װ����": "Dream Wind",
      "bar__1": "Dream Wind",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Ukraine",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8256,
      "bar": "",
      "�װ����": "Dubnica Air",
      "bar__1": "Dubnica Air",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Slovakia",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8257,
      "bar": "",
      "�װ����": "Dynamic Aviation Group",
      "bar__1": "Dynamic Aviation Group",
      "IATA": "",
      "bar__2": "",
      "ICAO": "United States",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8258,
      "bar": "",
      "�װ����": "Eagle Air",
      "bar__1": "Eagle Air",
      "IATA": "H7",
      "bar__2": "EGU",
      "ICAO": "Uganda",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8259,
      "bar": "",
      "�װ����": "Eagle Air Iceland",
      "bar__1": "Eagle Air Iceland",
      "IATA": "IS",
      "bar__2": "FEI",
      "ICAO": "Iceland",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8260,
      "bar": "",
      "�װ����": "Eagle Air Transport",
      "bar__1": "Eagle Air Transport",
      "IATA": "",
      "bar__2": "",
      "ICAO": "United States",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8261,
      "bar": "",
      "�װ����": "Eagle Helicopters",
      "bar__1": "Eagle Helicopters",
      "IATA": "",
      "bar__2": "EZ9",
      "ICAO": "United States",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8262,
      "bar": "",
      "�װ����": "East Kazakhstan Region Air Enterprise",
      "bar__1": "East Kazakhstan Region Air Enterprise",
      "IATA": "",
      "bar__2": "UCK",
      "ICAO": "Kazakhstan",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8263,
      "bar": "",
      "�װ����": "EastAfrican",
      "bar__1": "EastAfrican",
      "IATA": "B5",
      "bar__2": "EXZ",
      "ICAO": "Kenya",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8265,
      "bar": "",
      "�װ����": "Eastindo Air Taxi & Charter",
      "bar__1": "Eastindo Air Taxi & Charter",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Indonesia",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8266,
      "bar": "",
      "�װ����": "East-Wind",
      "bar__1": "East-Wind",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Russia",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8267,
      "bar": "",
      "�װ����": "easyJet Europe",
      "bar__1": "easyJet Europe",
      "IATA": "EC",
      "bar__2": "EJU",
      "ICAO": "Australia",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8268,
      "bar": "",
      "�װ����": "easyJet Switzerland",
      "bar__1": "easyJet Switzerland",
      "IATA": "DS",
      "bar__2": "EZS",
      "ICAO": "Switzerland",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8269,
      "bar": "",
      "�װ����": "EasySky",
      "bar__1": "EasySky",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Honduras",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8270,
      "bar": "",
      "�װ����": "E-Cargo",
      "bar__1": "E-Cargo",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Russia",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8271,
      "bar": "",
      "�װ����": "EcoJet",
      "bar__1": "EcoJet",
      "IATA": "8J",
      "bar__2": "ECO",
      "ICAO": "Bolivia",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8272,
      "bar": "",
      "�װ����": "Efly",
      "bar__1": "Efly",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Malta",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 9352,
      "bar": "",
      "�װ����": "EGO Airways",
      "bar__1": "EGO Airways",
      "IATA": "E3",
      "bar__2": "EGW",
      "ICAO": "Italy",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8273,
      "bar": "",
      "�װ����": "EgyptAir Cargo",
      "bar__1": "EgyptAir Cargo",
      "IATA": "MS",
      "bar__2": "MSX",
      "ICAO": "Egypt",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8688,
      "bar": "",
      "�װ����": "Maximus Air Cargo",
      "bar__1": "Maximus Air Cargo",
      "IATA": "",
      "bar__2": "MXU",
      "ICAO": "United Arab Emirates",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8689,
      "bar": "",
      "�װ����": "MAYAir",
      "bar__1": "MAYAir",
      "IATA": "7M",
      "bar__2": "MYI",
      "ICAO": "Mexico",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8690,
      "bar": "",
      "�װ����": "McNeely Charter Service",
      "bar__1": "McNeely Charter Service",
      "IATA": "",
      "bar__2": "MDS",
      "ICAO": "United States",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8691,
      "bar": "",
      "�װ����": "MCS Aerocarga",
      "bar__1": "MCS Aerocarga",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Mexico",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8692,
      "bar": "",
      "�װ����": "MED Airlines",
      "bar__1": "MED Airlines",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Morocco",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8693,
      "bar": "",
      "�װ����": "Medavia",
      "bar__1": "Medavia",
      "IATA": "N5",
      "bar__2": "MDM",
      "ICAO": "Malta",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8694,
      "bar": "",
      "�װ����": "Meezab Aviation",
      "bar__1": "Meezab Aviation",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Pakistan",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8695,
      "bar": "",
      "�װ����": "MEGA",
      "bar__1": "MEGA",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Brazil",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8696,
      "bar": "",
      "�װ����": "Melilla Airlines",
      "bar__1": "Melilla Airlines",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Spain",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8697,
      "bar": "",
      "�װ����": "Mena Aerospace Cargo",
      "bar__1": "Mena Aerospace Cargo",
      "IATA": "",
      "bar__2": "MEN",
      "ICAO": "Bahrain",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8698,
      "bar": "",
      "�װ����": "Menorca Air",
      "bar__1": "Menorca Air",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Spain",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8699,
      "bar": "",
      "�װ����": "Mercury World Cargo",
      "bar__1": "Mercury World Cargo",
      "IATA": "4X",
      "bar__2": "MEC",
      "ICAO": "United States",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8700,
      "bar": "",
      "�װ����": "Meridian Air Charter",
      "bar__1": "Meridian Air Charter",
      "IATA": "",
      "bar__2": "",
      "ICAO": "United States",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8701,
      "bar": "",
      "�װ����": "Mesco Airlines",
      "bar__1": "Mesco Airlines",
      "IATA": "",
      "bar__2": "",
      "ICAO": "India",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8702,
      "bar": "",
      "�װ����": "Metro Manila Airways International",
      "bar__1": "Metro Manila Airways International",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Philippines",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8703,
      "bar": "",
      "�װ����": "Metropolitan Airways",
      "bar__1": "Metropolitan Airways",
      "IATA": "",
      "bar__2": "",
      "ICAO": "United States",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8704,
      "bar": "",
      "�װ����": "MGC Airlines",
      "bar__1": "MGC Airlines",
      "IATA": "",
      "bar__2": "",
      "ICAO": "United States",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8705,
      "bar": "",
      "�װ����": "Miami Air International",
      "bar__1": "Miami Air International",
      "IATA": "LL",
      "bar__2": "BSK",
      "ICAO": "United States",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8706,
      "bar": "",
      "�װ����": "MIAT Mongolian Airlines",
      "bar__1": "MIAT Mongolian Airlines",
      "IATA": "OM",
      "bar__2": "MGL",
      "ICAO": "Mongolia",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8707,
      "bar": "",
      "�װ����": "Mid Airlines",
      "bar__1": "Mid Airlines",
      "IATA": "7Y",
      "bar__2": "NYL",
      "ICAO": "Sudan",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8708,
      "bar": "",
      "�װ����": "Mid Express Tchad",
      "bar__1": "Mid Express Tchad",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Chad",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8709,
      "bar": "",
      "�װ����": "Mid-Atlantic Freight",
      "bar__1": "Mid-Atlantic Freight",
      "IATA": "",
      "bar__2": "M5F",
      "ICAO": "United States",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 989,
      "bar": "",
      "�װ����": "Midex Airlines",
      "bar__1": "Midex Airlines",
      "IATA": "",
      "bar__2": "MIX",
      "ICAO": "United Arab Emirates",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8710,
      "bar": "",
      "�װ����": "Mid-Sea Express",
      "bar__1": "Mid-Sea Express",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Philippines",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8712,
      "bar": "",
      "�װ����": "Milenium Air",
      "bar__1": "Milenium Air",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Argentina",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8713,
      "bar": "",
      "�װ����": "Mimika Air",
      "bar__1": "Mimika Air",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Indonesia",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8714,
      "bar": "",
      "�װ����": "Minair",
      "bar__1": "Minair",
      "IATA": "",
      "bar__2": "OMR",
      "ICAO": "Central African Republic",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8715,
      "bar": "",
      "�װ����": "Mineral Airways",
      "bar__1": "Mineral Airways",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Chile",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8716,
      "bar": "",
      "�װ����": "Missinippi Airways",
      "bar__1": "Missinippi Airways",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Canada",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8717,
      "bar": "",
      "�װ����": "Mission Aviation Fellowship - MAF",
      "bar__1": "Mission Aviation Fellowship - MAF",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Australia",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8718,
      "bar": "",
      "�װ����": "Mistral Air",
      "bar__1": "Mistral Air",
      "IATA": "M4",
      "bar__2": "MSA",
      "ICAO": "Italy",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8719,
      "bar": "",
      "�װ����": "Misty Fjords Air",
      "bar__1": "Misty Fjords Air",
      "IATA": "",
      "bar__2": "",
      "ICAO": "United States",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8720,
      "bar": "",
      "�װ����": "MJ Airlines",
      "bar__1": "MJ Airlines",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Cambodia",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8721,
      "bar": "",
      "�װ����": "MN Aviation",
      "bar__1": "MN Aviation",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Puerto Rico",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 9157,
      "bar": "",
      "�װ����": "Thai Smile",
      "bar__1": "Thai Smile",
      "IATA": "WE",
      "bar__2": "THD",
      "ICAO": "Thailand",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 7115,
      "bar": "",
      "�װ����": "Thai VietJet Air",
      "bar__1": "Thai VietJet Air",
      "IATA": "VZ",
      "bar__2": "TVJ",
      "ICAO": "Thailand",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 9158,
      "bar": "",
      "�װ����": "The Cargo Airlines",
      "bar__1": "The Cargo Airlines",
      "IATA": "",
      "bar__2": "TZS",
      "ICAO": "Georgia",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 9160,
      "bar": "",
      "�װ����": "Thunder Airlines",
      "bar__1": "Thunder Airlines",
      "IATA": "",
      "bar__2": "THU",
      "ICAO": "Canada",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 9161,
      "bar": "",
      "�װ����": "Thunderbird Airways",
      "bar__1": "Thunderbird Airways",
      "IATA": "",
      "bar__2": "",
      "ICAO": "United States",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 9162,
      "bar": "",
      "�װ����": "Tianjin Cargo Airlines",
      "bar__1": "Tianjin Cargo Airlines",
      "IATA": "HT",
      "bar__2": "CTJ",
      "ICAO": "China",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 9163,
      "bar": "",
      "�װ����": "Tibet Airlines",
      "bar__1": "Tibet Airlines",
      "IATA": "TV",
      "bar__2": "TBA",
      "ICAO": "China",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 7109,
      "bar": "",
      "�װ����": "Tigerair Taiwan",
      "bar__1": "Tigerair Taiwan",
      "IATA": "IT",
      "bar__2": "TTW",
      "ICAO": "Taiwan",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 9165,
      "bar": "",
      "�װ����": "Tiko Air",
      "bar__1": "Tiko Air",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Madagascar",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 9166,
      "bar": "",
      "�װ����": "Titan Airways",
      "bar__1": "Titan Airways",
      "IATA": "ZT",
      "bar__2": "AWC",
      "ICAO": "United Kingdom",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 9167,
      "bar": "",
      "�װ����": "Tli Cho Air",
      "bar__1": "Tli Cho Air",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Canada",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 9168,
      "bar": "",
      "�װ����": "TMK Air Commuter",
      "bar__1": "TMK Air Commuter",
      "IATA": "",
      "bar__2": "TMK",
      "ICAO": "Democratic Republic of Congo",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 9169,
      "bar": "",
      "�װ����": "Tofino Air",
      "bar__1": "Tofino Air",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Canada",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 9170,
      "bar": "",
      "�װ����": "Toll Priority",
      "bar__1": "Toll Priority",
      "IATA": "",
      "bar__2": "",
      "ICAO": "New Zealand",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 9171,
      "bar": "",
      "�װ����": "TopJets Worldwide",
      "bar__1": "TopJets Worldwide",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Italy",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 9172,
      "bar": "",
      "�װ����": "Tortug Air",
      "bar__1": "Tortug Air",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Haiti",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 9173,
      "bar": "",
      "�װ����": "Total Linhas Aereas",
      "bar__1": "Total Linhas Aereas",
      "IATA": "",
      "bar__2": "TTL",
      "ICAO": "Brazil",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 9175,
      "bar": "",
      "�װ����": "Trade Air",
      "bar__1": "Trade Air",
      "IATA": "C3",
      "bar__2": "TDR",
      "ICAO": "Croatia",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 9176,
      "bar": "",
      "�װ����": "Tradecraft Air Nigeria",
      "bar__1": "Tradecraft Air Nigeria",
      "IATA": "",
      "bar__2": "TCA",
      "ICAO": "Nigeria",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 9177,
      "bar": "",
      "�װ����": "Tradewind Aviation",
      "bar__1": "Tradewind Aviation",
      "IATA": "TJ",
      "bar__2": "GPD",
      "ICAO": "United States",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 9178,
      "bar": "",
      "�װ����": "Tranaca",
      "bar__1": "Tranaca",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Venezuela",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 9179,
      "bar": "",
      "�װ����": "Trans Air Cargo Services",
      "bar__1": "Trans Air Cargo Services",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Democratic Republic of the Congo",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 9180,
      "bar": "",
      "�װ����": "Trans Bharat Aviation",
      "bar__1": "Trans Bharat Aviation",
      "IATA": "",
      "bar__2": "",
      "ICAO": "India",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 9181,
      "bar": "",
      "�װ����": "Trans Capital Air",
      "bar__1": "Trans Capital Air",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Canada",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 9182,
      "bar": "",
      "�װ����": "Trans Executive  Airlines",
      "bar__1": "Trans Executive Airlines",
      "IATA": "R9",
      "bar__2": "MUI",
      "ICAO": "United States",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 9183,
      "bar": "",
      "�װ����": "Trans Guyana Airways",
      "bar__1": "Trans Guyana Airways",
      "IATA": "",
      "bar__2": "TGY",
      "ICAO": "Guyana",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 9184,
      "bar": "",
      "�װ����": "Trans Maldivian Airways",
      "bar__1": "Trans Maldivian Airways",
      "IATA": "M8",
      "bar__2": "TMW",
      "ICAO": "Maldives",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 9185,
      "bar": "",
      "�װ����": "Trans Nation Airways",
      "bar__1": "Trans Nation Airways",
      "IATA": "",
      "bar__2": "TNW",
      "ICAO": "Ethiopia",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 9186,
      "bar": "",
      "�װ����": "Trans Niugini Tours",
      "bar__1": "Trans Niugini Tours",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Papua New Guinea",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 9187,
      "bar": "",
      "�װ����": "Trans North Aviation",
      "bar__1": "Trans North Aviation",
      "IATA": "",
      "bar__2": "TNT",
      "ICAO": "United States",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 9188,
      "bar": "",
      "�װ����": "Trans North Helicopters",
      "bar__1": "Trans North Helicopters",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Canada",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 9189,
      "bar": "",
      "�װ����": "Transaer RASA",
      "bar__1": "Transaer RASA",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Peru",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 9190,
      "bar": "",
      "�װ����": "TransAfrik International",
      "bar__1": "TransAfrik International",
      "IATA": "PQ",
      "bar__2": "TFK",
      "ICAO": "Angola",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 9191,
      "bar": "",
      "�װ����": "Transair Senegal",
      "bar__1": "Transair Senegal",
      "IATA": "R2",
      "bar__2": "GTS",
      "ICAO": "Senegal",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 9192,
      "bar": "",
      "�װ����": "Transavia",
      "bar__1": "Transavia",
      "IATA": "HV",
      "bar__2": "TRA",
      "ICAO": "Netherlands",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 9193,
      "bar": "",
      "�װ����": "Transaviabaltika Aviation",
      "bar__1": "Transaviabaltika Aviation",
      "IATA": "",
      "bar__2": "KTB",
      "ICAO": "Lithuania",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 9194,
      "bar": "",
      "�װ����": "TransAVIAexport Airlines",
      "bar__1": "TransAVIAexport Airlines",
      "IATA": "",
      "bar__2": "TXC",
      "ICAO": "Belarus",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8043,
      "bar": "",
      "�װ����": "Avion Express Malta",
      "bar__1": "Avion Express Malta",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Malta",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8044,
      "bar": "",
      "�װ����": "Avior Airlines",
      "bar__1": "Avior Airlines",
      "IATA": "9V",
      "bar__2": "ROI",
      "ICAO": "Venezuela",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8045,
      "bar": "",
      "�װ����": "Aviostart",
      "bar__1": "Aviostart",
      "IATA": "",
      "bar__2": "VSR",
      "ICAO": "Bulgaria",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8046,
      "bar": "",
      "�װ����": "Avluga-Trans",
      "bar__1": "Avluga-Trans",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Kazakhstan",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8274,
      "bar": "",
      "�װ����": "Elcovka",
      "bar__1": "Elcovka",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Russia",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8275,
      "bar": "",
      "�װ����": "Elite Airways",
      "bar__1": "Elite Airways",
      "IATA": "7Q",
      "bar__2": "MNU",
      "ICAO": "United States",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 7151,
      "bar": "",
      "�װ����": "Ellinair",
      "bar__1": "Ellinair",
      "IATA": "EL",
      "bar__2": "ELB",
      "ICAO": "Greece",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8277,
      "bar": "",
      "�װ����": "Emerald Airlines",
      "bar__1": "Emerald Airlines",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Zimbabwe",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8278,
      "bar": "",
      "�װ����": "Empire Airlines",
      "bar__1": "Empire Airlines",
      "IATA": "EM",
      "bar__2": "CFS",
      "ICAO": "United States",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8279,
      "bar": "",
      "�װ����": "Encore Air Cargo",
      "bar__1": "Encore Air Cargo",
      "IATA": "",
      "bar__2": "DKT",
      "ICAO": "United States",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8280,
      "bar": "",
      "�װ����": "Enggang Air Service",
      "bar__1": "Enggang Air Service",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Indonesia",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8281,
      "bar": "",
      "�װ����": "Enhance Aero Group",
      "bar__1": "Enhance Aero Group",
      "IATA": "",
      "bar__2": "",
      "ICAO": "France",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8282,
      "bar": "",
      "�װ����": "Enter Air",
      "bar__1": "Enter Air",
      "IATA": "E4",
      "bar__2": "ENT",
      "ICAO": "Poland",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8283,
      "bar": "",
      "�װ����": "Envoy",
      "bar__1": "Envoy",
      "IATA": "MQ",
      "bar__2": "EGF",
      "ICAO": "United States",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8285,
      "bar": "",
      "�װ����": "Equaflight",
      "bar__1": "Equaflight",
      "IATA": "E7",
      "bar__2": "EKA",
      "ICAO": "Republic of the Congo",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8287,
      "bar": "",
      "�װ����": "Estafeta CARGA AEREA",
      "bar__1": "Estafeta CARGA AEREA",
      "IATA": "E7",
      "bar__2": "ESF",
      "ICAO": "Mexico",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8288,
      "bar": "",
      "�װ����": "Estar Avia",
      "bar__1": "Estar Avia",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Russia",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8289,
      "bar": "",
      "�װ����": "Eswatini Airlink",
      "bar__1": "Eswatini Airlink",
      "IATA": "4Z",
      "bar__2": "SZL",
      "ICAO": "Swaziland",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 9353,
      "bar": "",
      "�װ����": "ETF Airways",
      "bar__1": "ETF Airways",
      "IATA": "",
      "bar__2": "EZZ",
      "ICAO": "Croatia",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8290,
      "bar": "",
      "�װ����": "Ethiopian Mozambique Airlines",
      "bar__1": "Ethiopian Mozambique Airlines",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Mozambique",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8292,
      "bar": "",
      "�װ����": "Euro-Asia Air",
      "bar__1": "Euro-Asia Air",
      "IATA": "5B",
      "bar__2": "EAK",
      "ICAO": "Kazakhstan",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8293,
      "bar": "",
      "�װ����": "euroAtlantic airways",
      "bar__1": "euroAtlantic airways",
      "IATA": "YU",
      "bar__2": "MMZ",
      "ICAO": "Portugal",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8117,
      "bar": "",
      "�װ����": "European Air Charter",
      "bar__1": "European Air Charter",
      "IATA": "1T",
      "bar__2": "BUC",
      "ICAO": "Bulgaria",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8294,
      "bar": "",
      "�װ����": "European Air Transport Leipzig",
      "bar__1": "European Air Transport Leipzig",
      "IATA": "QY",
      "bar__2": "BCS",
      "ICAO": "Germany",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8295,
      "bar": "",
      "�װ����": "European Helicopter Center",
      "bar__1": "European Helicopter Center",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Norway",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8722,
      "bar": "",
      "�װ����": "MODERN Logistics",
      "bar__1": "MODERN Logistics",
      "IATA": "WD",
      "bar__2": "MWM",
      "ICAO": "Brazil",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8723,
      "bar": "",
      "�װ����": "Mojn Express",
      "bar__1": "Mojn Express",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Denmark",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8724,
      "bar": "",
      "�װ����": "Mokulele Airlines",
      "bar__1": "Mokulele Airlines",
      "IATA": "9X",
      "bar__2": "FDY",
      "ICAO": "United States",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 9381,
      "bar": "",
      "�װ����": "Mongolian Airways Cargo",
      "bar__1": "Mongolian Airways Cargo",
      "IATA": "XF",
      "bar__2": "MGW",
      "ICAO": "Mongolia",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8725,
      "bar": "",
      "�װ����": "Mont Blanc Helicopteres",
      "bar__1": "Mont Blanc Helicopteres",
      "IATA": "",
      "bar__2": "",
      "ICAO": "France",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8726,
      "bar": "",
      "�װ����": "MontAir",
      "bar__1": "MontAir",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Canada",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8727,
      "bar": "",
      "�װ����": "Moremi Air Services",
      "bar__1": "Moremi Air Services",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Botswana",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8728,
      "bar": "",
      "�װ����": "Moscow Sky",
      "bar__1": "Moscow Sky",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Russia",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8729,
      "bar": "",
      "�װ����": "Mosphil Aero",
      "bar__1": "Mosphil Aero",
      "IATA": "",
      "bar__2": "MPI",
      "ICAO": "Philippines",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8731,
      "bar": "",
      "�װ����": "Mount Cook Ski PLanes",
      "bar__1": "Mount Cook Ski PLanes",
      "IATA": "",
      "bar__2": "",
      "ICAO": "New Zealand",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8732,
      "bar": "",
      "�װ����": "Mountain Air",
      "bar__1": "Mountain Air",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Nepal",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8733,
      "bar": "",
      "�װ����": "Mountain Air Cargo",
      "bar__1": "Mountain Air Cargo",
      "IATA": "C2",
      "bar__2": "MTN",
      "ICAO": "United States",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8734,
      "bar": "",
      "�װ����": "Moxy Airways",
      "bar__1": "Moxy Airways",
      "IATA": "",
      "bar__2": "",
      "ICAO": "United States",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8735,
      "bar": "",
      "�װ����": "MRK Airlines",
      "bar__1": "MRK Airlines",
      "IATA": "6V",
      "bar__2": "",
      "ICAO": "Ukraine",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8736,
      "bar": "",
      "�װ����": "MSD Aviation",
      "bar__1": "MSD Aviation",
      "IATA": "",
      "bar__2": "",
      "ICAO": "India",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8737,
      "bar": "",
      "�װ����": "Murmanskoya",
      "bar__1": "Murmanskoya",
      "IATA": "",
      "bar__2": "MNZ",
      "ICAO": "Russia",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8738,
      "bar": "",
      "�װ����": "Mustique Airways",
      "bar__1": "Mustique Airways",
      "IATA": "",
      "bar__2": "MAW",
      "ICAO": "Saint Vincent and the Grenadines",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8739,
      "bar": "",
      "�װ����": "My Indo Airlines",
      "bar__1": "My Indo Airlines",
      "IATA": "2Y",
      "bar__2": "MYU",
      "ICAO": "Indonesia",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8740,
      "bar": "",
      "�װ����": "Myachkovo Air Services",
      "bar__1": "Myachkovo Air Services",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Russia",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8741,
      "bar": "",
      "�װ����": "Myanmar National Airlines",
      "bar__1": "Myanmar National Airlines",
      "IATA": "UB",
      "bar__2": "UBA",
      "ICAO": "Myanmar",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8742,
      "bar": "",
      "�װ����": "myCARGO",
      "bar__1": "myCARGO",
      "IATA": "9T",
      "bar__2": "RUN",
      "ICAO": "Turkey",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8743,
      "bar": "",
      "�װ����": "MyWay Airlines",
      "bar__1": "MyWay Airlines",
      "IATA": "MJ",
      "bar__2": "MYW",
      "ICAO": "Georgia",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8744,
      "bar": "",
      "�װ����": "NAC Charter",
      "bar__1": "NAC Charter",
      "IATA": "",
      "bar__2": "",
      "ICAO": "South Africa",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8745,
      "bar": "",
      "�װ����": "Nacional de Aviacion Colombia",
      "bar__1": "Nacional de Aviacion Colombia",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Colombia",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8746,
      "bar": "",
      "�װ����": "Nakina Air Service",
      "bar__1": "Nakina Air Service",
      "IATA": "T2",
      "bar__2": "",
      "ICAO": "Canada",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8747,
      "bar": "",
      "�װ����": "Nam Air",
      "bar__1": "Nam Air",
      "IATA": "IN",
      "bar__2": "LKN",
      "ICAO": "Indonesia",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8749,
      "bar": "",
      "�װ����": "Naryan-Marski Air Enterprise",
      "bar__1": "Naryan-Marski Air Enterprise",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Russia",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8750,
      "bar": "",
      "�װ����": "Nasim Air",
      "bar__1": "Nasim Air",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Iran",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 9195,
      "bar": "",
      "�װ����": "Transavia-Garantiya",
      "bar__1": "Transavia-Garantiya",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Russia",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 9196,
      "bar": "",
      "�װ����": "Transaviaservice",
      "bar__1": "Transaviaservice",
      "IATA": "",
      "bar__2": "FNV",
      "ICAO": "Georgia",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 9197,
      "bar": "",
      "�װ����": "Transcarga International Airways",
      "bar__1": "Transcarga International Airways",
      "IATA": "T9",
      "bar__2": "TIW",
      "ICAO": "Venezuela",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 9198,
      "bar": "",
      "�װ����": "TransGlobal Airways",
      "bar__1": "TransGlobal Airways",
      "IATA": "T7",
      "bar__2": "TCU",
      "ICAO": "Philippines",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 9199,
      "bar": "",
      "�װ����": "Transliz Aviation",
      "bar__1": "Transliz Aviation",
      "IATA": "",
      "bar__2": "TLZ",
      "ICAO": "Sao Tome and Principe",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 9200,
      "bar": "",
      "�װ����": "TransNorthern",
      "bar__1": "TransNorthern",
      "IATA": "",
      "bar__2": "TNV",
      "ICAO": "United States",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 9201,
      "bar": "",
      "�װ����": "Transporte Air Checo",
      "bar__1": "Transporte Air Checo",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Venezuela",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 9202,
      "bar": "",
      "�װ����": "Transportes Aereos Bolivianos",
      "bar__1": "Transportes Aereos Bolivianos",
      "IATA": "2L",
      "bar__2": "BOL",
      "ICAO": "Bolivia",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 9203,
      "bar": "",
      "�װ����": "Transportes Aereos Cielos Andinos",
      "bar__1": "Transportes Aereos Cielos Andinos",
      "IATA": "",
      "bar__2": "NDN",
      "ICAO": "Peru",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8082,
      "bar": "",
      "�װ����": "Transportes Interilhas de Cabo Verde (TICV)",
      "bar__1": "Transportes Interilhas de Cabo Verde (TICV)",
      "IATA": "3B",
      "bar__2": "NTB",
      "ICAO": "Cape Verde",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 9204,
      "bar": "",
      "�װ����": "Transports Aeriens Intercaraibes",
      "bar__1": "Transports Aeriens Intercaraibes",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Guadeloupe",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 9205,
      "bar": "",
      "�װ����": "Transwest Air",
      "bar__1": "Transwest Air",
      "IATA": "4T",
      "bar__2": "ABS",
      "ICAO": "Canada",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 9206,
      "bar": "",
      "�װ����": "Tri-MG Intra Asia Airlines",
      "bar__1": "Tri-MG Intra Asia Airlines",
      "IATA": "GM",
      "bar__2": "TMG",
      "ICAO": "Indonesia",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 9207,
      "bar": "",
      "�װ����": "Tropical Air",
      "bar__1": "Tropical Air",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Tanzania",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 9208,
      "bar": "",
      "�װ����": "Tropical Air Gabon",
      "bar__1": "Tropical Air Gabon",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Gabon",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 9209,
      "bar": "",
      "�װ����": "Tropicana",
      "bar__1": "Tropicana",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Angola",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 7125,
      "bar": "",
      "�װ����": "TruJet",
      "bar__1": "TruJet",
      "IATA": "2T",
      "bar__2": "TRJ",
      "ICAO": "India",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 9210,
      "bar": "",
      "�װ����": "Tsaradia",
      "bar__1": "Tsaradia",
      "IATA": "TZ",
      "bar__2": "TDS",
      "ICAO": "Madagascar",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 9211,
      "bar": "",
      "�װ����": "TUI Airways",
      "bar__1": "TUI Airways",
      "IATA": "BY",
      "bar__2": "TOM",
      "ICAO": "United Kingdom",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 9212,
      "bar": "",
      "�װ����": "TUI fly Deutschland",
      "bar__1": "TUI fly Deutschland",
      "IATA": "X3",
      "bar__2": "TUI",
      "ICAO": "Germany",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 9213,
      "bar": "",
      "�װ����": "Tunisair Express",
      "bar__1": "Tunisair Express",
      "IATA": "UG",
      "bar__2": "TUX",
      "ICAO": "Tunisia",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 9214,
      "bar": "",
      "�װ����": "Tunisavia",
      "bar__1": "Tunisavia",
      "IATA": "",
      "bar__2": "TAJ",
      "ICAO": "Tunisia",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 9215,
      "bar": "",
      "�װ����": "Turbot Air Cargo",
      "bar__1": "Turbot Air Cargo",
      "IATA": "",
      "bar__2": "TAC",
      "ICAO": "Senegal",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 9216,
      "bar": "",
      "�װ����": "Turkietresor",
      "bar__1": "Turkietresor",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Turkey",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8047,
      "bar": "",
      "�װ����": "AWEX Croatia",
      "bar__1": "AWEX Croatia",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Croatia",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8048,
      "bar": "",
      "�װ����": "Axiom Air",
      "bar__1": "Axiom Air",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Nigeria",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8049,
      "bar": "",
      "�װ����": "Ayk Avia",
      "bar__1": "Ayk Avia",
      "IATA": "",
      "bar__2": "AYK",
      "ICAO": "Armenia",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8050,
      "bar": "",
      "�װ����": "Azimut Airlines",
      "bar__1": "Azimut Airlines",
      "IATA": "A4",
      "bar__2": "AZO",
      "ICAO": "Russia",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 7185,
      "bar": "",
      "�װ����": "Azman air",
      "bar__1": "Azman air",
      "IATA": "ZQ",
      "bar__2": "AZM",
      "ICAO": "Nigeria",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8051,
      "bar": "",
      "�װ����": "Azul Uruguay",
      "bar__1": "Azul Uruguay",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Uruguay",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 7138,
      "bar": "",
      "�װ����": "Azur Air",
      "bar__1": "Azur Air",
      "IATA": "ZF",
      "bar__2": "KTK",
      "ICAO": "Russia",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8052,
      "bar": "",
      "�װ����": "Azur Air Ukraine",
      "bar__1": "Azur Air Ukraine",
      "IATA": "QU",
      "bar__2": "UTN",
      "ICAO": "Ukraine",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8055,
      "bar": "",
      "�װ����": "Babcock Mission Critical Service Offshore",
      "bar__1": "Babcock Mission Critical Service Offshore",
      "IATA": "",
      "bar__2": "BND",
      "ICAO": "United Kingdom",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 9354,
      "bar": "",
      "�װ����": "Eurowings Discover",
      "bar__1": "Eurowings Discover",
      "IATA": "4Y",
      "bar__2": "OCN",
      "ICAO": "Germany",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8296,
      "bar": "",
      "�װ����": "Eurowings Europe",
      "bar__1": "Eurowings Europe",
      "IATA": "E2",
      "bar__2": "EWE",
      "ICAO": "Australia",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8297,
      "bar": "",
      "�װ����": "EVAS Air",
      "bar__1": "EVAS Air",
      "IATA": "8K",
      "bar__2": "EVS",
      "ICAO": "Canada",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 7149,
      "bar": "",
      "�װ����": "Evelop Airlines",
      "bar__1": "Evelop Airlines",
      "IATA": "E9",
      "bar__2": "EVE",
      "ICAO": "Spain",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8300,
      "bar": "",
      "�װ����": "Everjets",
      "bar__1": "Everjets",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Portugal",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8301,
      "bar": "",
      "�װ����": "Everts Air Cargo",
      "bar__1": "Everts Air Cargo",
      "IATA": "5V",
      "bar__2": "VTS",
      "ICAO": "United States",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 7188,
      "bar": "",
      "�װ����": "Ewa AIr",
      "bar__1": "Ewa AIr",
      "IATA": "ZD",
      "bar__2": "EWR",
      "ICAO": "Mayotte",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8302,
      "bar": "",
      "�װ����": "ExcelAire",
      "bar__1": "ExcelAire",
      "IATA": "",
      "bar__2": "XLS",
      "ICAO": "United States",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8303,
      "bar": "",
      "�װ����": "Excellent Air",
      "bar__1": "Excellent Air",
      "IATA": "",
      "bar__2": "GZA",
      "ICAO": "Germany",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8304,
      "bar": "",
      "�װ����": "Exclusive Alliance",
      "bar__1": "Exclusive Alliance",
      "IATA": "",
      "bar__2": "",
      "ICAO": "South Africa",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8305,
      "bar": "",
      "�װ����": "Exec Direct Aviation",
      "bar__1": "Exec Direct Aviation",
      "IATA": "",
      "bar__2": "EDA",
      "ICAO": "Jamaica",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8306,
      "bar": "",
      "�װ����": "ExecuJet",
      "bar__1": "ExecuJet",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Switzerland",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8307,
      "bar": "",
      "�װ����": "Executive Aerospace",
      "bar__1": "Executive Aerospace",
      "IATA": "",
      "bar__2": "EAS",
      "ICAO": "South Africa",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8308,
      "bar": "",
      "�װ����": "Executive Turbine Kenya",
      "bar__1": "Executive Turbine Kenya",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Kenya",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8309,
      "bar": "",
      "�װ����": "Exim Trading",
      "bar__1": "Exim Trading",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Guinea",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8310,
      "bar": "",
      "�װ����": "Express Air Cargo",
      "bar__1": "Express Air Cargo",
      "IATA": "7A",
      "bar__2": "XRC",
      "ICAO": "Tunisia",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8311,
      "bar": "",
      "�װ����": "Express Airways",
      "bar__1": "Express Airways",
      "IATA": "",
      "bar__2": "EPR",
      "ICAO": "Slovenia",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8312,
      "bar": "",
      "�װ����": "ExtraJet",
      "bar__1": "ExtraJet",
      "IATA": "",
      "bar__2": "",
      "ICAO": "United Kingdom",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8313,
      "bar": "",
      "�װ����": "EZ Air",
      "bar__1": "EZ Air",
      "IATA": "",
      "bar__2": "EZR",
      "ICAO": "Netherlands",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8314,
      "bar": "",
      "�װ����": "FAI Rent-A-Jet",
      "bar__1": "FAI Rent-A-Jet",
      "IATA": "F3",
      "bar__2": "IFA",
      "ICAO": "Germany",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8315,
      "bar": "",
      "�װ����": "Fair Aviation",
      "bar__1": "Fair Aviation",
      "IATA": "",
      "bar__2": "FAV",
      "ICAO": "South Africa",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8316,
      "bar": "",
      "�װ����": "Falcon Aviation Services",
      "bar__1": "Falcon Aviation Services",
      "IATA": "",
      "bar__2": "FVS",
      "ICAO": "United Arab Emirates",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8317,
      "bar": "",
      "�װ����": "Fars Qeshm Air Lines",
      "bar__1": "Fars Qeshm Air Lines",
      "IATA": "",
      "bar__2": "QFZ",
      "ICAO": "Iran",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8318,
      "bar": "",
      "�װ����": "fastjet Kenya",
      "bar__1": "fastjet Kenya",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Kenya",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8319,
      "bar": "",
      "�װ����": "fastjet Mozambique",
      "bar__1": "fastjet Mozambique",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Mozambique",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8320,
      "bar": "",
      "�װ����": "fastjet South Africa",
      "bar__1": "fastjet South Africa",
      "IATA": "",
      "bar__2": "",
      "ICAO": "South Africa",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8321,
      "bar": "",
      "�װ����": "fastjet Zambia",
      "bar__1": "fastjet Zambia",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Zambia",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 7184,
      "bar": "",
      "�װ����": "Fastjet Zimbabwe",
      "bar__1": "Fastjet Zimbabwe",
      "IATA": "FN",
      "bar__2": "FJW",
      "ICAO": "Zimbabwe",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8751,
      "bar": "",
      "�װ����": "National Airways",
      "bar__1": "National Airways",
      "IATA": "9Y",
      "bar__2": "NAE",
      "ICAO": "Ethiopia",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8752,
      "bar": "",
      "�װ����": "National Regionale Transport",
      "bar__1": "National Regionale Transport",
      "IATA": "",
      "bar__2": "NRG",
      "ICAO": "Gabon",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8753,
      "bar": "",
      "�װ����": "Nav Air Charter",
      "bar__1": "Nav Air Charter",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Canada",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8754,
      "bar": "",
      "�װ����": "Navion Airlines",
      "bar__1": "Navion Airlines",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Venezuela",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8755,
      "bar": "",
      "�װ����": "naxosair",
      "bar__1": "naxosair",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Greece",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8756,
      "bar": "",
      "�װ����": "Nesma Airlines",
      "bar__1": "Nesma Airlines",
      "IATA": "NA",
      "bar__2": "NSS",
      "ICAO": "Saudi Arabia",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8757,
      "bar": "",
      "�װ����": "Nestor Falls Fly-In Outposts",
      "bar__1": "Nestor Falls Fly-In Outposts",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Canada",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 7728,
      "bar": "",
      "�װ����": "NetJets",
      "bar__1": "NetJets",
      "IATA": "1I",
      "bar__2": "EJA",
      "ICAO": "United States",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8758,
      "bar": "",
      "�װ����": "Network Aviation",
      "bar__1": "Network Aviation",
      "IATA": "",
      "bar__2": "NWK",
      "ICAO": "Australia",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8759,
      "bar": "",
      "�װ����": "New Central Air Service",
      "bar__1": "New Central Air Service",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Japan",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8760,
      "bar": "",
      "�װ����": "New Jatayu Air",
      "bar__1": "New Jatayu Air",
      "IATA": "",
      "bar__2": "JTY",
      "ICAO": "Indonesia",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 7154,
      "bar": "",
      "�װ����": "NewLeaf Travel",
      "bar__1": "NewLeaf Travel",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Canada",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8761,
      "bar": "",
      "�װ����": "NEXTJETCANADA",
      "bar__1": "NEXTJETCANADA",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Canada",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8762,
      "bar": "",
      "�װ����": "Nice Helicopters",
      "bar__1": "Nice Helicopters",
      "IATA": "",
      "bar__2": "",
      "ICAO": "France",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 7189,
      "bar": "",
      "�װ����": "Niger Airlines",
      "bar__1": "Niger Airlines",
      "IATA": "6N",
      "bar__2": "NIN",
      "ICAO": "Niger",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8763,
      "bar": "",
      "�װ����": "Niger Airways",
      "bar__1": "Niger Airways",
      "IATA": "NJ",
      "bar__2": "NWA",
      "ICAO": "Niger",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8764,
      "bar": "",
      "�װ����": "Nile Airways",
      "bar__1": "Nile Airways",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Uganda",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8765,
      "bar": "",
      "�װ����": "Ningbo Airlines",
      "bar__1": "Ningbo Airlines",
      "IATA": "",
      "bar__2": "",
      "ICAO": "China",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8766,
      "bar": "",
      "�װ����": "Nizhnevartovsk Avia",
      "bar__1": "Nizhnevartovsk Avia",
      "IATA": "",
      "bar__2": "NVK",
      "ICAO": "Russia",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8767,
      "bar": "",
      "�װ����": "Nor-Alta Aviation",
      "bar__1": "Nor-Alta Aviation",
      "IATA": "",
      "bar__2": "LRA",
      "ICAO": "Canada",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8768,
      "bar": "",
      "�װ����": "Nordflyg Logistik",
      "bar__1": "Nordflyg Logistik",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Sweden",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8769,
      "bar": "",
      "�װ����": "Nordic Regional Airlines",
      "bar__1": "Nordic Regional Airlines",
      "IATA": "N7",
      "bar__2": "FCM",
      "ICAO": "Finland",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8770,
      "bar": "",
      "�װ����": "Nordica",
      "bar__1": "Nordica",
      "IATA": "EE",
      "bar__2": "EST",
      "ICAO": "Estonia",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8771,
      "bar": "",
      "�װ����": "Nordways Sweden",
      "bar__1": "Nordways Sweden",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Sweden",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8772,
      "bar": "",
      "�װ����": "Nordwind Airlines",
      "bar__1": "Nordwind Airlines",
      "IATA": "N4",
      "bar__2": "NWS",
      "ICAO": "Russia",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 9217,
      "bar": "",
      "�װ����": "Turpial Airlines",
      "bar__1": "Turpial Airlines",
      "IATA": "T9",
      "bar__2": "VTU",
      "ICAO": "Venezuela",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 9218,
      "bar": "",
      "�װ����": "Turukhan Airlines",
      "bar__1": "Turukhan Airlines",
      "IATA": "",
      "bar__2": "TRH",
      "ICAO": "Russia",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 9219,
      "bar": "",
      "�װ����": "Tus Airways",
      "bar__1": "Tus Airways",
      "IATA": "U8",
      "bar__2": "CYF",
      "ICAO": "Cyprus",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 9220,
      "bar": "",
      "�װ����": "Tuva Avia",
      "bar__1": "Tuva Avia",
      "IATA": "",
      "bar__2": "TIV",
      "ICAO": "Russia",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 9221,
      "bar": "",
      "�װ����": "Uganda Air Cargo",
      "bar__1": "Uganda Air Cargo",
      "IATA": "",
      "bar__2": "UCC",
      "ICAO": "Uganda",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 9222,
      "bar": "",
      "�װ����": "Ukraine Air Alliance",
      "bar__1": "Ukraine Air Alliance",
      "IATA": "",
      "bar__2": "UKL",
      "ICAO": "Ukraine",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 9223,
      "bar": "",
      "�װ����": "Ukraine Air Enterprise",
      "bar__1": "Ukraine Air Enterprise",
      "IATA": "",
      "bar__2": "UKN",
      "ICAO": "Ukraine",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 9224,
      "bar": "",
      "�װ����": "Ukraine State Flight Academy",
      "bar__1": "Ukraine State Flight Academy",
      "IATA": "",
      "bar__2": "UFA",
      "ICAO": "Ukraine",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 9225,
      "bar": "",
      "�װ����": "Ukrainian Wings",
      "bar__1": "Ukrainian Wings",
      "IATA": "",
      "bar__2": "UWJ",
      "ICAO": "Ukraine",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 9227,
      "bar": "",
      "�װ����": "Unimed Air",
      "bar__1": "Unimed Air",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Brazil",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 9228,
      "bar": "",
      "�װ����": "Union Express Charter Airline",
      "bar__1": "Union Express Charter Airline",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Myanmar",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 9229,
      "bar": "",
      "�װ����": "Unique Air",
      "bar__1": "Unique Air",
      "IATA": "6U",
      "bar__2": "UQA",
      "ICAO": "South Africa",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 9394,
      "bar": "",
      "�װ����": "United Nigeria",
      "bar__1": "United Nigeria",
      "IATA": "U5",
      "bar__2": "UNA",
      "ICAO": "Nigeria",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 9230,
      "bar": "",
      "�װ����": "Unity Air",
      "bar__1": "Unity Air",
      "IATA": "",
      "bar__2": "AFD",
      "ICAO": "Ghana",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 9231,
      "bar": "",
      "�װ����": "Uniworld Air Cargo",
      "bar__1": "Uniworld Air Cargo",
      "IATA": "U7",
      "bar__2": "UCG",
      "ICAO": "Panama",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 9232,
      "bar": "",
      "�װ����": "UPS",
      "bar__1": "UPS",
      "IATA": "5X",
      "bar__2": "UPS",
      "ICAO": "United States",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 9395,
      "bar": "",
      "�װ����": "UR Airlines",
      "bar__1": "UR Airlines",
      "IATA": "UD",
      "bar__2": "UBD",
      "ICAO": "Iraq",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 7106,
      "bar": "",
      "�װ����": "Urmuqi Air",
      "bar__1": "Urmuqi Air",
      "IATA": "UQ",
      "bar__2": "CUH",
      "ICAO": "China",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 9233,
      "bar": "",
      "�װ����": "USA Jet Airlines",
      "bar__1": "USA Jet Airlines",
      "IATA": "UJ",
      "bar__2": "JUS",
      "ICAO": "United States",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 7121,
      "bar": "",
      "�װ����": "US-Bangla Airlines",
      "bar__1": "US-Bangla Airlines",
      "IATA": "BS",
      "bar__2": "UBG",
      "ICAO": "Bangladesh",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 9234,
      "bar": "",
      "�װ����": "USGlobal Airways",
      "bar__1": "USGlobal Airways",
      "IATA": "",
      "bar__2": "",
      "ICAO": "United States",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 9236,
      "bar": "",
      "�װ����": "Usta Avia",
      "bar__1": "Usta Avia",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Uzbekistan",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 9237,
      "bar": "",
      "�װ����": "UTair Europe",
      "bar__1": "UTair Europe",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Slovakia",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8056,
      "bar": "",
      "�װ����": "Baby Jet Airlines",
      "bar__1": "Baby Jet Airlines",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Ghana",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8057,
      "bar": "",
      "�װ����": "Badr Airlines",
      "bar__1": "Badr Airlines",
      "IATA": "J4",
      "bar__2": "BDR",
      "ICAO": "Sudan",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8058,
      "bar": "",
      "�װ����": "Baikalaviacom",
      "bar__1": "Baikalaviacom",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Russia",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8059,
      "bar": "",
      "�װ����": "Baires Fly",
      "bar__1": "Baires Fly",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Argentina",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8060,
      "bar": "",
      "�װ����": "Bald Mountain Air Service",
      "bar__1": "Bald Mountain Air Service",
      "IATA": "",
      "bar__2": "",
      "ICAO": "United States",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8061,
      "bar": "",
      "�װ����": "Baltijas Meridians",
      "bar__1": "Baltijas Meridians",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Latvia",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8062,
      "bar": "",
      "�װ����": "Bamboo Airways",
      "bar__1": "Bamboo Airways",
      "IATA": "QH",
      "bar__2": "BAV",
      "ICAO": "Viet Nam",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8322,
      "bar": "",
      "�װ����": "FedEx EXPRESS",
      "bar__1": "FedEx EXPRESS",
      "IATA": "FX",
      "bar__2": "FDX",
      "ICAO": "United States",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8323,
      "bar": "",
      "�װ����": "Feniks Airlines",
      "bar__1": "Feniks Airlines",
      "IATA": "",
      "bar__2": "FNK",
      "ICAO": "Kazakhstan",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8324,
      "bar": "",
      "�װ����": "Filair",
      "bar__1": "Filair",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Democratic Republic of Congo",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8325,
      "bar": "",
      "�װ����": "Firnas Airways",
      "bar__1": "Firnas Airways",
      "IATA": "",
      "bar__2": "",
      "ICAO": "United Kingdom",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8326,
      "bar": "",
      "�װ����": "First Flying",
      "bar__1": "First Flying",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Japan",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8327,
      "bar": "",
      "�װ����": "Flair Airlines",
      "bar__1": "Flair Airlines",
      "IATA": "F8",
      "bar__2": "FLE",
      "ICAO": "Canada",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8328,
      "bar": "",
      "�װ����": "Flex Air Cargo",
      "bar__1": "Flex Air Cargo",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Kenya",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 9355,
      "bar": "",
      "�װ����": "Flex Air Charters",
      "bar__1": "Flex Air Charters",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Kenya",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8329,
      "bar": "",
      "�װ����": "Flightlink Air Charter",
      "bar__1": "Flightlink Air Charter",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Tanzania",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8330,
      "bar": "",
      "�װ����": "Florida Air Cargo",
      "bar__1": "Florida Air Cargo",
      "IATA": "",
      "bar__2": "",
      "ICAO": "United States",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 7170,
      "bar": "",
      "�װ����": "Fly All Ways",
      "bar__1": "Fly All Ways",
      "IATA": "8W",
      "bar__2": "EDR",
      "ICAO": "Suriname",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8332,
      "bar": "",
      "�װ����": "Fly Angola",
      "bar__1": "Fly Angola",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Angola",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 9356,
      "bar": "",
      "�װ����": "Fly Armenia Airways",
      "bar__1": "Fly Armenia Airways",
      "IATA": "VF",
      "bar__2": "FBB",
      "ICAO": "Armenia",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8333,
      "bar": "",
      "�װ����": "Fly Art",
      "bar__1": "Fly Art",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Chad",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 7173,
      "bar": "",
      "�װ����": "Fly Baghdad",
      "bar__1": "Fly Baghdad",
      "IATA": "IF",
      "bar__2": "FBA",
      "ICAO": "Iraq",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8335,
      "bar": "",
      "�װ����": "Fly Compass",
      "bar__1": "Fly Compass",
      "IATA": "F6",
      "bar__2": "FXP",
      "ICAO": "Romania",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8337,
      "bar": "",
      "�װ����": "Fly County Aviation",
      "bar__1": "Fly County Aviation",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Kenya",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8338,
      "bar": "",
      "�װ����": "Fly Erbil",
      "bar__1": "Fly Erbil",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Iraq",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8340,
      "bar": "",
      "�װ����": "Fly Go Air",
      "bar__1": "Fly Go Air",
      "IATA": "",
      "bar__2": "",
      "ICAO": "South Africa",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8341,
      "bar": "",
      "�װ����": "Fly Guam",
      "bar__1": "Fly Guam",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Guam",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8343,
      "bar": "",
      "�װ����": "Fly Jordan",
      "bar__1": "Fly Jordan",
      "IATA": "",
      "bar__2": "FJR",
      "ICAO": "Jordan",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8344,
      "bar": "",
      "�װ����": "Fly Mid Africa",
      "bar__1": "Fly Mid Africa",
      "IATA": "8G",
      "bar__2": "MFG",
      "ICAO": "Gambia",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8345,
      "bar": "",
      "�װ����": "Fly Modern Ark",
      "bar__1": "Fly Modern Ark",
      "IATA": "",
      "bar__2": "",
      "ICAO": "South Africa",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8346,
      "bar": "",
      "�װ����": "Fly My Sky",
      "bar__1": "Fly My Sky",
      "IATA": "",
      "bar__2": "",
      "ICAO": "New Zealand",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8347,
      "bar": "",
      "�װ����": "Fly Nawras",
      "bar__1": "Fly Nawras",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Libya",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8348,
      "bar": "",
      "�װ����": "Fly One",
      "bar__1": "Fly One",
      "IATA": "5F",
      "bar__2": "FIA",
      "ICAO": "Moldova",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8349,
      "bar": "",
      "�װ����": "Fly Qeshm",
      "bar__1": "Fly Qeshm",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Iran",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8350,
      "bar": "",
      "�װ����": "Fly Southern",
      "bar__1": "Fly Southern",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Sri Lanka",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8351,
      "bar": "",
      "�װ����": "Fly Tristar Services",
      "bar__1": "Fly Tristar Services",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Kenya",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 9357,
      "bar": "",
      "�װ����": "Fly2Sky",
      "bar__1": "Fly2Sky",
      "IATA": "",
      "bar__2": "VAW",
      "ICAO": "Bulgaria",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8773,
      "bar": "",
      "�װ����": "North Shore Air",
      "bar__1": "North Shore Air",
      "IATA": "",
      "bar__2": "",
      "ICAO": "New Zealand",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8774,
      "bar": "",
      "�װ����": "North South Airlines",
      "bar__1": "North South Airlines",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Philippines",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8775,
      "bar": "",
      "�װ����": "North Star Air",
      "bar__1": "North Star Air",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Canada",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8777,
      "bar": "",
      "�װ����": "Northern Territory Air Services",
      "bar__1": "Northern Territory Air Services",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Australia",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8778,
      "bar": "",
      "�װ����": "North-Wright Airways",
      "bar__1": "North-Wright Airways",
      "IATA": "HW",
      "bar__2": "NWL",
      "ICAO": "Canada",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8779,
      "bar": "",
      "�װ����": "Norwegian Air Argentina",
      "bar__1": "Norwegian Air Argentina",
      "IATA": "NS",
      "bar__2": "NAA",
      "ICAO": "Argentina",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 7023,
      "bar": "",
      "�װ����": "Norwegian Air International",
      "bar__1": "Norwegian Air International",
      "IATA": "D8",
      "bar__2": "IBK",
      "ICAO": "Ireland",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8781,
      "bar": "",
      "�װ����": "Norwegian Air Sweden",
      "bar__1": "Norwegian Air Sweden",
      "IATA": "LE",
      "bar__2": "NSW",
      "ICAO": "Sweden",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8782,
      "bar": "",
      "�װ����": "Norwegian Air UK",
      "bar__1": "Norwegian Air UK",
      "IATA": "DI",
      "bar__2": "NRS",
      "ICAO": "United Kingdom",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8783,
      "bar": "",
      "�װ����": "Nusantara Buana Air",
      "bar__1": "Nusantara Buana Air",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Indonesia",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 7158,
      "bar": "",
      "�װ����": "Ohana by Hawaiian",
      "bar__1": "Ohana by Hawaiian",
      "IATA": "",
      "bar__2": "",
      "ICAO": "United States",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8784,
      "bar": "",
      "�װ����": "Olimex",
      "bar__1": "Olimex",
      "IATA": "",
      "bar__2": "OLX",
      "ICAO": "Czech Republic",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 9238,
      "bar": "",
      "�װ����": "UTair Helicopter Services",
      "bar__1": "UTair Helicopter Services",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Russia",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 9239,
      "bar": "",
      "�װ����": "UTair India",
      "bar__1": "UTair India",
      "IATA": "",
      "bar__2": "",
      "ICAO": "India",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 9240,
      "bar": "",
      "�װ����": "UTair South Africa",
      "bar__1": "UTair South Africa",
      "IATA": "",
      "bar__2": "UTR",
      "ICAO": "South Africa",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 7137,
      "bar": "",
      "�װ����": "UVT Aero",
      "bar__1": "UVT Aero",
      "IATA": "RT",
      "bar__2": "UVT",
      "ICAO": "Russia",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 9242,
      "bar": "",
      "�װ����": "Valorfly",
      "bar__1": "Valorfly",
      "IATA": "",
      "bar__2": "VLF",
      "ICAO": "Malta",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 9243,
      "bar": "",
      "�װ����": "Van Air Europe",
      "bar__1": "Van Air Europe",
      "IATA": "V9",
      "bar__2": "VAA",
      "ICAO": "Czech Republic",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 9244,
      "bar": "",
      "�װ����": "Van Airlines",
      "bar__1": "Van Airlines",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Turkey",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 9245,
      "bar": "",
      "�װ����": "Vancouver Island Air",
      "bar__1": "Vancouver Island Air",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Canada",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 9246,
      "bar": "",
      "�װ����": "Varesh Airlines",
      "bar__1": "Varesh Airlines",
      "IATA": "",
      "bar__2": "VRH",
      "ICAO": "Iran",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 9247,
      "bar": "",
      "�װ����": "Vee Neal Aviation",
      "bar__1": "Vee Neal Aviation",
      "IATA": "",
      "bar__2": "",
      "ICAO": "United States",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 9248,
      "bar": "",
      "�װ����": "Venexcargo",
      "bar__1": "Venexcargo",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Venezuela",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 9249,
      "bar": "",
      "�װ����": "Venezolana",
      "bar__1": "Venezolana",
      "IATA": "VN",
      "bar__2": "VNE",
      "ICAO": "Venezuela",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 9250,
      "bar": "",
      "�װ����": "Ventura Airconnect",
      "bar__1": "Ventura Airconnect",
      "IATA": "",
      "bar__2": "",
      "ICAO": "India",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 9251,
      "bar": "",
      "�װ����": "Venture Air",
      "bar__1": "Venture Air",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Canada",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 9252,
      "bar": "",
      "�װ����": "Veteran Avia",
      "bar__1": "Veteran Avia",
      "IATA": "",
      "bar__2": "VTF",
      "ICAO": "Armenia",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 9254,
      "bar": "",
      "�װ����": "Victory Aviation",
      "bar__1": "Victory Aviation",
      "IATA": "",
      "bar__2": "",
      "ICAO": "United States",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 9255,
      "bar": "",
      "�װ����": "Vieques Air Link",
      "bar__1": "Vieques Air Link",
      "IATA": "V4",
      "bar__2": "VES",
      "ICAO": "Puerto Rico",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 9256,
      "bar": "",
      "�װ����": "Vietstar Airlines",
      "bar__1": "Vietstar Airlines",
      "IATA": "",
      "bar__2": "VSM",
      "ICAO": "Viet Nam",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 9257,
      "bar": "",
      "�װ����": "Vigo Jet",
      "bar__1": "Vigo Jet",
      "IATA": "",
      "bar__2": "MJT",
      "ICAO": "Mexico",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 9258,
      "bar": "",
      "�װ����": "Virgin Australia",
      "bar__1": "Virgin Australia",
      "IATA": "VA",
      "bar__2": "VOZ",
      "ICAO": "Australia",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 7126,
      "bar": "",
      "�װ����": "Vistara",
      "bar__1": "Vistara",
      "IATA": "UK",
      "bar__2": "VTI",
      "ICAO": "India",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 9259,
      "bar": "",
      "�װ����": "Vityaz Aero",
      "bar__1": "Vityaz Aero",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Russia",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 9260,
      "bar": "",
      "�װ����": "Viva Aerobus",
      "bar__1": "Viva Aerobus",
      "IATA": "VB",
      "bar__2": "VIV",
      "ICAO": "Mexico",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 9261,
      "bar": "",
      "�װ����": "Viva Air Peru",
      "bar__1": "Viva Air Peru",
      "IATA": "VV",
      "bar__2": "VPE",
      "ICAO": "Peru",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 9262,
      "bar": "",
      "�װ����": "VivaArgentina",
      "bar__1": "VivaArgentina",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Argentina",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 9263,
      "bar": "",
      "�װ����": "VizionAir",
      "bar__1": "VizionAir",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Belgium",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 9264,
      "bar": "",
      "�װ����": "Vladikavkaz Air Enterprise",
      "bar__1": "Vladikavkaz Air Enterprise",
      "IATA": "",
      "bar__2": "OSV",
      "ICAO": "Russia",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8806,
      "bar": "",
      "�װ����": "VOEPASS",
      "bar__1": "VOEPASS",
      "IATA": "2Z",
      "bar__2": "PTB",
      "ICAO": "Brazil",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 9265,
      "bar": "",
      "�װ����": "Voi Air",
      "bar__1": "Voi Air",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Dominican Republic",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8063,
      "bar": "",
      "�װ����": "Barbuda Airways",
      "bar__1": "Barbuda Airways",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Antigua and Barbuda",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8065,
      "bar": "",
      "�װ����": "Barkol Aviakompania",
      "bar__1": "Barkol Aviakompania",
      "IATA": "",
      "bar__2": "BKL",
      "ICAO": "Russia",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8066,
      "bar": "",
      "�װ����": "Baron Aviation Services",
      "bar__1": "Baron Aviation Services",
      "IATA": "",
      "bar__2": "BVN",
      "ICAO": "United States",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8067,
      "bar": "",
      "�װ����": "Barq Aviation",
      "bar__1": "Barq Aviation",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Jordan",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8068,
      "bar": "",
      "�װ����": "Barrier Air",
      "bar__1": "Barrier Air",
      "IATA": "",
      "bar__2": "",
      "ICAO": "New Zealand",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8069,
      "bar": "",
      "�װ����": "Batik Air",
      "bar__1": "Batik Air",
      "IATA": "ID",
      "bar__2": "BTK",
      "ICAO": "Indonesia",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8070,
      "bar": "",
      "�װ����": "Bay Air Aviation",
      "bar__1": "Bay Air Aviation",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Namibia",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8071,
      "bar": "",
      "�װ����": "BBZR Cargo",
      "bar__1": "BBZR Cargo",
      "IATA": "",
      "bar__2": "",
      "ICAO": "South Africa",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8352,
      "bar": "",
      "�װ����": "Fly540 Tanzania",
      "bar__1": "Fly540 Tanzania",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Tanzania",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8353,
      "bar": "",
      "�װ����": "flyadeal",
      "bar__1": "flyadeal",
      "IATA": "F3",
      "bar__2": "FAD",
      "ICAO": "Saudi Arabia",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8354,
      "bar": "",
      "�װ����": "FlyArystan",
      "bar__1": "FlyArystan",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Kazakhstan",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 9358,
      "bar": "",
      "�װ����": "flybig",
      "bar__1": "flybig",
      "IATA": "S9",
      "bar__2": "FLG",
      "ICAO": "India",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8355,
      "bar": "",
      "�װ����": "Flybondi",
      "bar__1": "Flybondi",
      "IATA": "FO",
      "bar__2": "FBZ",
      "ICAO": "Argentina",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8356,
      "bar": "",
      "�װ����": "FlyBosnia",
      "bar__1": "FlyBosnia",
      "IATA": "",
      "bar__2": "FBS",
      "ICAO": "Bosnia and Herzegovina",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8358,
      "bar": "",
      "�װ����": "Flycana",
      "bar__1": "Flycana",
      "IATA": "DW",
      "bar__2": "DWI",
      "ICAO": "Dominican Republic",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8359,
      "bar": "",
      "�װ����": "flyComoros",
      "bar__1": "flyComoros",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Comoros",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8361,
      "bar": "",
      "�װ����": "FLYeasy",
      "bar__1": "FLYeasy",
      "IATA": "",
      "bar__2": "",
      "ICAO": "India",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 7178,
      "bar": "",
      "�װ����": "FlyEgypt",
      "bar__1": "FlyEgypt",
      "IATA": "FT",
      "bar__2": "FEG",
      "ICAO": "Egypt",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8362,
      "bar": "",
      "�װ����": "Flyest",
      "bar__1": "Flyest",
      "IATA": "FQ",
      "bar__2": "AEG",
      "ICAO": "Argentina",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8363,
      "bar": "",
      "�װ����": "flyGlobal",
      "bar__1": "flyGlobal",
      "IATA": "FS",
      "bar__2": "FGG",
      "ICAO": "Malaysia",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 9359,
      "bar": "",
      "�װ����": "flyGTA Airlines",
      "bar__1": "flyGTA Airlines",
      "IATA": "SX",
      "bar__2": "TOR",
      "ICAO": "Canada",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8364,
      "bar": "",
      "�װ����": "Flying Fish Airline CC",
      "bar__1": "Flying Fish Airline CC",
      "IATA": "",
      "bar__2": "",
      "ICAO": "South Africa",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8365,
      "bar": "",
      "�װ����": "FlyMe",
      "bar__1": "FlyMe",
      "IATA": "VP",
      "bar__2": "VQI",
      "ICAO": "Maldives",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8366,
      "bar": "",
      "�װ����": "FlyMex",
      "bar__1": "FlyMex",
      "IATA": "",
      "bar__2": "NTG",
      "ICAO": "Mexico",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8367,
      "bar": "",
      "�װ����": "Flymii",
      "bar__1": "Flymii",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Portugal",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8368,
      "bar": "",
      "�װ����": "FlyMontserrat",
      "bar__1": "FlyMontserrat",
      "IATA": "5M",
      "bar__2": "MNT",
      "ICAO": "United Kingdom",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 7130,
      "bar": "",
      "�װ����": "FlyPelican",
      "bar__1": "FlyPelican",
      "IATA": "FP",
      "bar__2": "",
      "ICAO": "Australia",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 9360,
      "bar": "",
      "�װ����": "flyPersia",
      "bar__1": "flyPersia",
      "IATA": "FP",
      "bar__2": "FPI",
      "ICAO": "Iran",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 9361,
      "bar": "",
      "�װ����": "Flyr",
      "bar__1": "Flyr",
      "IATA": "FS",
      "bar__2": "FOX",
      "ICAO": "Norway",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8369,
      "bar": "",
      "�װ����": "FlySafair",
      "bar__1": "FlySafair",
      "IATA": "FA",
      "bar__2": "SFR",
      "ICAO": "South Africa",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8370,
      "bar": "",
      "�װ����": "FlyToo",
      "bar__1": "FlyToo",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Canada",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8371,
      "bar": "",
      "�װ����": "flyValan",
      "bar__1": "flyValan",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Italy",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8372,
      "bar": "",
      "�װ����": "Fort Frances Sportsmen Airways",
      "bar__1": "Fort Frances Sportsmen Airways",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Canada",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8373,
      "bar": "",
      "�װ����": "Fortune Air",
      "bar__1": "Fortune Air",
      "IATA": "",
      "bar__2": "",
      "ICAO": "South Africa",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8374,
      "bar": "",
      "�װ����": "Free Airways",
      "bar__1": "Free Airways",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Greece",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8375,
      "bar": "",
      "�װ����": "Free Falcon Air",
      "bar__1": "Free Falcon Air",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Libya",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 7129,
      "bar": "",
      "�װ����": "Free Spirit Airlines",
      "bar__1": "Free Spirit Airlines",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Australia",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8376,
      "bar": "",
      "�װ����": "Freebird Airlines",
      "bar__1": "Freebird Airlines",
      "IATA": "FH",
      "bar__2": "FHY",
      "ICAO": "Turkey",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8377,
      "bar": "",
      "�װ����": "Freebird Europe",
      "bar__1": "Freebird Europe",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Malta",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8378,
      "bar": "",
      "�װ����": "Freedom Air",
      "bar__1": "Freedom Air",
      "IATA": "",
      "bar__2": "FRI",
      "ICAO": "Guam",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8379,
      "bar": "",
      "�װ����": "Freedom Air Express",
      "bar__1": "Freedom Air Express",
      "IATA": "",
      "bar__2": "FDT",
      "ICAO": "Kenya",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8380,
      "bar": "",
      "�װ����": "Freight Runners Express",
      "bar__1": "Freight Runners Express",
      "IATA": "",
      "bar__2": "FRG",
      "ICAO": "United States",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8381,
      "bar": "",
      "�װ����": "French Bee",
      "bar__1": "French Bee",
      "IATA": "BF",
      "bar__2": "FBU",
      "ICAO": "France",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 7166,
      "bar": "",
      "�װ����": "One Airlines",
      "bar__1": "One Airlines",
      "IATA": "",
      "bar__2": "ONS",
      "ICAO": "Chile",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8786,
      "bar": "",
      "�װ����": "One Sky Cargo Services",
      "bar__1": "One Sky Cargo Services",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Philippines",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8788,
      "bar": "",
      "�װ����": "Orange Air",
      "bar__1": "Orange Air",
      "IATA": "",
      "bar__2": "",
      "ICAO": "United States",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8789,
      "bar": "",
      "�װ����": "Orange2fly",
      "bar__1": "Orange2fly",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Greece",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8790,
      "bar": "",
      "�װ����": "Orenburg Airlines",
      "bar__1": "Orenburg Airlines",
      "IATA": "O7",
      "bar__2": "ORG",
      "ICAO": "Russia",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8791,
      "bar": "",
      "�װ����": "Oriental Air Bridge",
      "bar__1": "Oriental Air Bridge",
      "IATA": "OC",
      "bar__2": "ORC",
      "ICAO": "Japan",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 7131,
      "bar": "",
      "�װ����": "Originair",
      "bar__1": "Originair",
      "IATA": "OG",
      "bar__2": "OGN",
      "ICAO": "New Zealand",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8792,
      "bar": "",
      "�װ����": "Osprey Wings",
      "bar__1": "Osprey Wings",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Canada",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 9382,
      "bar": "",
      "�װ����": "OTT Airlines",
      "bar__1": "OTT Airlines",
      "IATA": "MU",
      "bar__2": "OTT",
      "ICAO": "China",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 9383,
      "bar": "",
      "�װ����": "OWG",
      "bar__1": "OWG",
      "IATA": "N5",
      "bar__2": "NRL",
      "ICAO": "Canada",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8793,
      "bar": "",
      "�װ����": "Pacific Air Cargo",
      "bar__1": "Pacific Air Cargo",
      "IATA": "",
      "bar__2": "",
      "ICAO": "United States",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8794,
      "bar": "",
      "�װ����": "Pacific Airways Corporation",
      "bar__1": "Pacific Airways Corporation",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Philippines",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8795,
      "bar": "",
      "�װ����": "Pacific Ocean",
      "bar__1": "Pacific Ocean",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Argentina",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8796,
      "bar": "",
      "�װ����": "PAL Airlines",
      "bar__1": "PAL Airlines",
      "IATA": "PB",
      "bar__2": "PVL",
      "ICAO": "Canada",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8797,
      "bar": "",
      "�װ����": "PanAfriqiyah",
      "bar__1": "PanAfriqiyah",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Malta",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8798,
      "bar": "",
      "�װ����": "PANH",
      "bar__1": "PANH",
      "IATA": "PA",
      "bar__2": "PAN",
      "ICAO": "Russia",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8799,
      "bar": "",
      "�װ����": "PANKh Avia",
      "bar__1": "PANKh Avia",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Russia",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 7995,
      "bar": "",
      "�װ����": "Armenia Aircompany",
      "bar__1": "Armenia Aircompany",
      "IATA": "RM",
      "bar__2": "NGT",
      "ICAO": "Armenia",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 7996,
      "bar": "",
      "�װ����": "Armenia Airways",
      "bar__1": "Armenia Airways",
      "IATA": "6A",
      "bar__2": "AMW",
      "ICAO": "Armenia",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 7997,
      "bar": "",
      "�װ����": "ARP 410 Airlines",
      "bar__1": "ARP 410 Airlines",
      "IATA": "",
      "bar__2": "URP",
      "ICAO": "Ukraine",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 9345,
      "bar": "",
      "�װ����": "Bees Airline",
      "bar__1": "Bees Airline",
      "IATA": "7B",
      "bar__2": "UBE",
      "ICAO": "Ukraine",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8072,
      "bar": "",
      "�װ����": "Beijing Capital Airlines",
      "bar__1": "Beijing Capital Airlines",
      "IATA": "JD",
      "bar__2": "CBJ",
      "ICAO": "China",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8383,
      "bar": "",
      "�װ����": "Fuga Air Charter",
      "bar__1": "Fuga Air Charter",
      "IATA": "",
      "bar__2": "",
      "ICAO": "United States",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8384,
      "bar": "",
      "�װ����": "Fuzhou Airlines",
      "bar__1": "Fuzhou Airlines",
      "IATA": "FU",
      "bar__2": "FZA",
      "ICAO": "China",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8385,
      "bar": "",
      "�װ����": "Gainjet Aviation",
      "bar__1": "Gainjet Aviation",
      "IATA": "",
      "bar__2": "GNJ",
      "ICAO": "Greece",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8386,
      "bar": "",
      "�װ����": "Galeyr Airline",
      "bar__1": "Galeyr Airline",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Somalia",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 9362,
      "bar": "",
      "�װ����": "Galistair Malta",
      "bar__1": "Galistair Malta",
      "IATA": "",
      "bar__2": "GTR",
      "ICAO": "Malta",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8388,
      "bar": "",
      "�װ����": "Gama Aviation Plc",
      "bar__1": "Gama Aviation Plc",
      "IATA": "",
      "bar__2": "GSH",
      "ICAO": "United Kingdom",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8390,
      "bar": "",
      "�װ����": "Gatari Air Service",
      "bar__1": "Gatari Air Service",
      "IATA": "",
      "bar__2": "GHS",
      "ICAO": "Indonesia",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8391,
      "bar": "",
      "�װ����": "GB AirLink",
      "bar__1": "GB AirLink",
      "IATA": "",
      "bar__2": "GBX",
      "ICAO": "United States",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8392,
      "bar": "",
      "�װ����": "GCA Air",
      "bar__1": "GCA Air",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Colombia",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8393,
      "bar": "",
      "�װ����": "GEASA",
      "bar__1": "GEASA",
      "IATA": "",
      "bar__2": "GEA",
      "ICAO": "Equatorial Guinea",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8394,
      "bar": "",
      "�װ����": "General Airways",
      "bar__1": "General Airways",
      "IATA": "",
      "bar__2": "",
      "ICAO": "South Africa",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8395,
      "bar": "",
      "�װ����": "Genex",
      "bar__1": "Genex",
      "IATA": "",
      "bar__2": "GNX",
      "ICAO": "Belarus",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8396,
      "bar": "",
      "�װ����": "Genghis Khan Airlines",
      "bar__1": "Genghis Khan Airlines",
      "IATA": "",
      "bar__2": "",
      "ICAO": "China",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8397,
      "bar": "",
      "�װ����": "GENSA",
      "bar__1": "GENSA",
      "IATA": "",
      "bar__2": "GEN",
      "ICAO": "Brazil",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 9281,
      "bar": "",
      "�װ����": "German Regional Airlines",
      "bar__1": "German Regional Airlines",
      "IATA": "WH",
      "bar__2": "WDL",
      "ICAO": "Germany",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8399,
      "bar": "",
      "�װ����": "GetJet Airlines",
      "bar__1": "GetJet Airlines",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Lithuania",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8400,
      "bar": "",
      "�װ����": "GETRA",
      "bar__1": "GETRA",
      "IATA": "",
      "bar__2": "GET",
      "ICAO": "Equatorial Guinea",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8401,
      "bar": "",
      "�װ����": "Ghadames Air Transport",
      "bar__1": "Ghadames Air Transport",
      "IATA": "",
      "bar__2": "GHT",
      "ICAO": "Liberia",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8402,
      "bar": "",
      "�װ����": "GI Aviation",
      "bar__1": "GI Aviation",
      "IATA": "",
      "bar__2": "",
      "ICAO": "United Arab Emirates",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8403,
      "bar": "",
      "�װ����": "GjaevAir",
      "bar__1": "GjaevAir",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Norway",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8405,
      "bar": "",
      "�װ����": "Global Air",
      "bar__1": "Global Air",
      "IATA": "",
      "bar__2": "DMJ",
      "ICAO": "Mexico",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8406,
      "bar": "",
      "�װ����": "Global Aviation",
      "bar__1": "Global Aviation",
      "IATA": "GE",
      "bar__2": "GBB",
      "ICAO": "South Africa",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8407,
      "bar": "",
      "�װ����": "Global Aviation and Services Group",
      "bar__1": "Global Aviation and Services Group",
      "IATA": "5S",
      "bar__2": "GAK",
      "ICAO": "Libya",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8408,
      "bar": "",
      "�װ����": "Global Vectra Helicorp",
      "bar__1": "Global Vectra Helicorp",
      "IATA": "",
      "bar__2": "",
      "ICAO": "India",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8409,
      "bar": "",
      "�װ����": "GM Helicopters",
      "bar__1": "GM Helicopters",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Latvia",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8410,
      "bar": "",
      "�װ����": "Go Fly Airlines",
      "bar__1": "Go Fly Airlines",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Saint Lucia",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8411,
      "bar": "",
      "�װ����": "Go2Sky",
      "bar__1": "Go2Sky",
      "IATA": "6G",
      "bar__2": "RLX",
      "ICAO": "Slovakia",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8412,
      "bar": "",
      "�װ����": "GoAir",
      "bar__1": "GoAir",
      "IATA": "G8",
      "bar__2": "GOW",
      "ICAO": "India",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8413,
      "bar": "",
      "�װ����": "GoAir Citylink",
      "bar__1": "GoAir Citylink",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Canada",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 9363,
      "bar": "",
      "�װ����": "Golden Bay Air",
      "bar__1": "Golden Bay Air",
      "IATA": "G1",
      "bar__2": "GBY",
      "ICAO": "New Zealand",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8800,
      "bar": "",
      "�װ����": "Paradigm Air Operators",
      "bar__1": "Paradigm Air Operators",
      "IATA": "",
      "bar__2": "",
      "ICAO": "United States",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8802,
      "bar": "",
      "�װ����": "Paradise Air",
      "bar__1": "Paradise Air",
      "IATA": "",
      "bar__2": "",
      "ICAO": "United States",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8803,
      "bar": "",
      "�װ����": "Paramount Jet",
      "bar__1": "Paramount Jet",
      "IATA": "",
      "bar__2": "",
      "ICAO": "United States",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8804,
      "bar": "",
      "�װ����": "Paranair",
      "bar__1": "Paranair",
      "IATA": "ZP",
      "bar__2": "AZP",
      "ICAO": "Paraguay",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8805,
      "bar": "",
      "�װ����": "Pascan Aviation",
      "bar__1": "Pascan Aviation",
      "IATA": "P6",
      "bar__2": "PSC",
      "ICAO": "Canada",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8807,
      "bar": "",
      "�װ����": "PassionAir",
      "bar__1": "PassionAir",
      "IATA": "OP",
      "bar__2": "DIG",
      "ICAO": "Ghana",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8808,
      "bar": "",
      "�װ����": "Patagonia Airlines a",
      "bar__1": "Patagonia Airlines a",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Chile",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8809,
      "bar": "",
      "�װ����": "PAWA Dominicana",
      "bar__1": "PAWA Dominicana",
      "IATA": "7N",
      "bar__2": "PWD",
      "ICAO": "Dominican Republic",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8810,
      "bar": "",
      "�װ����": "Payam Air",
      "bar__1": "Payam Air",
      "IATA": "2F",
      "bar__2": "IRP",
      "ICAO": "Iran",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8811,
      "bar": "",
      "�װ����": "PC Air",
      "bar__1": "PC Air",
      "IATA": "",
      "bar__2": "PCA",
      "ICAO": "Thailand",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8812,
      "bar": "",
      "�װ����": "Peace Air",
      "bar__1": "Peace Air",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Sri Lanka",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8813,
      "bar": "",
      "�װ����": "Pearl Aviation Australia Pty",
      "bar__1": "Pearl Aviation Australia Pty",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Australia",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8814,
      "bar": "",
      "�װ����": "Pegas Fly",
      "bar__1": "Pegas Fly",
      "IATA": "EO",
      "bar__2": "KAR",
      "ICAO": "Russia",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8815,
      "bar": "",
      "�װ����": "Pegase Aviation",
      "bar__1": "Pegase Aviation",
      "IATA": "",
      "bar__2": "",
      "ICAO": "South Africa",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8816,
      "bar": "",
      "�װ����": "Pegasus Air Services",
      "bar__1": "Pegasus Air Services",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Indonesia",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8817,
      "bar": "",
      "�װ����": "Pel-Air",
      "bar__1": "Pel-Air",
      "IATA": "",
      "bar__2": "PFY",
      "ICAO": "Australia",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8818,
      "bar": "",
      "�װ����": "Pelita Air Service",
      "bar__1": "Pelita Air Service",
      "IATA": "6D",
      "bar__2": "PAS",
      "ICAO": "Indonesia",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8819,
      "bar": "",
      "�װ����": "Penas Air",
      "bar__1": "Penas Air",
      "IATA": "",
      "bar__2": "PNS",
      "ICAO": "Indonesia",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8820,
      "bar": "",
      "�װ����": "PENTA",
      "bar__1": "PENTA",
      "IATA": "",
      "bar__2": "PEP",
      "ICAO": "Brazil",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8821,
      "bar": "",
      "�װ����": "Perimeter Aviation",
      "bar__1": "Perimeter Aviation",
      "IATA": "YP",
      "bar__2": "PAG",
      "ICAO": "Canada",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8822,
      "bar": "",
      "�װ����": "Petroleum Air Services",
      "bar__1": "Petroleum Air Services",
      "IATA": "UF",
      "bar__2": "PER",
      "ICAO": "Egypt",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8823,
      "bar": "",
      "�װ����": "Petropavlovsk-Kamchatsky Air Enterprise",
      "bar__1": "Petropavlovsk-Kamchatsky Air Enterprise",
      "IATA": "",
      "bar__2": "PTK",
      "ICAO": "Russia",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8824,
      "bar": "",
      "�װ����": "Phakalane Airways",
      "bar__1": "Phakalane Airways",
      "IATA": "",
      "bar__2": "",
      "ICAO": "South Africa",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8825,
      "bar": "",
      "�װ����": "PHI",
      "bar__1": "PHI",
      "IATA": "",
      "bar__2": "",
      "ICAO": "United States",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8826,
      "bar": "",
      "�װ����": "PHI Petroleum Helicopters",
      "bar__1": "PHI Petroleum Helicopters",
      "IATA": "",
      "bar__2": "PHM",
      "ICAO": "United States",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8827,
      "bar": "",
      "�װ����": "PHI Venezuela",
      "bar__1": "PHI Venezuela",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Venezuela",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8828,
      "bar": "",
      "�װ����": "Philippines AirAsia",
      "bar__1": "Philippines AirAsia",
      "IATA": "Z2",
      "bar__2": "APG",
      "ICAO": "Philippines",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8829,
      "bar": "",
      "�װ����": "Phnom Penh Air Cargo",
      "bar__1": "Phnom Penh Air Cargo",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Cambodia",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8830,
      "bar": "",
      "�װ����": "Phoebus Apollo Aviation",
      "bar__1": "Phoebus Apollo Aviation",
      "IATA": "",
      "bar__2": "PHB",
      "ICAO": "South Africa",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8831,
      "bar": "",
      "�װ����": "Phoenix Air",
      "bar__1": "Phoenix Air",
      "IATA": "",
      "bar__2": "PHA",
      "ICAO": "United States",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8832,
      "bar": "",
      "�װ����": "Phoenix Airways",
      "bar__1": "Phoenix Airways",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Saint Kitts and Nevis",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8833,
      "bar": "",
      "�װ����": "Phoenix Aviation",
      "bar__1": "Phoenix Aviation",
      "IATA": "",
      "bar__2": "PHN",
      "ICAO": "Kenya",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8834,
      "bar": "",
      "�װ����": "Phuket Air",
      "bar__1": "Phuket Air",
      "IATA": "",
      "bar__2": "VAP",
      "ICAO": "Thailand",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 7999,
      "bar": "",
      "�װ����": "As Salaam Air",
      "bar__1": "As Salaam Air",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Tanzania",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8000,
      "bar": "",
      "�װ����": "Asahi Airlines",
      "bar__1": "Asahi Airlines",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Japan",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8073,
      "bar": "",
      "�װ����": "Belogorie",
      "bar__1": "Belogorie",
      "IATA": "",
      "bar__2": "BLO",
      "ICAO": "Russia",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 7880,
      "bar": "",
      "�װ����": "Benin Airlines",
      "bar__1": "Benin Airlines",
      "IATA": "",
      "bar__2": "ABT",
      "ICAO": "Benin",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8074,
      "bar": "",
      "�װ����": "Bergen Air Transport",
      "bar__1": "Bergen Air Transport",
      "IATA": "",
      "bar__2": "BGT",
      "ICAO": "Norway",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8075,
      "bar": "",
      "�װ����": "Berkut West",
      "bar__1": "Berkut West",
      "IATA": "",
      "bar__2": "BPK",
      "ICAO": "Kazakhstan",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8414,
      "bar": "",
      "�װ����": "Golden Wings Aviation",
      "bar__1": "Golden Wings Aviation",
      "IATA": "",
      "bar__2": "",
      "ICAO": "South Africa",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8415,
      "bar": "",
      "�װ����": "Golden Wings Aviation South Sudan",
      "bar__1": "Golden Wings Aviation South Sudan",
      "IATA": "",
      "bar__2": "",
      "ICAO": "South Sudan",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8416,
      "bar": "",
      "�װ����": "Goldstar Air",
      "bar__1": "Goldstar Air",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Ghana",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8417,
      "bar": "",
      "�װ����": "Good Fly",
      "bar__1": "Good Fly",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Spain",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8418,
      "bar": "",
      "�װ����": "goTO-Nordics",
      "bar__1": "goTO-Nordics",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Norway",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8419,
      "bar": "",
      "�װ����": "Gowair",
      "bar__1": "Gowair",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Spain",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8421,
      "bar": "",
      "�װ����": "Grafair",
      "bar__1": "Grafair",
      "IATA": "",
      "bar__2": "GFM",
      "ICAO": "Sweden",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8422,
      "bar": "",
      "�װ����": "Grand Canyon Airlines",
      "bar__1": "Grand Canyon Airlines",
      "IATA": "YR",
      "bar__2": "CVU",
      "ICAO": "United States",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 7141,
      "bar": "",
      "�װ����": "Grand Cru Airlines",
      "bar__1": "Grand Cru Airlines",
      "IATA": "",
      "bar__2": "GCA",
      "ICAO": "Lithuania",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8423,
      "bar": "",
      "�װ����": "Great Dane Airlines",
      "bar__1": "Great Dane Airlines",
      "IATA": "",
      "bar__2": "GDE",
      "ICAO": "Denmark",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8424,
      "bar": "",
      "�װ����": "Green Africa",
      "bar__1": "Green Africa",
      "IATA": "Q9",
      "bar__2": "GWG",
      "ICAO": "Nigeria",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8425,
      "bar": "",
      "�װ����": "Green Flag",
      "bar__1": "Green Flag",
      "IATA": "",
      "bar__2": "GNF",
      "ICAO": "Sudan",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8426,
      "bar": "",
      "�װ����": "Grodno Aviakompania",
      "bar__1": "Grodno Aviakompania",
      "IATA": "",
      "bar__2": "GRX",
      "ICAO": "Belarus",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8427,
      "bar": "",
      "�װ����": "GST Aero Aircompany",
      "bar__1": "GST Aero Aircompany",
      "IATA": "",
      "bar__2": "BMK",
      "ICAO": "Kazakhstan",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 7103,
      "bar": "",
      "�װ����": "Guangxi Beibu Gulf Airlines",
      "bar__1": "Guangxi Beibu Gulf Airlines",
      "IATA": "GX",
      "bar__2": "CBG",
      "ICAO": "China",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8430,
      "bar": "",
      "�װ����": "Guicango",
      "bar__1": "Guicango",
      "IATA": "",
      "bar__2": "NCL",
      "ICAO": "Angola",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8433,
      "bar": "",
      "�װ����": "Gulf & Caribbean Air",
      "bar__1": "Gulf & Caribbean Air",
      "IATA": "IF",
      "bar__2": "TSU",
      "ICAO": "United States",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 9364,
      "bar": "",
      "�װ����": "GullivAir",
      "bar__1": "GullivAir",
      "IATA": "G2",
      "bar__2": "GBG",
      "ICAO": "Bulgaria",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8434,
      "bar": "",
      "�װ����": "Gum Air",
      "bar__1": "Gum Air",
      "IATA": "",
      "bar__2": "GUM",
      "ICAO": "Suriname",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8437,
      "bar": "",
      "�װ����": "Hahn Air",
      "bar__1": "Hahn Air",
      "IATA": "HR",
      "bar__2": "HHN",
      "ICAO": "Germany",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8438,
      "bar": "",
      "�װ����": "Hai Au Aviation",
      "bar__1": "Hai Au Aviation",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Viet Nam",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8440,
      "bar": "",
      "�װ����": "Hangzhou YTO Express Airlines",
      "bar__1": "Hangzhou YTO Express Airlines",
      "IATA": "YG",
      "bar__2": "HYT",
      "ICAO": "China",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8441,
      "bar": "",
      "�װ����": "Hawk de Mexico",
      "bar__1": "Hawk de Mexico",
      "IATA": "",
      "bar__2": "HMX",
      "ICAO": "Mexico",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8442,
      "bar": "",
      "�װ����": "Hawkins & Powers Aviation",
      "bar__1": "Hawkins & Powers Aviation",
      "IATA": "",
      "bar__2": "",
      "ICAO": "United States",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8444,
      "bar": "",
      "�װ����": "Hearst Air Service",
      "bar__1": "Hearst Air Service",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Canada",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8445,
      "bar": "",
      "�װ����": "Hefei Airlines",
      "bar__1": "Hefei Airlines",
      "IATA": "",
      "bar__2": "",
      "ICAO": "China",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8446,
      "bar": "",
      "�װ����": "Heilongjiang Airlines",
      "bar__1": "Heilongjiang Airlines",
      "IATA": "",
      "bar__2": "",
      "ICAO": "China",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8835,
      "bar": "",
      "�װ����": "Pineapple Air",
      "bar__1": "Pineapple Air",
      "IATA": "",
      "bar__2": "PNP",
      "ICAO": "Bahamas",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8836,
      "bar": "",
      "�װ����": "Pink Aviation Services",
      "bar__1": "Pink Aviation Services",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Australia",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8837,
      "bar": "",
      "�װ����": "Pionair Australia",
      "bar__1": "Pionair Australia",
      "IATA": "PH",
      "bar__2": "SFZ",
      "ICAO": "Australia",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8838,
      "bar": "",
      "�װ����": "Planemasters",
      "bar__1": "Planemasters",
      "IATA": "",
      "bar__2": "PMS",
      "ICAO": "United States",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8839,
      "bar": "",
      "�װ����": "Planes For Africa",
      "bar__1": "Planes For Africa",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Kenya",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8840,
      "bar": "",
      "�װ����": "Plastun-Avia",
      "bar__1": "Plastun-Avia",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Russia",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8841,
      "bar": "",
      "�װ����": "Plummer's Arctic Lodges",
      "bar__1": "Plummer's Arctic Lodges",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Canada",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 7148,
      "bar": "",
      "�װ����": "Plus Ultra Lineas Aereas",
      "bar__1": "Plus Ultra Lineas Aereas",
      "IATA": "PU",
      "bar__2": "PUE",
      "ICAO": "Spain",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 7136,
      "bar": "",
      "�װ����": "Pobeda Airlines",
      "bar__1": "Pobeda Airlines",
      "IATA": "DP",
      "bar__2": "PBD",
      "ICAO": "Russia",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8842,
      "bar": "",
      "�װ����": "Podillia Avia",
      "bar__1": "Podillia Avia",
      "IATA": "",
      "bar__2": "PDA",
      "ICAO": "Ukraine",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8843,
      "bar": "",
      "�װ����": "Pol Air",
      "bar__1": "Pol Air",
      "IATA": "",
      "bar__2": "",
      "ICAO": "French Polynesia",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8844,
      "bar": "",
      "�װ����": "Polar Air Cargo",
      "bar__1": "Polar Air Cargo",
      "IATA": "PO",
      "bar__2": "PAC",
      "ICAO": "United States",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8845,
      "bar": "",
      "�װ����": "Polar Airlines",
      "bar__1": "Polar Airlines",
      "IATA": "PI",
      "bar__2": "RKA",
      "ICAO": "Russia",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8846,
      "bar": "",
      "�װ����": "Polar Aviation Pty",
      "bar__1": "Polar Aviation Pty",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Australia",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8847,
      "bar": "",
      "�װ����": "Polar Lineas Aereas",
      "bar__1": "Polar Lineas Aereas",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Argentina",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8848,
      "bar": "",
      "�װ����": "Polynesie Perles",
      "bar__1": "Polynesie Perles",
      "IATA": "",
      "bar__2": "",
      "ICAO": "French Polynesia",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8849,
      "bar": "",
      "�װ����": "POP",
      "bar__1": "POP",
      "IATA": "",
      "bar__2": "",
      "ICAO": "United Kingdom",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8851,
      "bar": "",
      "�װ����": "Pouya Air",
      "bar__1": "Pouya Air",
      "IATA": "PY",
      "bar__2": "PYA",
      "ICAO": "Iran",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8852,
      "bar": "",
      "�װ����": "Prams Air",
      "bar__1": "Prams Air",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Puerto Rico",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8853,
      "bar": "",
      "�װ����": "Premiair",
      "bar__1": "Premiair",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Indonesia",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8854,
      "bar": "",
      "�װ����": "Premier Airways",
      "bar__1": "Premier Airways",
      "IATA": "",
      "bar__2": "",
      "ICAO": "India",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8855,
      "bar": "",
      "�װ����": "Prescott",
      "bar__1": "Prescott",
      "IATA": "PM",
      "bar__2": "PSK",
      "ICAO": "United States",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8856,
      "bar": "",
      "�װ����": "Presidential Airways",
      "bar__1": "Presidential Airways",
      "IATA": "",
      "bar__2": "",
      "ICAO": "United States",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8857,
      "bar": "",
      "�װ����": "Prinair",
      "bar__1": "Prinair",
      "IATA": "",
      "bar__2": "PRU",
      "ICAO": "Puerto Rico",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8858,
      "bar": "",
      "�װ����": "Privilege Style",
      "bar__1": "Privilege Style",
      "IATA": "P6",
      "bar__2": "PVG",
      "ICAO": "Spain",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8859,
      "bar": "",
      "�װ����": "Pro Air Charter Aruba",
      "bar__1": "Pro Air Charter Aruba",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Aruba",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8860,
      "bar": "",
      "�װ����": "Progress TsSKB Aviakompania",
      "bar__1": "Progress TsSKB Aviakompania",
      "IATA": "",
      "bar__2": "PSS",
      "ICAO": "Russia",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8862,
      "bar": "",
      "�װ����": "Propair",
      "bar__1": "Propair",
      "IATA": "",
      "bar__2": "PRO",
      "ICAO": "Canada",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8863,
      "bar": "",
      "�װ����": "Protocole Aviation",
      "bar__1": "Protocole Aviation",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Republic of the Congo",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8864,
      "bar": "",
      "�װ����": "PSA Airlines",
      "bar__1": "PSA Airlines",
      "IATA": "OH",
      "bar__2": "JIA",
      "ICAO": "United States",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8001,
      "bar": "",
      "�װ����": "ASAP Charters CA",
      "bar__1": "ASAP Charters CA",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Venezuela",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8002,
      "bar": "",
      "�װ����": "Asas de Mocambique",
      "bar__1": "Asas de Mocambique",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Mozambique",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8003,
      "bar": "",
      "�װ����": "Asco Nusa Air",
      "bar__1": "Asco Nusa Air",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Indonesia",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8005,
      "bar": "",
      "�װ����": "Asia Pacific Airline PNG",
      "bar__1": "Asia Pacific Airline PNG",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Papua New Guinea",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8006,
      "bar": "",
      "�װ����": "Asia Pacific Airlines",
      "bar__1": "Asia Pacific Airlines",
      "IATA": "P9",
      "bar__2": "MGE",
      "ICAO": "United States",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8007,
      "bar": "",
      "�װ����": "Asian Wings Airways",
      "bar__1": "Asian Wings Airways",
      "IATA": "YJ",
      "bar__2": "AWM",
      "ICAO": "Myanmar",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 9346,
      "bar": "",
      "�װ����": "Berniq Airways",
      "bar__1": "Berniq Airways",
      "IATA": "NB",
      "bar__2": "BNL",
      "ICAO": "Libya",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8076,
      "bar": "",
      "�װ����": "Berry Aviation",
      "bar__1": "Berry Aviation",
      "IATA": "",
      "bar__2": "BYA",
      "ICAO": "United States",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8078,
      "bar": "",
      "�װ����": "BH Air",
      "bar__1": "BH Air",
      "IATA": "8H",
      "bar__2": "BGH",
      "ICAO": "Bulgaria",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8080,
      "bar": "",
      "�װ����": "BidAir Cargo",
      "bar__1": "BidAir Cargo",
      "IATA": "",
      "bar__2": "",
      "ICAO": "South Africa",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8081,
      "bar": "",
      "�װ����": "Big Island Air",
      "bar__1": "Big Island Air",
      "IATA": "",
      "bar__2": "BIG",
      "ICAO": "United States",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8083,
      "bar": "",
      "�װ����": "Bishwo Airways",
      "bar__1": "Bishwo Airways",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Nepal",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8084,
      "bar": "",
      "�װ����": "Bismillah Airlines",
      "bar__1": "Bismillah Airlines",
      "IATA": "BH",
      "bar__2": "BML",
      "ICAO": "Bangladesh",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8085,
      "bar": "",
      "�װ����": "Biznes Aero",
      "bar__1": "Biznes Aero",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Russia",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8447,
      "bar": "",
      "�װ����": "Heli Air Monaco",
      "bar__1": "Heli Air Monaco",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Monaco",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8448,
      "bar": "",
      "�װ����": "Heli Inter SA",
      "bar__1": "Heli Inter SA",
      "IATA": "",
      "bar__2": "HIN",
      "ICAO": "France",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8449,
      "bar": "",
      "�װ����": "Heli Malongo Airways",
      "bar__1": "Heli Malongo Airways",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Angola",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8450,
      "bar": "",
      "�װ����": "Heli Max",
      "bar__1": "Heli Max",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Bulgaria",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8451,
      "bar": "",
      "�װ����": "Heli Securite Helicopter Airline",
      "bar__1": "Heli Securite Helicopter Airline",
      "IATA": "HS",
      "bar__2": "",
      "ICAO": "France",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8452,
      "bar": "",
      "�װ����": "Heliandes a",
      "bar__1": "Heliandes a",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Colombia",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8453,
      "bar": "",
      "�װ����": "Helicargo SA",
      "bar__1": "Helicargo SA",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Colombia",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8454,
      "bar": "",
      "�װ����": "Helicocean",
      "bar__1": "Helicocean",
      "IATA": "",
      "bar__2": "OCE",
      "ICAO": "New Caledonia",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8455,
      "bar": "",
      "�װ����": "Helicol",
      "bar__1": "Helicol",
      "IATA": "",
      "bar__2": "HEL",
      "ICAO": "Colombia",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8456,
      "bar": "",
      "�װ����": "Helicopter Resources",
      "bar__1": "Helicopter Resources",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Australia",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8457,
      "bar": "",
      "�װ����": "Helicopteros del Sureste",
      "bar__1": "Helicopteros del Sureste",
      "IATA": "UV",
      "bar__2": "",
      "ICAO": "Spain",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8458,
      "bar": "",
      "�װ����": "Heli-drive",
      "bar__1": "Heli-drive",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Russia",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8459,
      "bar": "",
      "�װ����": "Helijet Aerotaxi a",
      "bar__1": "Helijet Aerotaxi a",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Brazil",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8460,
      "bar": "",
      "�װ����": "Helijet International",
      "bar__1": "Helijet International",
      "IATA": "JB",
      "bar__2": "JBA",
      "ICAO": "Canada",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8461,
      "bar": "",
      "�װ����": "Helikopter Air Transport",
      "bar__1": "Helikopter Air Transport",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Australia",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8462,
      "bar": "",
      "�װ����": "Heliservicio Campeche",
      "bar__1": "Heliservicio Campeche",
      "IATA": "",
      "bar__2": "HEC",
      "ICAO": "Mexico",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8463,
      "bar": "",
      "�װ����": "Helisur",
      "bar__1": "Helisur",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Peru",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8464,
      "bar": "",
      "�װ����": "Helitours",
      "bar__1": "Helitours",
      "IATA": "",
      "bar__2": "HLT",
      "ICAO": "Sri Lanka",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8465,
      "bar": "",
      "�װ����": "Helitrans",
      "bar__1": "Helitrans",
      "IATA": "",
      "bar__2": "HTA",
      "ICAO": "Norway",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8466,
      "bar": "",
      "�װ����": "Helivan",
      "bar__1": "Helivan",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Mexico",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8467,
      "bar": "",
      "�װ����": "Hellivalle SA",
      "bar__1": "Hellivalle SA",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Colombia",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8468,
      "bar": "",
      "�װ����": "Hello Airlines",
      "bar__1": "Hello Airlines",
      "IATA": "H3",
      "bar__2": "",
      "ICAO": "Bangladesh",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8469,
      "bar": "",
      "�װ����": "Helvetic Airways",
      "bar__1": "Helvetic Airways",
      "IATA": "2L",
      "bar__2": "OAW",
      "ICAO": "Sweden",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8470,
      "bar": "",
      "�װ����": "Henan Cargo Airlines",
      "bar__1": "Henan Cargo Airlines",
      "IATA": "",
      "bar__2": "",
      "ICAO": "China",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8471,
      "bar": "",
      "�װ����": "Hercules",
      "bar__1": "Hercules",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Brazil",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8472,
      "bar": "",
      "�װ����": "Heringer Taxi Aereo",
      "bar__1": "Heringer Taxi Aereo",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Brazil",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8473,
      "bar": "",
      "�װ����": "Heritage Air",
      "bar__1": "Heritage Air",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Malaysia",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 9365,
      "bar": "",
      "�װ����": "Heston Airlines",
      "bar__1": "Heston Airlines",
      "IATA": "",
      "bar__2": "HST",
      "ICAO": "Lithuania",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8474,
      "bar": "",
      "�װ����": "Hevilift Aviation Indonesia",
      "bar__1": "Hevilift Aviation Indonesia",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Indonesia",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8475,
      "bar": "",
      "�װ����": "Hi Fly",
      "bar__1": "Hi Fly",
      "IATA": "5K",
      "bar__2": "HFY",
      "ICAO": "Portugal",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8476,
      "bar": "",
      "�װ����": "Hi Fly Malta",
      "bar__1": "Hi Fly Malta",
      "IATA": "",
      "bar__2": "HFM",
      "ICAO": "Malta",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8477,
      "bar": "",
      "�װ����": "Hibernian Airlines",
      "bar__1": "Hibernian Airlines",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Spain",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 7122,
      "bar": "",
      "�װ����": "Himalaya Airlines",
      "bar__1": "Himalaya Airlines",
      "IATA": "H9",
      "bar__2": "HIM",
      "ICAO": "Nepal",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8478,
      "bar": "",
      "�װ����": "Himalayan Bulls Airlines",
      "bar__1": "Himalayan Bulls Airlines",
      "IATA": "",
      "bar__2": "",
      "ICAO": "India",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 9366,
      "bar": "",
      "�װ����": "HiSky (Moldova)",
      "bar__1": "HiSky (Moldova)",
      "IATA": "",
      "bar__2": "HYM",
      "ICAO": "Moldova",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 9367,
      "bar": "",
      "�װ����": "HiSky (Romania)",
      "bar__1": "HiSky (Romania)",
      "IATA": "H4",
      "bar__2": "HYS",
      "ICAO": "Romania",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8479,
      "bar": "",
      "�װ����": "HNZ Cougar Helicopters Pty",
      "bar__1": "HNZ Cougar Helicopters Pty",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Australia",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8480,
      "bar": "",
      "�װ����": "Hokkaido Air System",
      "bar__1": "Hokkaido Air System",
      "IATA": "6L",
      "bar__2": "NTH",
      "ICAO": "Japan",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8481,
      "bar": "",
      "�װ����": "Hong Kong Air Cargo",
      "bar__1": "Hong Kong Air Cargo",
      "IATA": "RH",
      "bar__2": "HKC",
      "ICAO": "Hong Kong",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8866,
      "bar": "",
      "�װ����": "Punto Azul",
      "bar__1": "Punto Azul",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Equatorial Guinea",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8867,
      "bar": "",
      "�װ����": "QantasLink",
      "bar__1": "QantasLink",
      "IATA": "QF",
      "bar__2": "QLK",
      "ICAO": "Australia",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8868,
      "bar": "",
      "�װ����": "Qazaq Air",
      "bar__1": "Qazaq Air",
      "IATA": "IQ",
      "bar__2": "QAZ",
      "ICAO": "Kazakhstan",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 7105,
      "bar": "",
      "�װ����": "Qingdao Airlines",
      "bar__1": "Qingdao Airlines",
      "IATA": "QW",
      "bar__2": "QDA",
      "ICAO": "China",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8869,
      "bar": "",
      "�װ����": "Queen Bilqis Airways",
      "bar__1": "Queen Bilqis Airways",
      "IATA": "",
      "bar__2": "QBA",
      "ICAO": "Yemen",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8870,
      "bar": "",
      "�װ����": "R1 Airlines",
      "bar__1": "R1 Airlines",
      "IATA": "",
      "bar__2": "TSH",
      "ICAO": "Canada",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 7142,
      "bar": "",
      "�װ����": "Rada Airlines",
      "bar__1": "Rada Airlines",
      "IATA": "",
      "bar__2": "RDA",
      "ICAO": "Belarus",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8872,
      "bar": "",
      "�װ����": "RAF Avia",
      "bar__1": "RAF Avia",
      "IATA": "",
      "bar__2": "MTL",
      "ICAO": "Latvia",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8873,
      "bar": "",
      "�װ����": "Rahila Air",
      "bar__1": "Rahila Air",
      "IATA": "",
      "bar__2": "RIH",
      "ICAO": "Libya",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8874,
      "bar": "",
      "�װ����": "Rainbow Airlines",
      "bar__1": "Rainbow Airlines",
      "IATA": "",
      "bar__2": "RAT",
      "ICAO": "Zimbabwe",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8875,
      "bar": "",
      "�װ����": "Raul Helicopters",
      "bar__1": "Raul Helicopters",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Venezuela",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8876,
      "bar": "",
      "�װ����": "Ravn Alaska",
      "bar__1": "Ravn Alaska",
      "IATA": "7H",
      "bar__2": "RVF",
      "ICAO": "United States",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8877,
      "bar": "",
      "�װ����": "Raya Airways",
      "bar__1": "Raya Airways",
      "IATA": "TH",
      "bar__2": "RMY",
      "ICAO": "Malaysia",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8879,
      "bar": "",
      "�װ����": "Rectrix Aviation",
      "bar__1": "Rectrix Aviation",
      "IATA": "",
      "bar__2": "RIX",
      "ICAO": "United States",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8880,
      "bar": "",
      "�װ����": "Red Wings",
      "bar__1": "Red Wings",
      "IATA": "WZ",
      "bar__2": "RWZ",
      "ICAO": "Russia",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8881,
      "bar": "",
      "�װ����": "Regais Airlines",
      "bar__1": "Regais Airlines",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Chile",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8882,
      "bar": "",
      "�װ����": "RegionAir",
      "bar__1": "RegionAir",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Gabon",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8883,
      "bar": "",
      "�װ����": "Regional Air",
      "bar__1": "Regional Air",
      "IATA": "8N",
      "bar__2": "REG",
      "ICAO": "Tanzania",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8885,
      "bar": "",
      "�װ����": "Regional Express Americas",
      "bar__1": "Regional Express Americas",
      "IATA": "EX",
      "bar__2": "",
      "ICAO": "Colombia",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8887,
      "bar": "",
      "�װ����": "Regional Sky",
      "bar__1": "Regional Sky",
      "IATA": "4P",
      "bar__2": "",
      "ICAO": "United States",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8888,
      "bar": "",
      "�װ����": "Reignwood Aviation",
      "bar__1": "Reignwood Aviation",
      "IATA": "",
      "bar__2": "",
      "ICAO": "China",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8889,
      "bar": "",
      "�װ����": "Republic Express Airlines",
      "bar__1": "Republic Express Airlines",
      "IATA": "RH",
      "bar__2": "RPH",
      "ICAO": "Indonesia",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8890,
      "bar": "",
      "�װ����": "RepublicAir",
      "bar__1": "RepublicAir",
      "IATA": "",
      "bar__2": "RBC",
      "ICAO": "Mexico",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8891,
      "bar": "",
      "�װ����": "Revere Aviation",
      "bar__1": "Revere Aviation",
      "IATA": "",
      "bar__2": "",
      "ICAO": "United States",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8892,
      "bar": "",
      "�װ����": "Rey Airlines",
      "bar__1": "Rey Airlines",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Turkey",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8893,
      "bar": "",
      "�װ����": "Rhein-Neckar Air",
      "bar__1": "Rhein-Neckar Air",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Germany",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8894,
      "bar": "",
      "�װ����": "Rigas Aeroclub",
      "bar__1": "Rigas Aeroclub",
      "IATA": "",
      "bar__2": "RAK",
      "ICAO": "Latvia",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8895,
      "bar": "",
      "�װ����": "River Air",
      "bar__1": "River Air",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Canada",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8008,
      "bar": "",
      "�װ����": "ASL Airlines Belgium",
      "bar__1": "ASL Airlines Belgium",
      "IATA": "3V",
      "bar__2": "TAY",
      "ICAO": "Belgium",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8086,
      "bar": "",
      "�װ����": "Black Sea Airlines",
      "bar__1": "Black Sea Airlines",
      "IATA": "",
      "bar__2": "ODA",
      "ICAO": "Ukraine",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8087,
      "bar": "",
      "�װ����": "Black Sheep Aviation & Cattle Co",
      "bar__1": "Black Sheep Aviation & Cattle Co",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Canada",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8088,
      "bar": "",
      "�װ����": "Blackbird",
      "bar__1": "Blackbird",
      "IATA": "",
      "bar__2": "",
      "ICAO": "United States",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8089,
      "bar": "",
      "�װ����": "Blackbird Air Charter",
      "bar__1": "Blackbird Air Charter",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Denmark",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8090,
      "bar": "",
      "�װ����": "Blagoveshchensk Airlines",
      "bar__1": "Blagoveshchensk Airlines",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Russia",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8091,
      "bar": "",
      "�װ����": "BLUairways",
      "bar__1": "BLUairways",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Poland",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8092,
      "bar": "",
      "�װ����": "Blue Bird Air Line",
      "bar__1": "Blue Bird Air Line",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Spain",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8093,
      "bar": "",
      "�װ����": "Blue Dart Aviation",
      "bar__1": "Blue Dart Aviation",
      "IATA": "BZ",
      "bar__2": "BDA",
      "ICAO": "India",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8094,
      "bar": "",
      "�װ����": "Blue Islands",
      "bar__1": "Blue Islands",
      "IATA": "SI",
      "bar__2": "BCI",
      "ICAO": "United Kingdom",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8095,
      "bar": "",
      "�װ����": "Blue Sky Aviation",
      "bar__1": "Blue Sky Aviation",
      "IATA": "",
      "bar__2": "SBK",
      "ICAO": "Kenya",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8096,
      "bar": "",
      "�װ����": "Blue Slovakia",
      "bar__1": "Blue Slovakia",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Slovakia",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8097,
      "bar": "",
      "�װ����": "Blue Water Aviation",
      "bar__1": "Blue Water Aviation",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Canada",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8483,
      "bar": "",
      "�װ����": "Hubei Airlines",
      "bar__1": "Hubei Airlines",
      "IATA": "",
      "bar__2": "",
      "ICAO": "China",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 9368,
      "bar": "",
      "�װ����": "Humo Air",
      "bar__1": "Humo Air",
      "IATA": "",
      "bar__2": "USW",
      "ICAO": "Uzbekistan",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 9401,
      "bar": "",
      "�װ����": "Humo Air",
      "bar__1": "Humo Air",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Uzbekistan",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8484,
      "bar": "",
      "�װ����": "Hunnu Airlines",
      "bar__1": "Hunnu Airlines",
      "IATA": "MR",
      "bar__2": "MML",
      "ICAO": "Mongolia",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8485,
      "bar": "",
      "�װ����": "Huron Air & Outfitters Air",
      "bar__1": "Huron Air & Outfitters Air",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Canada",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 9115,
      "bar": "",
      "�װ����": "iAero Airways",
      "bar__1": "iAero Airways",
      "IATA": "WQ",
      "bar__2": "SWQ",
      "ICAO": "United States",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8486,
      "bar": "",
      "�װ����": "IBC Airways",
      "bar__1": "IBC Airways",
      "IATA": "II",
      "bar__2": "CSQ",
      "ICAO": "United States",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 7221,
      "bar": "",
      "�װ����": "Iberia Express",
      "bar__1": "Iberia Express",
      "IATA": "I2",
      "bar__2": "IBS",
      "ICAO": "Spain",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8487,
      "bar": "",
      "�װ����": "Iberia Regional Air Nostrum",
      "bar__1": "Iberia Regional Air Nostrum",
      "IATA": "YW",
      "bar__2": "ANE",
      "ICAO": "Spain",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8488,
      "bar": "",
      "�װ����": "IBIS Airlines",
      "bar__1": "IBIS Airlines",
      "IATA": "",
      "bar__2": "",
      "ICAO": "United States",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8489,
      "bar": "",
      "�װ����": "Ibom Air",
      "bar__1": "Ibom Air",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Nigeria",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8490,
      "bar": "",
      "�װ����": "ICAR - International Cargo Airline",
      "bar__1": "ICAR - International Cargo Airline",
      "IATA": "",
      "bar__2": "MEM",
      "ICAO": "France",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8491,
      "bar": "",
      "�װ����": "I-Fly",
      "bar__1": "I-Fly",
      "IATA": "F7",
      "bar__2": "RSY",
      "ICAO": "Russia",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8492,
      "bar": "",
      "�װ����": "iJet Charters",
      "bar__1": "iJet Charters",
      "IATA": "",
      "bar__2": "",
      "ICAO": "United States",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8493,
      "bar": "",
      "�װ����": "Iliamna Air Taxi",
      "bar__1": "Iliamna Air Taxi",
      "IATA": "V8",
      "bar__2": "IAR",
      "ICAO": "United States",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8494,
      "bar": "",
      "�װ����": "Ilin Aviakompania",
      "bar__1": "Ilin Aviakompania",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Russia",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8495,
      "bar": "",
      "�װ����": "Ilyich-Avia",
      "bar__1": "Ilyich-Avia",
      "IATA": "",
      "bar__2": "ILL",
      "ICAO": "Ukraine",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8496,
      "bar": "",
      "�װ����": "Imo Air",
      "bar__1": "Imo Air",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Nigeria",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8497,
      "bar": "",
      "�װ����": "Imperial Air Cargo",
      "bar__1": "Imperial Air Cargo",
      "IATA": "",
      "bar__2": "",
      "ICAO": "South Africa",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8498,
      "bar": "",
      "�װ����": "Inaer Helicopter France",
      "bar__1": "Inaer Helicopter France",
      "IATA": "",
      "bar__2": "PTH",
      "ICAO": "France",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8499,
      "bar": "",
      "�װ����": "Indonesia Air Transport",
      "bar__1": "Indonesia Air Transport",
      "IATA": "I8",
      "bar__2": "IDA",
      "ICAO": "Indonesia",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 7110,
      "bar": "",
      "�װ����": "Indonesia AirAsia X",
      "bar__1": "Indonesia AirAsia X",
      "IATA": "XT",
      "bar__2": "INX",
      "ICAO": "Indonesia",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8500,
      "bar": "",
      "�װ����": "Instantair",
      "bar__1": "Instantair",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Netherlands",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8501,
      "bar": "",
      "�װ����": "Insumos Alimenticios Prawn 7.C.A",
      "bar__1": "Insumos Alimenticios Prawn 7.C.A",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Venezuela",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8502,
      "bar": "",
      "�װ����": "Intal Air",
      "bar__1": "Intal Air",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Kyrgyzstan",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8503,
      "bar": "",
      "�װ����": "Intan Angkasa Air Services",
      "bar__1": "Intan Angkasa Air Services",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Indonesia",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8896,
      "bar": "",
      "�װ����": "Rivne Universal Avia",
      "bar__1": "Rivne Universal Avia",
      "IATA": "",
      "bar__2": "UNR",
      "ICAO": "Ukraine",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8897,
      "bar": "",
      "�װ����": "Rodina",
      "bar__1": "Rodina",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Russia",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8898,
      "bar": "",
      "�װ����": "Roraima Airways",
      "bar__1": "Roraima Airways",
      "IATA": "",
      "bar__2": "ROR",
      "ICAO": "Guyana",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8899,
      "bar": "",
      "�װ����": "Rossair Charter",
      "bar__1": "Rossair Charter",
      "IATA": "",
      "bar__2": "RFS",
      "ICAO": "Australia",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8900,
      "bar": "",
      "�װ����": "Rossiya - Russian Airlines",
      "bar__1": "Rossiya - Russian Airlines",
      "IATA": "FV",
      "bar__2": "SDM",
      "ICAO": "Russia",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8901,
      "bar": "",
      "�װ����": "Rostvertol-Avia",
      "bar__1": "Rostvertol-Avia",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Russia",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8902,
      "bar": "",
      "�װ����": "Royal Air Charter Service",
      "bar__1": "Royal Air Charter Service",
      "IATA": "RW",
      "bar__2": "RYL",
      "ICAO": "Philippines",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8903,
      "bar": "",
      "�װ����": "Royal Air Freight",
      "bar__1": "Royal Air Freight",
      "IATA": "",
      "bar__2": "RAX",
      "ICAO": "United States",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8904,
      "bar": "",
      "�װ����": "Royal Flight",
      "bar__1": "Royal Flight",
      "IATA": "RL",
      "bar__2": "ABG",
      "ICAO": "Russia",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 9384,
      "bar": "",
      "�װ����": "Royal Zambian Airlines",
      "bar__1": "Royal Zambian Airlines",
      "IATA": "3Q",
      "bar__2": "",
      "ICAO": "Zambia",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8906,
      "bar": "",
      "�װ����": "RubyStar Airways",
      "bar__1": "RubyStar Airways",
      "IATA": "",
      "bar__2": "RSB",
      "ICAO": "Belarus",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8907,
      "bar": "",
      "�װ����": "Ruili Airlines",
      "bar__1": "Ruili Airlines",
      "IATA": "DR",
      "bar__2": "RLH",
      "ICAO": "China",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8908,
      "bar": "",
      "�װ����": "Run Aviation",
      "bar__1": "Run Aviation",
      "IATA": "",
      "bar__2": "",
      "ICAO": "France",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8909,
      "bar": "",
      "�װ����": "Russ Air Transport Company",
      "bar__1": "Russ Air Transport Company",
      "IATA": "",
      "bar__2": "RUR",
      "ICAO": "Russia",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8910,
      "bar": "",
      "�װ����": "Rust's Flying Service",
      "bar__1": "Rust's Flying Service",
      "IATA": "",
      "bar__2": "",
      "ICAO": "United States",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8911,
      "bar": "",
      "�װ����": "Rutaca Airlines",
      "bar__1": "Rutaca Airlines",
      "IATA": "5R",
      "bar__2": "RUC",
      "ICAO": "Venezuela",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8912,
      "bar": "",
      "�װ����": "RVR Aircraft Charter",
      "bar__1": "RVR Aircraft Charter",
      "IATA": "",
      "bar__2": "",
      "ICAO": "United States",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8913,
      "bar": "",
      "�װ����": "Ryanair Sun",
      "bar__1": "Ryanair Sun",
      "IATA": "RR",
      "bar__2": "RYS",
      "ICAO": "Poland",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8914,
      "bar": "",
      "�װ����": "Ryanair UK",
      "bar__1": "Ryanair UK",
      "IATA": "RK",
      "bar__2": "RUK",
      "ICAO": "United Kingdom",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8915,
      "bar": "",
      "�װ����": "Ryukyu Air Commuter",
      "bar__1": "Ryukyu Air Commuter",
      "IATA": "",
      "bar__2": "RAC",
      "ICAO": "Japan",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8916,
      "bar": "",
      "�װ����": "SA Express",
      "bar__1": "SA Express",
      "IATA": "XZ",
      "bar__2": "EXY",
      "ICAO": "South Africa",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8009,
      "bar": "",
      "�װ����": "ASL Airlines France",
      "bar__1": "ASL Airlines France",
      "IATA": "5O",
      "bar__2": "FPO",
      "ICAO": "France",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8010,
      "bar": "",
      "�װ����": "ASL Airlines Ireland",
      "bar__1": "ASL Airlines Ireland",
      "IATA": "",
      "bar__2": "ABR",
      "ICAO": "Ireland",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8098,
      "bar": "",
      "�װ����": "Blue Wing Airlines",
      "bar__1": "Blue Wing Airlines",
      "IATA": "",
      "bar__2": "BWI",
      "ICAO": "Suriname",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8099,
      "bar": "",
      "�װ����": "Bluebird Aviation",
      "bar__1": "Bluebird Aviation",
      "IATA": "",
      "bar__2": "BBZ",
      "ICAO": "Kenya",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8100,
      "bar": "",
      "�װ����": "Bluebird NORDIC",
      "bar__1": "Bluebird NORDIC",
      "IATA": "BO",
      "bar__2": "BBD",
      "ICAO": "Iceland",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8101,
      "bar": "",
      "�װ����": "BlueSky Airlines",
      "bar__1": "BlueSky Airlines",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Democratic Republic of Congo",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8102,
      "bar": "",
      "�װ����": "BlueSky Airways",
      "bar__1": "BlueSky Airways",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Botswana",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8103,
      "bar": "",
      "�װ����": "blu-express",
      "bar__1": "blu-express",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Italy",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 7169,
      "bar": "",
      "�װ����": "BoA Regional",
      "bar__1": "BoA Regional",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Bolivia",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8104,
      "bar": "",
      "�װ����": "Bohlke International Airways",
      "bar__1": "Bohlke International Airways",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Virgin Islands, US",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8105,
      "bar": "",
      "�װ����": "Borcola",
      "bar__1": "Borcola",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Russia",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8106,
      "bar": "",
      "�װ����": "Braathens Regional Airlines",
      "bar__1": "Braathens Regional Airlines",
      "IATA": "DC",
      "bar__2": "BRX",
      "ICAO": "Sweden",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8107,
      "bar": "",
      "�װ����": "Braniff International Airlines",
      "bar__1": "Braniff International Airlines",
      "IATA": "",
      "bar__2": "",
      "ICAO": "United States",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 7729,
      "bar": "",
      "�װ����": "Branson Air Express",
      "bar__1": "Branson Air Express",
      "IATA": "1X",
      "bar__2": "",
      "ICAO": "United States",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8108,
      "bar": "",
      "�װ����": "Brava Linhas Aereas",
      "bar__1": "Brava Linhas Aereas",
      "IATA": "NT",
      "bar__2": "NHG",
      "ICAO": "Brazil",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8109,
      "bar": "",
      "�װ����": "Bravo Airways",
      "bar__1": "Bravo Airways",
      "IATA": "",
      "bar__2": "BAY",
      "ICAO": "Ukraine",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 9347,
      "bar": "",
      "�װ����": "Breeze Airways",
      "bar__1": "Breeze Airways",
      "IATA": "MX",
      "bar__2": "MXY",
      "ICAO": "United States",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8110,
      "bar": "",
      "�װ����": "British Gulf International Airlines",
      "bar__1": "British Gulf International Airlines",
      "IATA": "",
      "bar__2": "BGI",
      "ICAO": "Sao Tome and Principe",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8111,
      "bar": "",
      "�װ����": "British International Helicopters",
      "bar__1": "British International Helicopters",
      "IATA": "BS",
      "bar__2": "BIH",
      "ICAO": "United Kingdom",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8113,
      "bar": "",
      "�װ����": "Buddha Air",
      "bar__1": "Buddha Air",
      "IATA": "U4",
      "bar__2": "BHA",
      "ICAO": "Nepal",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8114,
      "bar": "",
      "�װ����": "Buffalo Airways",
      "bar__1": "Buffalo Airways",
      "IATA": "J4",
      "bar__2": "BFL",
      "ICAO": "Canada",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8115,
      "bar": "",
      "�װ����": "Bukovyna Airlines",
      "bar__1": "Bukovyna Airlines",
      "IATA": "BQ",
      "bar__2": "BKV",
      "ICAO": "Ukraine",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8504,
      "bar": "",
      "�װ����": "Integra Air",
      "bar__1": "Integra Air",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Canada",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8506,
      "bar": "",
      "�װ����": "Inter Island Airways",
      "bar__1": "Inter Island Airways",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Fiji",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8508,
      "bar": "",
      "�װ����": "Inter-Archipelago Airways",
      "bar__1": "Inter-Archipelago Airways",
      "IATA": "",
      "bar__2": "",
      "ICAO": "United States",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8509,
      "bar": "",
      "�װ����": "InterIsland Airlines",
      "bar__1": "InterIsland Airlines",
      "IATA": "I4",
      "bar__2": "ISN",
      "ICAO": "Philippines",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8510,
      "bar": "",
      "�װ����": "International AirLink",
      "bar__1": "International AirLink",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Jamaica",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8513,
      "bar": "",
      "�װ����": "Iran Air Tours",
      "bar__1": "Iran Air Tours",
      "IATA": "B9",
      "bar__2": "IRB",
      "ICAO": "Iran",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8514,
      "bar": "",
      "�װ����": "Iraq Gate",
      "bar__1": "Iraq Gate",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Iraq",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8515,
      "bar": "",
      "�װ����": "Iris Air",
      "bar__1": "Iris Air",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Ghana",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8516,
      "bar": "",
      "�װ����": "Irkut-Avia",
      "bar__1": "Irkut-Avia",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Russia",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 9369,
      "bar": "",
      "�װ����": "IrMa Air Service",
      "bar__1": "IrMa Air Service",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Kazakhstan",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8518,
      "bar": "",
      "�װ����": "Island Air Service",
      "bar__1": "Island Air Service",
      "IATA": "2O",
      "bar__2": "",
      "ICAO": "United States",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8519,
      "bar": "",
      "�װ����": "Island Express Air",
      "bar__1": "Island Express Air",
      "IATA": "",
      "bar__2": "IAX",
      "ICAO": "Canada",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8520,
      "bar": "",
      "�װ����": "Island Helicopters",
      "bar__1": "Island Helicopters",
      "IATA": "",
      "bar__2": "IH7",
      "ICAO": "United States",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8521,
      "bar": "",
      "�װ����": "Island Valley Airways",
      "bar__1": "Island Valley Airways",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Canada",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8522,
      "bar": "",
      "�װ����": "Islands Airline",
      "bar__1": "Islands Airline",
      "IATA": "",
      "bar__2": "",
      "ICAO": "New Caledonia",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8523,
      "bar": "",
      "�װ����": "Islands Nationair",
      "bar__1": "Islands Nationair",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Papua New Guinea",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8524,
      "bar": "",
      "�װ����": "Isle-Fly",
      "bar__1": "Isle-Fly",
      "IATA": "",
      "bar__2": "",
      "ICAO": "United Kingdom",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8525,
      "bar": "",
      "�װ����": "Isles Of Scilly Skybus",
      "bar__1": "Isles Of Scilly Skybus",
      "IATA": "",
      "bar__2": "IOS",
      "ICAO": "United Kingdom",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 9370,
      "bar": "",
      "�װ����": "ITA Transportes Aereos",
      "bar__1": "ITA Transportes Aereos",
      "IATA": "8I",
      "bar__2": "IPM",
      "ICAO": "Brazil",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8526,
      "bar": "",
      "�װ����": "ITAB - International Trans Air Business",
      "bar__1": "ITAB - International Trans Air Business",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Democratic Republic of Congo",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 9371,
      "bar": "",
      "�װ����": "Italia Trasporteo Aereo",
      "bar__1": "Italia Trasporteo Aereo",
      "IATA": "AZ",
      "bar__2": "AZA",
      "ICAO": "Italy",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8527,
      "bar": "",
      "�װ����": "Italian Airways",
      "bar__1": "Italian Airways",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Italy",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8528,
      "bar": "",
      "�װ����": "Ivoirienne de Transportes Aeriens",
      "bar__1": "Ivoirienne de Transportes Aeriens",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Cote d'Ivoire",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8530,
      "bar": "",
      "�װ����": "IWS Aviation",
      "bar__1": "IWS Aviation",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Sri Lanka",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8531,
      "bar": "",
      "�װ����": "Izhavia",
      "bar__1": "Izhavia",
      "IATA": "I8",
      "bar__2": "IZA",
      "ICAO": "Russia",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 9372,
      "bar": "",
      "�װ����": "Jags Aviation",
      "bar__1": "Jags Aviation",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Guyana",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8532,
      "bar": "",
      "�װ����": "J-Air",
      "bar__1": "J-Air",
      "IATA": "JL",
      "bar__2": "JLJ",
      "ICAO": "Japan",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 9373,
      "bar": "",
      "�װ����": "JAM AIR Express",
      "bar__1": "JAM AIR Express",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Guatemala",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 7182,
      "bar": "",
      "�װ����": "Jambojet",
      "bar__1": "Jambojet",
      "IATA": "JM",
      "bar__2": "JMA",
      "ICAO": "Kenya",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8534,
      "bar": "",
      "�װ����": "Japan Air Commuter",
      "bar__1": "Japan Air Commuter",
      "IATA": "3X",
      "bar__2": "JAC",
      "ICAO": "Japan",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8917,
      "bar": "",
      "�װ����": "Sabang Merauke Raya Air Charter",
      "bar__1": "Sabang Merauke Raya Air Charter",
      "IATA": "",
      "bar__2": "SMC",
      "ICAO": "Indonesia",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8918,
      "bar": "",
      "�װ����": "SADELCA",
      "bar__1": "SADELCA",
      "IATA": "",
      "bar__2": "SDK",
      "ICAO": "Colombia",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8919,
      "bar": "",
      "�װ����": "SADI Colombia",
      "bar__1": "SADI Colombia",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Colombia",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8920,
      "bar": "",
      "�װ����": "SAE Societe Avion Express",
      "bar__1": "SAE Societe Avion Express",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Mali",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8921,
      "bar": "",
      "�װ����": "SAEP",
      "bar__1": "SAEP",
      "IATA": "",
      "bar__2": "KSP",
      "ICAO": "Colombia",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8922,
      "bar": "",
      "�װ����": "SAEREO",
      "bar__1": "SAEREO",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Ecuador",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8923,
      "bar": "",
      "�װ����": "Safari Airlines",
      "bar__1": "Safari Airlines",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Brazil",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8924,
      "bar": "",
      "�װ����": "Safari AirLink",
      "bar__1": "Safari AirLink",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Tanzania",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8925,
      "bar": "",
      "�װ����": "Safari Express Cargo",
      "bar__1": "Safari Express Cargo",
      "IATA": "ZF",
      "bar__2": "SXY",
      "ICAO": "Kenya",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8926,
      "bar": "",
      "�װ����": "Safarilink Aviation",
      "bar__1": "Safarilink Aviation",
      "IATA": "F2",
      "bar__2": "XLK",
      "ICAO": "Kenya",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 9385,
      "bar": "",
      "�װ����": "Safe Air Company",
      "bar__1": "Safe Air Company",
      "IATA": "K3",
      "bar__2": "",
      "ICAO": "Kenya",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8927,
      "bar": "",
      "�װ����": "Saha Airlines",
      "bar__1": "Saha Airlines",
      "IATA": "",
      "bar__2": "IRZ",
      "ICAO": "Iran",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8928,
      "bar": "",
      "�װ����": "Saif Air",
      "bar__1": "Saif Air",
      "IATA": "",
      "bar__2": "",
      "ICAO": "United Kingdom",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8929,
      "bar": "",
      "�װ����": "Saint-Ex Cargo",
      "bar__1": "Saint-Ex Cargo",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Mexico",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8930,
      "bar": "",
      "�װ����": "S-Air",
      "bar__1": "S-Air",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Australia",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8931,
      "bar": "",
      "�װ����": "SAL",
      "bar__1": "SAL",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Angola",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8932,
      "bar": "",
      "�װ����": "Salalah Air",
      "bar__1": "Salalah Air",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Oman",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8933,
      "bar": "",
      "�װ����": "SalamAir",
      "bar__1": "SalamAir",
      "IATA": "OV",
      "bar__2": "OMS",
      "ICAO": "Oman",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8934,
      "bar": "",
      "�װ����": "Salmon Air",
      "bar__1": "Salmon Air",
      "IATA": "S6",
      "bar__2": "MBI",
      "ICAO": "United States",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8936,
      "bar": "",
      "�װ����": "Salt Air",
      "bar__1": "Salt Air",
      "IATA": "",
      "bar__2": "",
      "ICAO": "New Zealand",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8937,
      "bar": "",
      "�װ����": "Samaritans Purse",
      "bar__1": "Samaritans Purse",
      "IATA": "",
      "bar__2": "",
      "ICAO": "United States",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8939,
      "bar": "",
      "�װ����": "San Juan Airlines",
      "bar__1": "San Juan Airlines",
      "IATA": "",
      "bar__2": "MRR",
      "ICAO": "United States",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8940,
      "bar": "",
      "�װ����": "SANSA",
      "bar__1": "SANSA",
      "IATA": "RZ",
      "bar__2": "LRS",
      "ICAO": "Costa Rica",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8941,
      "bar": "",
      "�װ����": "SAP",
      "bar__1": "SAP",
      "IATA": "5S",
      "bar__2": "PSV",
      "ICAO": "Dominican Republic",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8942,
      "bar": "",
      "�װ����": "Sapsan",
      "bar__1": "Sapsan",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Kazakhstan",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8944,
      "bar": "",
      "�װ����": "SARPA",
      "bar__1": "SARPA",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Colombia",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8945,
      "bar": "",
      "�װ����": "SAS",
      "bar__1": "SAS",
      "IATA": "SK",
      "bar__2": "SAS",
      "ICAO": "Sweden",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8946,
      "bar": "",
      "�װ����": "SAS Ireland",
      "bar__1": "SAS Ireland",
      "IATA": "SL",
      "bar__2": "SZS",
      "ICAO": "Ireland",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8947,
      "bar": "",
      "�װ����": "SASCA",
      "bar__1": "SASCA",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Venezuela",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8948,
      "bar": "",
      "�װ����": "SATA - Air Acores",
      "bar__1": "SATA - Air Acores",
      "IATA": "SP",
      "bar__2": "SAT",
      "ICAO": "Portugal",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8949,
      "bar": "",
      "�װ����": "SATA International",
      "bar__1": "SATA International",
      "IATA": "S4",
      "bar__2": "RZO",
      "ICAO": "Portugal",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8950,
      "bar": "",
      "�װ����": "Saturn Aviakompania",
      "bar__1": "Saturn Aviakompania",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Russia",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8951,
      "bar": "",
      "�װ����": "Saudia Cargo",
      "bar__1": "Saudia Cargo",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Saudi Arabia",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8952,
      "bar": "",
      "�װ����": "Saudia Private Aviation",
      "bar__1": "Saudia Private Aviation",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Saudi Arabia",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 7177,
      "bar": "",
      "�װ����": "SaudiGulf Airlines",
      "bar__1": "SaudiGulf Airlines",
      "IATA": "6S",
      "bar__2": "SGQ",
      "ICAO": "Saudi Arabia",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8953,
      "bar": "",
      "�װ����": "SAX-Tanzania",
      "bar__1": "SAX-Tanzania",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Tanzania",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8954,
      "bar": "",
      "�װ����": "Scan Air Charter",
      "bar__1": "Scan Air Charter",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Swaziland",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8012,
      "bar": "",
      "�װ����": "Athens Spirit Airlines",
      "bar__1": "Athens Spirit Airlines",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Greece",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8013,
      "bar": "",
      "�װ����": "Atlantic Star Airlines",
      "bar__1": "Atlantic Star Airlines",
      "IATA": "",
      "bar__2": "",
      "ICAO": "United Kingdom",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8116,
      "bar": "",
      "�װ����": "Bul Air",
      "bar__1": "Bul Air",
      "IATA": "LB",
      "bar__2": "BVL",
      "ICAO": "Bulgaria",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8118,
      "bar": "",
      "�װ����": "Business Aviation of Congo",
      "bar__1": "Business Aviation of Congo",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Democratic Republic of Congo",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8119,
      "bar": "",
      "�װ����": "Busy Bee Congo",
      "bar__1": "Busy Bee Congo",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Democratic Republic of Congo",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8120,
      "bar": "",
      "�װ����": "Buta Airways",
      "bar__1": "Buta Airways",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Azerbaijan",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8123,
      "bar": "",
      "�װ����": "C S Turisticos CA",
      "bar__1": "C S Turisticos CA",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Venezuela",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8124,
      "bar": "",
      "�װ����": "Cabo Verde Airlines",
      "bar__1": "Cabo Verde Airlines",
      "IATA": "VR",
      "bar__2": "TCV",
      "ICAO": "Cape Verde",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8125,
      "bar": "",
      "�װ����": "Cabo Verde Express",
      "bar__1": "Cabo Verde Express",
      "IATA": "",
      "bar__2": "CVE",
      "ICAO": "Cape Verde",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8126,
      "bar": "",
      "�װ����": "Caicos Express Airways",
      "bar__1": "Caicos Express Airways",
      "IATA": "9Q",
      "bar__2": "CXE",
      "ICAO": "Turks and Caicos Islands",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8127,
      "bar": "",
      "�װ����": "Cairo Aviation",
      "bar__1": "Cairo Aviation",
      "IATA": "",
      "bar__2": "CCE",
      "ICAO": "Egypt",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 7743,
      "bar": "",
      "�װ����": "Calafia Airlines",
      "bar__1": "Calafia Airlines",
      "IATA": "A7",
      "bar__2": "CFV",
      "ICAO": "Mexico",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8128,
      "bar": "",
      "�װ����": "Cally Air",
      "bar__1": "Cally Air",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Nigeria",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8129,
      "bar": "",
      "�װ����": "Cambodia Airways",
      "bar__1": "Cambodia Airways",
      "IATA": "KR",
      "bar__2": "KME",
      "ICAO": "Cambodia",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8130,
      "bar": "",
      "�װ����": "Cambodia Angkor Air",
      "bar__1": "Cambodia Angkor Air",
      "IATA": "K6",
      "bar__2": "KHV",
      "ICAO": "Cambodia",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8131,
      "bar": "",
      "�װ����": "Canadian Airways Congo",
      "bar__1": "Canadian Airways Congo",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Republic of the Congo",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8132,
      "bar": "",
      "�װ����": "Canadian North",
      "bar__1": "Canadian North",
      "IATA": "5T",
      "bar__2": "MPE",
      "ICAO": "Canada",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8133,
      "bar": "",
      "�װ����": "Canarias Airlines",
      "bar__1": "Canarias Airlines",
      "IATA": "",
      "bar__2": "RSC",
      "ICAO": "Spain",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8535,
      "bar": "",
      "�װ����": "Jasmin Airways",
      "bar__1": "Jasmin Airways",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Tunisia",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8536,
      "bar": "",
      "�װ����": "JC International Airlines",
      "bar__1": "JC International Airlines",
      "IATA": "QD",
      "bar__2": "JCC",
      "ICAO": "Cambodia",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8537,
      "bar": "",
      "�װ����": "JedAir",
      "bar__1": "JedAir",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Nigeria",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8538,
      "bar": "",
      "�װ����": "Jet 2000",
      "bar__1": "Jet 2000",
      "IATA": "",
      "bar__2": "JTT",
      "ICAO": "Russia",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8539,
      "bar": "",
      "�װ����": "Jet 4 Now",
      "bar__1": "Jet 4 Now",
      "IATA": "",
      "bar__2": "",
      "ICAO": "South Africa",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8540,
      "bar": "",
      "�װ����": "Jet Air Group",
      "bar__1": "Jet Air Group",
      "IATA": "",
      "bar__2": "JSI",
      "ICAO": "Russia",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8541,
      "bar": "",
      "�װ����": "Jet Asia International",
      "bar__1": "Jet Asia International",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Pakistan",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8542,
      "bar": "",
      "�װ����": "Jet Express",
      "bar__1": "Jet Express",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Colombia",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8543,
      "bar": "",
      "�װ����": "Jet Systems France",
      "bar__1": "Jet Systems France",
      "IATA": "",
      "bar__2": "",
      "ICAO": "France",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8544,
      "bar": "",
      "�װ����": "Jet Time Finland",
      "bar__1": "Jet Time Finland",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Finland",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 9374,
      "bar": "",
      "�װ����": "JetAir Caribbean",
      "bar__1": "JetAir Caribbean",
      "IATA": "4J",
      "bar__2": "JRC",
      "ICAO": "Curacao",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8545,
      "bar": "",
      "�װ����": "Jetconnect",
      "bar__1": "Jetconnect",
      "IATA": "QF",
      "bar__2": "QFA",
      "ICAO": "New Zealand",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8546,
      "bar": "",
      "�װ����": "JetFly",
      "bar__1": "JetFly",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Cameroon",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8547,
      "bar": "",
      "�װ����": "JetGo America",
      "bar__1": "JetGo America",
      "IATA": "",
      "bar__2": "",
      "ICAO": "United States",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8548,
      "bar": "",
      "�װ����": "Jetlines",
      "bar__1": "Jetlines",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Canada",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8549,
      "bar": "",
      "�װ����": "JetPurple Airwayz",
      "bar__1": "JetPurple Airwayz",
      "IATA": "",
      "bar__2": "",
      "ICAO": "United States",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8551,
      "bar": "",
      "�װ����": "JetSMART",
      "bar__1": "JetSMART",
      "IATA": "JA",
      "bar__2": "JAT",
      "ICAO": "Chile",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8550,
      "bar": "",
      "�װ����": "JetSMART",
      "bar__1": "JetSMART",
      "IATA": "WJ",
      "bar__2": "JES",
      "ICAO": "Argentina",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8552,
      "bar": "",
      "�װ����": "JetSmart",
      "bar__1": "JetSmart",
      "IATA": "",
      "bar__2": "",
      "ICAO": "India",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8553,
      "bar": "",
      "�װ����": "JetSuite",
      "bar__1": "JetSuite",
      "IATA": "",
      "bar__2": "",
      "ICAO": "United States",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8554,
      "bar": "",
      "�װ����": "JetSuiteX",
      "bar__1": "JetSuiteX",
      "IATA": "XE",
      "bar__2": "JSX",
      "ICAO": "United States",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8555,
      "bar": "",
      "�װ����": "Jetways Airlines",
      "bar__1": "Jetways Airlines",
      "IATA": "WU",
      "bar__2": "JWX",
      "ICAO": "Kenya",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8556,
      "bar": "",
      "�װ����": "jetWest Airways",
      "bar__1": "jetWest Airways",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Nigeria",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8955,
      "bar": "",
      "�װ����": "SDS Aero",
      "bar__1": "SDS Aero",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Russia",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8956,
      "bar": "",
      "�װ����": "Sea Air",
      "bar__1": "Sea Air",
      "IATA": "",
      "bar__2": "SIB",
      "ICAO": "Croatia",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8958,
      "bar": "",
      "�װ����": "Seair Pacific Gold Coast",
      "bar__1": "Seair Pacific Gold Coast",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Australia",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8959,
      "bar": "",
      "�װ����": "Seair Seaplanes",
      "bar__1": "Seair Seaplanes",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Canada",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8960,
      "bar": "",
      "�װ����": "SEARCA Colombia",
      "bar__1": "SEARCA Colombia",
      "IATA": "",
      "bar__2": "SRC",
      "ICAO": "Colombia",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8961,
      "bar": "",
      "�װ����": "Seawings",
      "bar__1": "Seawings",
      "IATA": "",
      "bar__2": "",
      "ICAO": "United Arab Emirates",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8962,
      "bar": "",
      "�װ����": "Second Arkhangelsk Aviation Division",
      "bar__1": "Second Arkhangelsk Aviation Division",
      "IATA": "",
      "bar__2": "OAO",
      "ICAO": "Russia",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8963,
      "bar": "",
      "�װ����": "SELVA Colombia",
      "bar__1": "SELVA Colombia",
      "IATA": "",
      "bar__2": "SDV",
      "ICAO": "Colombia",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8964,
      "bar": "",
      "�װ����": "Sepehran Airlines",
      "bar__1": "Sepehran Airlines",
      "IATA": "IS",
      "bar__2": "SHI",
      "ICAO": "Iran",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8965,
      "bar": "",
      "�װ����": "Serair Transworld Press",
      "bar__1": "Serair Transworld Press",
      "IATA": "",
      "bar__2": "SEV",
      "ICAO": "Spain",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8966,
      "bar": "",
      "�װ����": "Serami",
      "bar__1": "Serami",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Venezuela",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8967,
      "bar": "",
      "�װ����": "SereneAir",
      "bar__1": "SereneAir",
      "IATA": "ER",
      "bar__2": "SEP",
      "ICAO": "Pakistan",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8968,
      "bar": "",
      "�װ����": "Servant Air",
      "bar__1": "Servant Air",
      "IATA": "8D",
      "bar__2": "",
      "ICAO": "United States",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 9387,
      "bar": "",
      "�װ����": "Serve Air Cargo",
      "bar__1": "Serve Air Cargo",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Democratic Republic of Congo",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8969,
      "bar": "",
      "�װ����": "Services Air",
      "bar__1": "Services Air",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Democratic Republic of Congo",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8970,
      "bar": "",
      "�װ����": "Servicios Aereos de Los Andes",
      "bar__1": "Servicios Aereos de Los Andes",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Peru",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8971,
      "bar": "",
      "�װ����": "Servicios Aereos Regionales",
      "bar__1": "Servicios Aereos Regionales",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Argentina",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8972,
      "bar": "",
      "�װ����": "Servicios Asociados Nacionales de Transportes Aereos",
      "bar__1": "Servicios Asociados Nacionales de Transportes Aereos",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Colombia",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8973,
      "bar": "",
      "�װ����": "Servicios Executivos Aereos de Angola",
      "bar__1": "Servicios Executivos Aereos de Angola",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Angola",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8974,
      "bar": "",
      "�װ����": "Servicios y Transportes Aereos Petrolero",
      "bar__1": "Servicios y Transportes Aereos Petrolero",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Bolivia",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8975,
      "bar": "",
      "�װ����": "Sevenair Air Services",
      "bar__1": "Sevenair Air Services",
      "IATA": "WV",
      "bar__2": "RVP",
      "ICAO": "Portugal",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8976,
      "bar": "",
      "�װ����": "Severin Air Safaris",
      "bar__1": "Severin Air Safaris",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Kenya",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8977,
      "bar": "",
      "�װ����": "Severstal Aircompany",
      "bar__1": "Severstal Aircompany",
      "IATA": "D2",
      "bar__2": "SSF",
      "ICAO": "Russia",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8979,
      "bar": "",
      "�װ����": "Shenniao Airlines",
      "bar__1": "Shenniao Airlines",
      "IATA": "",
      "bar__2": "",
      "ICAO": "China",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8980,
      "bar": "",
      "�װ����": "Shoreline Aviation",
      "bar__1": "Shoreline Aviation",
      "IATA": "",
      "bar__2": "SDB",
      "ICAO": "United States",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8981,
      "bar": "",
      "�װ����": "Shree Airlines",
      "bar__1": "Shree Airlines",
      "IATA": "N9",
      "bar__2": "SHA",
      "ICAO": "Nepal",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 9389,
      "bar": "",
      "�װ����": "Sibirskaya Legkaya Aviatsiya (SiLA)",
      "bar__1": "Sibirskaya Legkaya Aviatsiya (SiLA)",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Russia",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8982,
      "bar": "",
      "�װ����": "Sibiya",
      "bar__1": "Sibiya",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Russia",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8015,
      "bar": "",
      "�װ����": "AtlasJet",
      "bar__1": "AtlasJet",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Russia",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8016,
      "bar": "",
      "�װ����": "ATP",
      "bar__1": "ATP",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Brazil",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8017,
      "bar": "",
      "�װ����": "Atrak Airlines",
      "bar__1": "Atrak Airlines",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Iran",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8018,
      "bar": "",
      "�װ����": "ATRAN",
      "bar__1": "ATRAN",
      "IATA": "V8",
      "bar__2": "VAS",
      "ICAO": "Russia",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8134,
      "bar": "",
      "�װ����": "Caneflight Enterprises",
      "bar__1": "Caneflight Enterprises",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Australia",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8136,
      "bar": "",
      "�װ����": "Capital Airways",
      "bar__1": "Capital Airways",
      "IATA": "",
      "bar__2": "",
      "ICAO": "United States",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8137,
      "bar": "",
      "�װ����": "Caravan Charters",
      "bar__1": "Caravan Charters",
      "IATA": "",
      "bar__2": "",
      "ICAO": "United States",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8138,
      "bar": "",
      "�װ����": "Cardinal Prestige Helicopter Charter",
      "bar__1": "Cardinal Prestige Helicopter Charter",
      "IATA": "",
      "bar__2": "",
      "ICAO": "United Kingdom",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8139,
      "bar": "",
      "�װ����": "Cargo Airways International",
      "bar__1": "Cargo Airways International",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Cameroon",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8140,
      "bar": "",
      "�װ����": "Cargojet Airways",
      "bar__1": "Cargojet Airways",
      "IATA": "W8",
      "bar__2": "CJT",
      "ICAO": "Canada",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8141,
      "bar": "",
      "�װ����": "CargoLogic Germany",
      "bar__1": "CargoLogic Germany",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Germany",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8142,
      "bar": "",
      "�װ����": "CargoLogicAir",
      "bar__1": "CargoLogicAir",
      "IATA": "P3",
      "bar__2": "CLU",
      "ICAO": "United Kingdom",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8143,
      "bar": "",
      "�װ����": "Cargolux Airlines",
      "bar__1": "Cargolux Airlines",
      "IATA": "CV",
      "bar__2": "CLX",
      "ICAO": "Luxembourg",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8557,
      "bar": "",
      "�װ����": "JetXtra.com",
      "bar__1": "JetXtra.com",
      "IATA": "",
      "bar__2": "",
      "ICAO": "United Kingdom",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8558,
      "bar": "",
      "�װ����": "Jiangsu Airlines",
      "bar__1": "Jiangsu Airlines",
      "IATA": "",
      "bar__2": "",
      "ICAO": "China",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 7101,
      "bar": "",
      "�װ����": "Jiangxi Air",
      "bar__1": "Jiangxi Air",
      "IATA": "RY",
      "bar__2": "CJX",
      "ICAO": "China",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8559,
      "bar": "",
      "�װ����": "Jilin Airlines",
      "bar__1": "Jilin Airlines",
      "IATA": "",
      "bar__2": "",
      "ICAO": "China",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8560,
      "bar": "",
      "�װ����": "Jonair",
      "bar__1": "Jonair",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Sweden",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8561,
      "bar": "",
      "�װ����": "Jonika Airlines",
      "bar__1": "Jonika Airlines",
      "IATA": "",
      "bar__2": "JNK",
      "ICAO": "Ukraine",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8563,
      "bar": "",
      "�װ����": "Jordan Aviation",
      "bar__1": "Jordan Aviation",
      "IATA": "R5",
      "bar__2": "JAV",
      "ICAO": "Jordan",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8564,
      "bar": "",
      "�װ����": "Jordan International Air Cargo",
      "bar__1": "Jordan International Air Cargo",
      "IATA": "J4",
      "bar__2": "JCI",
      "ICAO": "Jordan",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 7152,
      "bar": "",
      "�װ����": "Jota Aviation",
      "bar__1": "Jota Aviation",
      "IATA": "",
      "bar__2": "ENZ",
      "ICAO": "United Kingdom",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8565,
      "bar": "",
      "�װ����": "Joy Luzhou Airlines",
      "bar__1": "Joy Luzhou Airlines",
      "IATA": "",
      "bar__2": "",
      "ICAO": "China",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8566,
      "bar": "",
      "�װ����": "Jubba Airways",
      "bar__1": "Jubba Airways",
      "IATA": "3J",
      "bar__2": "JUB",
      "ICAO": "Kenya",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8567,
      "bar": "",
      "�װ����": "Junkanoo Air",
      "bar__1": "Junkanoo Air",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Bahamas",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 7903,
      "bar": "",
      "�װ����": "Jupiter Jet",
      "bar__1": "Jupiter Jet",
      "IATA": "IM",
      "bar__2": "JPJ",
      "ICAO": "Kazakhstan",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8568,
      "bar": "",
      "�װ����": "Just Fly",
      "bar__1": "Just Fly",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Spain",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8569,
      "bar": "",
      "�װ����": "Just Us Air",
      "bar__1": "Just Us Air",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Romania",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8570,
      "bar": "",
      "�װ����": "Jutland Jets",
      "bar__1": "Jutland Jets",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Denmark",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8571,
      "bar": "",
      "�װ����": "K2 Airways",
      "bar__1": "K2 Airways",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Pakistan",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8573,
      "bar": "",
      "�װ����": "Kairali Airlines",
      "bar__1": "Kairali Airlines",
      "IATA": "",
      "bar__2": "",
      "ICAO": "India",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8574,
      "bar": "",
      "�װ����": "Kalahari Air Services & Charter",
      "bar__1": "Kalahari Air Services & Charter",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Botswana",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8575,
      "bar": "",
      "�װ����": "Kalahari Airways",
      "bar__1": "Kalahari Airways",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Botswana",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8576,
      "bar": "",
      "�װ����": "Kalitta Air",
      "bar__1": "Kalitta Air",
      "IATA": "K4",
      "bar__2": "CKS",
      "ICAO": "United States",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8577,
      "bar": "",
      "�װ����": "Kalitta Charters",
      "bar__1": "Kalitta Charters",
      "IATA": "K9",
      "bar__2": "KFS",
      "ICAO": "United States",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8578,
      "bar": "",
      "�װ����": "Kallat Elsaker Air",
      "bar__1": "Kallat Elsaker Air",
      "IATA": "",
      "bar__2": "KES",
      "ICAO": "Libya",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8579,
      "bar": "",
      "�װ����": "Kamaka Air",
      "bar__1": "Kamaka Air",
      "IATA": "",
      "bar__2": "",
      "ICAO": "United States",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8580,
      "bar": "",
      "�װ����": "KAPO Avia",
      "bar__1": "KAPO Avia",
      "IATA": "",
      "bar__2": "KAO",
      "ICAO": "Russia",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8581,
      "bar": "",
      "�װ����": "Karinou Airlines",
      "bar__1": "Karinou Airlines",
      "IATA": "U5",
      "bar__2": "KRN",
      "ICAO": "Central African Republic",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8582,
      "bar": "",
      "�װ����": "Karpaty-Avia",
      "bar__1": "Karpaty-Avia",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Ukraine",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8583,
      "bar": "",
      "�װ����": "Karun Airlines",
      "bar__1": "Karun Airlines",
      "IATA": "NV",
      "bar__2": "KRU",
      "ICAO": "Iran",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8584,
      "bar": "",
      "�װ����": "KASAS",
      "bar__1": "KASAS",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Kenya",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8585,
      "bar": "",
      "�װ����": "Kata Transportation Company",
      "bar__1": "Kata Transportation Company",
      "IATA": "",
      "bar__2": "KTV",
      "ICAO": "Sudan",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8586,
      "bar": "",
      "�װ����": "Kavango Air",
      "bar__1": "Kavango Air",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Botswana",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8983,
      "bar": "",
      "�װ����": "Sideral Air Cargo",
      "bar__1": "Sideral Air Cargo",
      "IATA": "",
      "bar__2": "SID",
      "ICAO": "Brazil",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8984,
      "bar": "",
      "�װ����": "Sierra Pacific Airlines",
      "bar__1": "Sierra Pacific Airlines",
      "IATA": "SI",
      "bar__2": "SPA",
      "ICAO": "United States",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8985,
      "bar": "",
      "�װ����": "Sierra West Airlines",
      "bar__1": "Sierra West Airlines",
      "IATA": "",
      "bar__2": "PKW",
      "ICAO": "United States",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8986,
      "bar": "",
      "�װ����": "Silk Way Airlines",
      "bar__1": "Silk Way Airlines",
      "IATA": "ZP",
      "bar__2": "AZQ",
      "ICAO": "Azerbaijan",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 7226,
      "bar": "",
      "�װ����": "Silk Way West Airlines",
      "bar__1": "Silk Way West Airlines",
      "IATA": "7L",
      "bar__2": "AZG",
      "ICAO": "Azerbaijan",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8987,
      "bar": "",
      "�װ����": "Silver Airways",
      "bar__1": "Silver Airways",
      "IATA": "3M",
      "bar__2": "SIL",
      "ICAO": "United States",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8989,
      "bar": "",
      "�װ����": "Simargl",
      "bar__1": "Simargl",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Russia",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8990,
      "bar": "",
      "�װ����": "Simplifly",
      "bar__1": "Simplifly",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Sri Lanka",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8991,
      "bar": "",
      "�װ����": "Simrik Air",
      "bar__1": "Simrik Air",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Nepal",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8992,
      "bar": "",
      "�װ����": "Simrik Airlines",
      "bar__1": "Simrik Airlines",
      "IATA": "",
      "bar__2": "RMK",
      "ICAO": "Nepal",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8993,
      "bar": "",
      "�װ����": "Simrik International Cargo Airlines",
      "bar__1": "Simrik International Cargo Airlines",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Nepal",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8994,
      "bar": "",
      "�װ����": "Sindal Air Taxi",
      "bar__1": "Sindal Air Taxi",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Denmark",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8995,
      "bar": "",
      "�װ����": "Singapore Airlines",
      "bar__1": "Singapore Airlines",
      "IATA": "SQ",
      "bar__2": "SIA",
      "ICAO": "Singapore",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8996,
      "bar": "",
      "�װ����": "Sirius-Aero",
      "bar__1": "Sirius-Aero",
      "IATA": "",
      "bar__2": "CIG",
      "ICAO": "Russia",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8997,
      "bar": "",
      "�װ����": "Sita Air",
      "bar__1": "Sita Air",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Nepal",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8998,
      "bar": "",
      "�װ����": "SKA Air & Logistics",
      "bar__1": "SKA Air & Logistics",
      "IATA": "KH",
      "bar__2": "",
      "ICAO": "United Arab Emirates",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8999,
      "bar": "",
      "�װ����": "Skies Airlines",
      "bar__1": "Skies Airlines",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Sweden",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 9000,
      "bar": "",
      "�װ����": "SKOL Airlines",
      "bar__1": "SKOL Airlines",
      "IATA": "",
      "bar__2": "CDV",
      "ICAO": "Russia",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 9001,
      "bar": "",
      "�װ����": "Sky Airline",
      "bar__1": "Sky Airline",
      "IATA": "H2",
      "bar__2": "SKU",
      "ICAO": "Chile",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 9002,
      "bar": "",
      "�װ����": "Sky Airways",
      "bar__1": "Sky Airways",
      "IATA": "",
      "bar__2": "",
      "ICAO": "India",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 9390,
      "bar": "",
      "�װ����": "Sky Cana",
      "bar__1": "Sky Cana",
      "IATA": "RD",
      "bar__2": "SNA",
      "ICAO": "Dominican Republic",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 9004,
      "bar": "",
      "�װ����": "Sky Gates Airlines",
      "bar__1": "Sky Gates Airlines",
      "IATA": "U3",
      "bar__2": "SAY",
      "ICAO": "Russia",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 9006,
      "bar": "",
      "�װ����": "Sky High Aviation Service",
      "bar__1": "Sky High Aviation Service",
      "IATA": "DO",
      "bar__2": "SHH",
      "ICAO": "Dominican Republic",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 9007,
      "bar": "",
      "�װ����": "Sky Horse Aviation",
      "bar__1": "Sky Horse Aviation",
      "IATA": "",
      "bar__2": "TNL",
      "ICAO": "Mongolia",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 9008,
      "bar": "",
      "�װ����": "Sky Line Ulasim Ticaret",
      "bar__1": "Sky Line Ulasim Ticaret",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Turkey",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 9009,
      "bar": "",
      "�װ����": "SKY Linhas Aereas",
      "bar__1": "SKY Linhas Aereas",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Brazil",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 9391,
      "bar": "",
      "�װ����": "Sky Mali",
      "bar__1": "Sky Mali",
      "IATA": "",
      "bar__2": "FML",
      "ICAO": "Mali",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 9010,
      "bar": "",
      "�װ����": "Sky Pasada",
      "bar__1": "Sky Pasada",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Philippines",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 9011,
      "bar": "",
      "�װ����": "Sky Pearl Aviation",
      "bar__1": "Sky Pearl Aviation",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Jordan",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 9012,
      "bar": "",
      "�װ����": "SKY Peru",
      "bar__1": "SKY Peru",
      "IATA": "H8",
      "bar__2": "SKX",
      "ICAO": "Peru",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 9013,
      "bar": "",
      "�װ����": "Sky Prime",
      "bar__1": "Sky Prime",
      "IATA": "UY",
      "bar__2": "SPD",
      "ICAO": "Saudi Arabia",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 9014,
      "bar": "",
      "�װ����": "Sky Relief",
      "bar__1": "Sky Relief",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Zimbabwe",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 9015,
      "bar": "",
      "�װ����": "Sky Way Air",
      "bar__1": "Sky Way Air",
      "IATA": "",
      "bar__2": "SAB",
      "ICAO": "Kyrgyzstan",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 9016,
      "bar": "",
      "�װ����": "Sky Wind",
      "bar__1": "Sky Wind",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Azerbaijan",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 9017,
      "bar": "",
      "�װ����": "SkyAir",
      "bar__1": "SkyAir",
      "IATA": "S8",
      "bar__2": "",
      "ICAO": "Bangladesh",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8019,
      "bar": "",
      "�װ����": "Aurora Air International",
      "bar__1": "Aurora Air International",
      "IATA": "",
      "bar__2": "",
      "ICAO": "United States",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8020,
      "bar": "",
      "�װ����": "Aurora Airlines",
      "bar__1": "Aurora Airlines",
      "IATA": "HZ",
      "bar__2": "SHU",
      "ICAO": "Russia",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8021,
      "bar": "",
      "�װ����": "Austral Lineas Aereas",
      "bar__1": "Austral Lineas Aereas",
      "IATA": "AU",
      "bar__2": "AUT",
      "ICAO": "Argentina",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8022,
      "bar": "",
      "�װ����": "AV Cargo",
      "bar__1": "AV Cargo",
      "IATA": "",
      "bar__2": "",
      "ICAO": "United Kingdom",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8023,
      "bar": "",
      "�װ����": "AVA Airways",
      "bar__1": "AVA Airways",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Dominican Republic",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8024,
      "bar": "",
      "�װ����": "Avanti Air",
      "bar__1": "Avanti Air",
      "IATA": "",
      "bar__2": "ATV",
      "ICAO": "Germany",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8025,
      "bar": "",
      "�װ����": "Avatar Airlines",
      "bar__1": "Avatar Airlines",
      "IATA": "",
      "bar__2": "",
      "ICAO": "United States",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 9343,
      "bar": "",
      "�װ����": "Avelo Airlines",
      "bar__1": "Avelo Airlines",
      "IATA": "XP",
      "bar__2": "VXP",
      "ICAO": "United States",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8144,
      "bar": "",
      "�װ����": "Carib South Airways",
      "bar__1": "Carib South Airways",
      "IATA": "",
      "bar__2": "",
      "ICAO": "United States",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8146,
      "bar": "",
      "�װ����": "Carinair Airlines",
      "bar__1": "Carinair Airlines",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Malta",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8147,
      "bar": "",
      "�װ����": "Carpatair",
      "bar__1": "Carpatair",
      "IATA": "V3",
      "bar__2": "KRP",
      "ICAO": "Romania",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8148,
      "bar": "",
      "�װ����": "Castle Aviation",
      "bar__1": "Castle Aviation",
      "IATA": "",
      "bar__2": "CSJ",
      "ICAO": "United States",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8150,
      "bar": "",
      "�װ����": "Cavok Air",
      "bar__1": "Cavok Air",
      "IATA": "",
      "bar__2": "CVK",
      "ICAO": "Ukraine",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8151,
      "bar": "",
      "�װ����": "Cebgo",
      "bar__1": "Cebgo",
      "IATA": "DG",
      "bar__2": "SRQ",
      "ICAO": "Philippines",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8152,
      "bar": "",
      "�װ����": "Celebes Air",
      "bar__1": "Celebes Air",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Indonesia",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8153,
      "bar": "",
      "�װ����": "Center South Airlines",
      "bar__1": "Center South Airlines",
      "IATA": "",
      "bar__2": "CTS",
      "ICAO": "Russia",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8154,
      "bar": "",
      "�װ����": "Central Air Southwest",
      "bar__1": "Central Air Southwest",
      "IATA": "",
      "bar__2": "CTL",
      "ICAO": "United States",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8587,
      "bar": "",
      "�װ����": "Kazan Air Enterprise",
      "bar__1": "Kazan Air Enterprise",
      "IATA": "",
      "bar__2": "KKA",
      "ICAO": "Russia",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 9375,
      "bar": "",
      "�װ����": "Kazan Avia",
      "bar__1": "Kazan Avia",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Russia",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8589,
      "bar": "",
      "�װ����": "Kenai River Xpress",
      "bar__1": "Kenai River Xpress",
      "IATA": "",
      "bar__2": "",
      "ICAO": "United States",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8590,
      "bar": "",
      "�װ����": "Kenn Borek Air",
      "bar__1": "Kenn Borek Air",
      "IATA": "4K",
      "bar__2": "KBA",
      "ICAO": "Canada",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8591,
      "bar": "",
      "�װ����": "Key Lime Air",
      "bar__1": "Key Lime Air",
      "IATA": "KG",
      "bar__2": "LYM",
      "ICAO": "United States",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8592,
      "bar": "",
      "�װ����": "Khabarovsk Airlines",
      "bar__1": "Khabarovsk Airlines",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Russia",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8593,
      "bar": "",
      "�װ����": "Khonkaen Airlines",
      "bar__1": "Khonkaen Airlines",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Thailand",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8594,
      "bar": "",
      "�װ����": "Khors Air",
      "bar__1": "Khors Air",
      "IATA": "",
      "bar__2": "KHO",
      "ICAO": "Ukraine",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8595,
      "bar": "",
      "�װ����": "Khozu Avia",
      "bar__1": "Khozu Avia",
      "IATA": "",
      "bar__2": "OZU",
      "ICAO": "Kazakhstan",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 7187,
      "bar": "",
      "�װ����": "Khuphuka Kings Airways",
      "bar__1": "Khuphuka Kings Airways",
      "IATA": "",
      "bar__2": "",
      "ICAO": "South Africa",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8596,
      "bar": "",
      "�װ����": "Kin Avia",
      "bar__1": "Kin Avia",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Democratic Republic of Congo",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8597,
      "bar": "",
      "�װ����": "KlasJet",
      "bar__1": "KlasJet",
      "IATA": "",
      "bar__2": "KLJ",
      "ICAO": "Lithuania",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8598,
      "bar": "",
      "�װ����": "K-Mile Air",
      "bar__1": "K-Mile Air",
      "IATA": "8K",
      "bar__2": "KMI",
      "ICAO": "Thailand",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8599,
      "bar": "",
      "�װ����": "Knight Aviation",
      "bar__1": "Knight Aviation",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Kenya",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8600,
      "bar": "",
      "�װ����": "Koral Blue",
      "bar__1": "Koral Blue",
      "IATA": "",
      "bar__2": "KBR",
      "ICAO": "Egypt",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8601,
      "bar": "",
      "�װ����": "Koryakavia",
      "bar__1": "Koryakavia",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Russia",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8602,
      "bar": "",
      "�װ����": "Kostroma Air Enterprise",
      "bar__1": "Kostroma Air Enterprise",
      "IATA": "",
      "bar__2": "KMW",
      "ICAO": "Russia",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8603,
      "bar": "",
      "�װ����": "Kush Air",
      "bar__1": "Kush Air",
      "IATA": "",
      "bar__2": "KUH",
      "ICAO": "Sudan",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8604,
      "bar": "",
      "�װ����": "Kwacha Airlines",
      "bar__1": "Kwacha Airlines",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Malawi",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8605,
      "bar": "",
      "�װ����": "Kyoritsu Air Co",
      "bar__1": "Kyoritsu Air Co",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Japan",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 9018,
      "bar": "",
      "�װ����": "SkyBird Airlines",
      "bar__1": "SkyBird Airlines",
      "IATA": "",
      "bar__2": "SBL",
      "ICAO": "Egypt",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 9019,
      "bar": "",
      "�װ����": "Skybus Jet Cargo",
      "bar__1": "Skybus Jet Cargo",
      "IATA": "",
      "bar__2": "KYG",
      "ICAO": "United States",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 9020,
      "bar": "",
      "�װ����": "SkyBus JSC",
      "bar__1": "SkyBus JSC",
      "IATA": "",
      "bar__2": "BYK",
      "ICAO": "Kazakhstan",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 9021,
      "bar": "",
      "�װ����": "Skycam Helicopteres Sarl",
      "bar__1": "Skycam Helicopteres Sarl",
      "IATA": "",
      "bar__2": "SCK",
      "ICAO": "France",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 9022,
      "bar": "",
      "�װ����": "Skydive & Air Service",
      "bar__1": "Skydive & Air Service",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Czech Republic",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 9023,
      "bar": "",
      "�װ����": "Skydrift",
      "bar__1": "Skydrift",
      "IATA": "",
      "bar__2": "",
      "ICAO": "United Kingdom",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 9024,
      "bar": "",
      "�װ����": "SkyJet Airlines",
      "bar__1": "SkyJet Airlines",
      "IATA": "M8",
      "bar__2": "MSJ",
      "ICAO": "Philippines",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 9025,
      "bar": "",
      "�װ����": "Skylar Airways",
      "bar__1": "Skylar Airways",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Thailand",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 9026,
      "bar": "",
      "�װ����": "Skylease Cargo",
      "bar__1": "Skylease Cargo",
      "IATA": "GG",
      "bar__2": "KYE",
      "ICAO": "United States",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 9027,
      "bar": "",
      "�װ����": "SkyLine air services",
      "bar__1": "SkyLine air services",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Germany",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 9028,
      "bar": "",
      "�װ����": "Skynet",
      "bar__1": "Skynet",
      "IATA": "",
      "bar__2": "SKJ",
      "ICAO": "Armenia",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 9029,
      "bar": "",
      "�װ����": "Skynorth Air",
      "bar__1": "Skynorth Air",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Canada",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 9030,
      "bar": "",
      "�װ����": "Skytaxi",
      "bar__1": "Skytaxi",
      "IATA": "TE",
      "bar__2": "IGA",
      "ICAO": "Poland",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 9031,
      "bar": "",
      "�װ����": "Skytraders",
      "bar__1": "Skytraders",
      "IATA": "",
      "bar__2": "SND",
      "ICAO": "Australia",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 9032,
      "bar": "",
      "�װ����": "Skytrail",
      "bar__1": "Skytrail",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Kenya",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 9033,
      "bar": "",
      "�װ����": "SkyUp",
      "bar__1": "SkyUp",
      "IATA": "PQ",
      "bar__2": "SQP",
      "ICAO": "Ukraine",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 9034,
      "bar": "",
      "�װ����": "SkyValue Airways",
      "bar__1": "SkyValue Airways",
      "IATA": "",
      "bar__2": "",
      "ICAO": "United States",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 9035,
      "bar": "",
      "�װ����": "Skyward Express",
      "bar__1": "Skyward Express",
      "IATA": "OW",
      "bar__2": "SEW",
      "ICAO": "Kenya",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 9036,
      "bar": "",
      "�װ����": "SKYWAY Costa Rica",
      "bar__1": "SKYWAY Costa Rica",
      "IATA": "LC",
      "bar__2": "",
      "ICAO": "Croatia",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 9037,
      "bar": "",
      "�װ����": "SkyWay Enterprises",
      "bar__1": "SkyWay Enterprises",
      "IATA": "KI",
      "bar__2": "SKZ",
      "ICAO": "United States",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 9038,
      "bar": "",
      "�װ����": "SkyWest Airlines",
      "bar__1": "SkyWest Airlines",
      "IATA": "OO",
      "bar__2": "SKW",
      "ICAO": "United States",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 9040,
      "bar": "",
      "�װ����": "SmartLynx Airlines",
      "bar__1": "SmartLynx Airlines",
      "IATA": "6Y",
      "bar__2": "ART",
      "ICAO": "Latvia",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 9041,
      "bar": "",
      "�װ����": "Smartlynx Airlines Estonia",
      "bar__1": "Smartlynx Airlines Estonia",
      "IATA": "",
      "bar__2": "MYX",
      "ICAO": "Estonia",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 9042,
      "bar": "",
      "�װ����": "Smartlynx Malta",
      "bar__1": "Smartlynx Malta",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Malta",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 9043,
      "bar": "",
      "�װ����": "SmartWings",
      "bar__1": "SmartWings",
      "IATA": "QS",
      "bar__2": "TVS",
      "ICAO": "Czech Republic",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 9044,
      "bar": "",
      "�װ����": "SmartWings Germany",
      "bar__1": "SmartWings Germany",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Germany",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 9045,
      "bar": "",
      "�װ����": "SmartWings Hungary",
      "bar__1": "SmartWings Hungary",
      "IATA": "7O",
      "bar__2": "TVL",
      "ICAO": "Hungary",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 9046,
      "bar": "",
      "�װ����": "SmartWings Polska",
      "bar__1": "SmartWings Polska",
      "IATA": "3Z",
      "bar__2": "TVP",
      "ICAO": "Poland",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 9047,
      "bar": "",
      "�װ����": "SmartWings Slovakia",
      "bar__1": "SmartWings Slovakia",
      "IATA": "6D",
      "bar__2": "TVQ",
      "ICAO": "Slovakia",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 9048,
      "bar": "",
      "�װ����": "Smile Air",
      "bar__1": "Smile Air",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Ghana",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 9049,
      "bar": "",
      "�װ����": "Snowbird Airlines",
      "bar__1": "Snowbird Airlines",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Finland",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 9050,
      "bar": "",
      "�װ����": "Societe Nouvelle Air Congo",
      "bar__1": "Societe Nouvelle Air Congo",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Democratic Republic of Congo",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 9051,
      "bar": "",
      "�װ����": "Solar Cargo",
      "bar__1": "Solar Cargo",
      "IATA": "4S",
      "bar__2": "OLC",
      "ICAO": "Venezuela",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 9052,
      "bar": "",
      "�װ����": "Solenta Aviation",
      "bar__1": "Solenta Aviation",
      "IATA": "",
      "bar__2": "SET",
      "ICAO": "South Africa",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 9053,
      "bar": "",
      "�װ����": "Solenta Aviation Gabon",
      "bar__1": "Solenta Aviation Gabon",
      "IATA": "",
      "bar__2": "SVG",
      "ICAO": "Gabon",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 9054,
      "bar": "",
      "�װ����": "Solenta Aviation Mozambique",
      "bar__1": "Solenta Aviation Mozambique",
      "IATA": "FW",
      "bar__2": "",
      "ICAO": "Mozambique",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 9055,
      "bar": "",
      "�װ����": "Solinair",
      "bar__1": "Solinair",
      "IATA": "",
      "bar__2": "SOP",
      "ICAO": "Slovenia",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8026,
      "bar": "",
      "�װ����": "Avia Jaynar",
      "bar__1": "Avia Jaynar",
      "IATA": "",
      "bar__2": "SAP",
      "ICAO": "Kazakhstan",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8027,
      "bar": "",
      "�װ����": "Avia Traffic Company",
      "bar__1": "Avia Traffic Company",
      "IATA": "YK",
      "bar__2": "AVJ",
      "ICAO": "Kyrgyzstan",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8155,
      "bar": "",
      "�װ����": "Central Asian Aviation Services",
      "bar__1": "Central Asian Aviation Services",
      "IATA": "",
      "bar__2": "",
      "ICAO": "United Arab Emirates",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8157,
      "bar": "",
      "�װ����": "Central Mountain Air",
      "bar__1": "Central Mountain Air",
      "IATA": "9M",
      "bar__2": "GLR",
      "ICAO": "Canada",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8158,
      "bar": "",
      "�װ����": "Century Airlines",
      "bar__1": "Century Airlines",
      "IATA": "",
      "bar__2": "",
      "ICAO": "United States",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8159,
      "bar": "",
      "�װ����": "Chair Airlines",
      "bar__1": "Chair Airlines",
      "IATA": "GM",
      "bar__2": "GSW",
      "ICAO": "Switzerland",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8160,
      "bar": "",
      "�װ����": "Chalair Aviation",
      "bar__1": "Chalair Aviation",
      "IATA": "CE",
      "bar__2": "CLG",
      "ICAO": "France",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8161,
      "bar": "",
      "�װ����": "Chani Enterprises",
      "bar__1": "Chani Enterprises",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Zambia",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8162,
      "bar": "",
      "�װ����": "Charlie Airlines",
      "bar__1": "Charlie Airlines",
      "IATA": "CY",
      "bar__2": "CYP",
      "ICAO": "Cyprus",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8163,
      "bar": "",
      "�װ����": "Chartair",
      "bar__1": "Chartair",
      "IATA": "",
      "bar__2": "CHW",
      "ICAO": "Australia",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8164,
      "bar": "",
      "�װ����": "CHC Airways",
      "bar__1": "CHC Airways",
      "IATA": "AW",
      "bar__2": "SCH",
      "ICAO": "Netherlands",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8169,
      "bar": "",
      "�װ����": "CHC Helicopters",
      "bar__1": "CHC Helicopters",
      "IATA": "",
      "bar__2": "ATQ",
      "ICAO": "Nigeria",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8167,
      "bar": "",
      "�װ����": "CHC Helicopters",
      "bar__1": "CHC Helicopters",
      "IATA": "",
      "bar__2": "HEM",
      "ICAO": "Australia",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8170,
      "bar": "",
      "�װ����": "CHC Helikopter Service",
      "bar__1": "CHC Helikopter Service",
      "IATA": "",
      "bar__2": "HKS",
      "ICAO": "Norway",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8174,
      "bar": "",
      "�װ����": "Cherokee Air",
      "bar__1": "Cherokee Air",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Bahamas",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8175,
      "bar": "",
      "�װ����": "Cherry Air",
      "bar__1": "Cherry Air",
      "IATA": "",
      "bar__2": "CCY",
      "ICAO": "United States",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8176,
      "bar": "",
      "�װ����": "Chilean Airways",
      "bar__1": "Chilean Airways",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Chile",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8177,
      "bar": "",
      "�װ����": "China Air Cargo Corporation",
      "bar__1": "China Air Cargo Corporation",
      "IATA": "ZY",
      "bar__2": "CCO",
      "ICAO": "China",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8178,
      "bar": "",
      "�װ����": "China Airlines",
      "bar__1": "China Airlines",
      "IATA": "CI",
      "bar__2": "CAL",
      "ICAO": "Taiwan",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8179,
      "bar": "",
      "�װ����": "China Cargo Airlines",
      "bar__1": "China Cargo Airlines",
      "IATA": "CK",
      "bar__2": "CKK",
      "ICAO": "China",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8180,
      "bar": "",
      "�װ����": "China Express Airlines",
      "bar__1": "China Express Airlines",
      "IATA": "G5",
      "bar__2": "HXA",
      "ICAO": "China",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8181,
      "bar": "",
      "�װ����": "China Flying Dragon Aviation",
      "bar__1": "China Flying Dragon Aviation",
      "IATA": "",
      "bar__2": "CFA",
      "ICAO": "China",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8607,
      "bar": "",
      "�װ����": "Kyzyl Orda Air",
      "bar__1": "Kyzyl Orda Air",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Kazakhstan",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 7192,
      "bar": "",
      "�װ����": "La Compagnie",
      "bar__1": "La Compagnie",
      "IATA": "B0",
      "bar__2": "DJT",
      "ICAO": "France",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8608,
      "bar": "",
      "�װ����": "La Costena",
      "bar__1": "La Costena",
      "IATA": "6Y",
      "bar__2": "NIS",
      "ICAO": "Nicaragua",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8609,
      "bar": "",
      "�װ����": "La Nova",
      "bar__1": "La Nova",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Switzerland",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8610,
      "bar": "",
      "�װ����": "LADE - Lineas Aereas del Estado",
      "bar__1": "LADE - Lineas Aereas del Estado",
      "IATA": "5U",
      "bar__2": "LDE",
      "ICAO": "Argentina",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8611,
      "bar": "",
      "�װ����": "Lake and Peninsula Airlines",
      "bar__1": "Lake and Peninsula Airlines",
      "IATA": "",
      "bar__2": "",
      "ICAO": "United States",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8612,
      "bar": "",
      "�װ����": "LAM Mozambique Airlines",
      "bar__1": "LAM Mozambique Airlines",
      "IATA": "TM",
      "bar__2": "LAM",
      "ICAO": "Mozambique",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8613,
      "bar": "",
      "�װ����": "Lanmei Airlines",
      "bar__1": "Lanmei Airlines",
      "IATA": "LQ",
      "bar__2": "MKR",
      "ICAO": "Cambodia",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8614,
      "bar": "",
      "�װ����": "Lanzarote Aerocargo SL",
      "bar__1": "Lanzarote Aerocargo SL",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Spain",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8615,
      "bar": "",
      "�װ����": "Lao Skyway",
      "bar__1": "Lao Skyway",
      "IATA": "LK",
      "bar__2": "LLL",
      "ICAO": "Laos",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8619,
      "bar": "",
      "�װ����": "LATAM Airline",
      "bar__1": "LATAM Airline",
      "IATA": "LA",
      "bar__2": "LAN",
      "ICAO": "Chile",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8616,
      "bar": "",
      "�װ����": "LATAM Brasil",
      "bar__1": "LATAM Brasil",
      "IATA": "JJ",
      "bar__2": "TAM",
      "ICAO": "Brazil",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8617,
      "bar": "",
      "�װ����": "LATAM Cargo Chile",
      "bar__1": "LATAM Cargo Chile",
      "IATA": "UC",
      "bar__2": "LCO",
      "ICAO": "Chile",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8618,
      "bar": "",
      "�װ����": "LATAM Cargo Colombia",
      "bar__1": "LATAM Cargo Colombia",
      "IATA": "L7",
      "bar__2": "LAE",
      "ICAO": "Colombia",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8620,
      "bar": "",
      "�װ����": "LATAM Colombia",
      "bar__1": "LATAM Colombia",
      "IATA": "4C",
      "bar__2": "ARE",
      "ICAO": "Colombia",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8621,
      "bar": "",
      "�װ����": "LATAM Ecuador",
      "bar__1": "LATAM Ecuador",
      "IATA": "XL",
      "bar__2": "LNE",
      "ICAO": "Ecuador",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8622,
      "bar": "",
      "�װ����": "LATAM Express",
      "bar__1": "LATAM Express",
      "IATA": "LU",
      "bar__2": "LXP",
      "ICAO": "Chile",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8623,
      "bar": "",
      "�װ����": "LATAM Peru",
      "bar__1": "LATAM Peru",
      "IATA": "LP",
      "bar__2": "LPE",
      "ICAO": "Peru",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8624,
      "bar": "",
      "�װ����": "Latin Air Cargo",
      "bar__1": "Latin Air Cargo",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Brazil",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 9376,
      "bar": "",
      "�װ����": "Lauda Europe",
      "bar__1": "Lauda Europe",
      "IATA": "LW",
      "bar__2": "LDA",
      "ICAO": "Malta",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8626,
      "bar": "",
      "�װ����": "Layang-Layang Aerospace",
      "bar__1": "Layang-Layang Aerospace",
      "IATA": "",
      "bar__2": "LAY",
      "ICAO": "Malaysia",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8627,
      "bar": "",
      "�װ����": "Layonair",
      "bar__1": "Layonair",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Mauritania",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8628,
      "bar": "",
      "�װ����": "Le One",
      "bar__1": "Le One",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Malta",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8629,
      "bar": "",
      "�װ����": "Leading Edge Air Services",
      "bar__1": "Leading Edge Air Services",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Philippines",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8630,
      "bar": "",
      "�װ����": "LeAir Charter Services",
      "bar__1": "LeAir Charter Services",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Bahamas",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8631,
      "bar": "",
      "�װ����": "Lease Fly",
      "bar__1": "Lease Fly",
      "IATA": "",
      "bar__2": "LZF",
      "ICAO": "Portugal",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8632,
      "bar": "",
      "�װ����": "Leisure Cargo",
      "bar__1": "Leisure Cargo",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Germany",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8633,
      "bar": "",
      "�װ����": "Leste Aviation",
      "bar__1": "Leste Aviation",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Timor-Leste",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8634,
      "bar": "",
      "�װ����": "Leuenberger Air Service",
      "bar__1": "Leuenberger Air Service",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Canada",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8635,
      "bar": "",
      "�װ����": "LEVEL",
      "bar__1": "LEVEL",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Spain",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8637,
      "bar": "",
      "�װ����": "LEVEL France",
      "bar__1": "LEVEL France",
      "IATA": "LV",
      "bar__2": "",
      "ICAO": "France",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8638,
      "bar": "",
      "�װ����": "Liard Air",
      "bar__1": "Liard Air",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Canada",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8639,
      "bar": "",
      "�װ����": "LIAT",
      "bar__1": "LIAT",
      "IATA": "LI",
      "bar__2": "LIA",
      "ICAO": "Antigua and Barbuda",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8640,
      "bar": "",
      "�װ����": "Libyan Air Cargo",
      "bar__1": "Libyan Air Cargo",
      "IATA": "",
      "bar__2": "LCR",
      "ICAO": "Libya",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 7180,
      "bar": "",
      "�װ����": "Libyan WIngs",
      "bar__1": "Libyan WIngs",
      "IATA": "YL",
      "bar__2": "LWA",
      "ICAO": "Libya",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 9377,
      "bar": "",
      "�װ����": "LIFT Airline",
      "bar__1": "LIFT Airline",
      "IATA": "GE",
      "bar__2": "GBB",
      "ICAO": "South Africa",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 9056,
      "bar": "",
      "�װ����": "Somon Air",
      "bar__1": "Somon Air",
      "IATA": "SZ",
      "bar__2": "SMR",
      "ICAO": "Tajikistan",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 9057,
      "bar": "",
      "�װ����": "Sonair",
      "bar__1": "Sonair",
      "IATA": "",
      "bar__2": "SOR",
      "ICAO": "Angola",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 9058,
      "bar": "",
      "�װ����": "Songbird Airlines",
      "bar__1": "Songbird Airlines",
      "IATA": "",
      "bar__2": "SGB",
      "ICAO": "United States",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 9059,
      "bar": "",
      "�װ����": "Sophia Airlines",
      "bar__1": "Sophia Airlines",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Cote d'Ivoire",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 9060,
      "bar": "",
      "�װ����": "Sounds Air",
      "bar__1": "Sounds Air",
      "IATA": "S8",
      "bar__2": "SDA",
      "ICAO": "New Zealand",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 9061,
      "bar": "",
      "�װ����": "South African Airways",
      "bar__1": "South African Airways",
      "IATA": "SA",
      "bar__2": "SAA",
      "ICAO": "South Africa",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 9062,
      "bar": "",
      "�װ����": "South Airlines",
      "bar__1": "South Airlines",
      "IATA": "",
      "bar__2": "STH",
      "ICAO": "Armenia",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 9063,
      "bar": "",
      "�װ����": "South Nahanni Airways",
      "bar__1": "South Nahanni Airways",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Canada",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 9064,
      "bar": "",
      "�װ����": "Southern Air",
      "bar__1": "Southern Air",
      "IATA": "9S",
      "bar__2": "SOO",
      "ICAO": "United States",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 9065,
      "bar": "",
      "�װ����": "Southern Sky Airlines",
      "bar__1": "Southern Sky Airlines",
      "IATA": "IH",
      "bar__2": "SRS",
      "ICAO": "Kazakhstan",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 9066,
      "bar": "",
      "�װ����": "Sovika Aviation Services",
      "bar__1": "Sovika Aviation Services",
      "IATA": "",
      "bar__2": "",
      "ICAO": "India",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 9067,
      "bar": "",
      "�װ����": "Sparkle Roll",
      "bar__1": "Sparkle Roll",
      "IATA": "",
      "bar__2": "",
      "ICAO": "China",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 9068,
      "bar": "",
      "�װ����": "Speed Star Express",
      "bar__1": "Speed Star Express",
      "IATA": "",
      "bar__2": "",
      "ICAO": "United States",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 9070,
      "bar": "",
      "�װ����": "Spirit Air",
      "bar__1": "Spirit Air",
      "IATA": "",
      "bar__2": "",
      "ICAO": "United States",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 9071,
      "bar": "",
      "�װ����": "Spring Airlines Japan",
      "bar__1": "Spring Airlines Japan",
      "IATA": "IJ",
      "bar__2": "SJO",
      "ICAO": "Japan",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 9072,
      "bar": "",
      "�װ����": "SprintAir",
      "bar__1": "SprintAir",
      "IATA": "P8",
      "bar__2": "SRN",
      "ICAO": "Poland",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 9073,
      "bar": "",
      "�װ����": "SriLankan AirTaxi",
      "bar__1": "SriLankan AirTaxi",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Sri Lanka",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 9074,
      "bar": "",
      "�װ����": "SSA",
      "bar__1": "SSA",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Russia",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 9075,
      "bar": "",
      "�װ����": "ST Barth Commuter",
      "bar__1": "ST Barth Commuter",
      "IATA": "PV",
      "bar__2": "SBU",
      "ICAO": "France",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 9076,
      "bar": "",
      "�װ����": "Stabo Air",
      "bar__1": "Stabo Air",
      "IATA": "4E",
      "bar__2": "SBO",
      "ICAO": "Zambia",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 9077,
      "bar": "",
      "�װ����": "Star Air",
      "bar__1": "Star Air",
      "IATA": "",
      "bar__2": "SRR",
      "ICAO": "Denmark",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 9078,
      "bar": "",
      "�װ����": "Star Air (India)",
      "bar__1": "Star Air (India)",
      "IATA": "OG",
      "bar__2": "SDG",
      "ICAO": "India",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 9079,
      "bar": "",
      "�װ����": "Star Air Aviation",
      "bar__1": "Star Air Aviation",
      "IATA": "",
      "bar__2": "URJ",
      "ICAO": "Pakistan",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 9080,
      "bar": "",
      "�װ����": "Star Aviation",
      "bar__1": "Star Aviation",
      "IATA": "",
      "bar__2": "DST",
      "ICAO": "Algeria",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 9392,
      "bar": "",
      "�װ����": "Star East Airline",
      "bar__1": "Star East Airline",
      "IATA": "4R",
      "bar__2": "SEK",
      "ICAO": "Romania",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 9081,
      "bar": "",
      "�װ����": "Star Peru",
      "bar__1": "Star Peru",
      "IATA": "2I",
      "bar__2": "SRU",
      "ICAO": "Peru",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 9082,
      "bar": "",
      "�װ����": "StarFlyer",
      "bar__1": "StarFlyer",
      "IATA": "7G",
      "bar__2": "SFJ",
      "ICAO": "Japan",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 9083,
      "bar": "",
      "�װ����": "Starlight Airlines",
      "bar__1": "Starlight Airlines",
      "IATA": "QP",
      "bar__2": "SLT",
      "ICAO": "Iraq",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 9084,
      "bar": "",
      "�װ����": "STARLUX Airlines",
      "bar__1": "STARLUX Airlines",
      "IATA": "JX",
      "bar__2": "SJX",
      "ICAO": "China",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8028,
      "bar": "",
      "�װ����": "Aviacon Zito-Trans",
      "bar__1": "Aviacon Zito-Trans",
      "IATA": "ZR",
      "bar__2": "AZS",
      "ICAO": "Russia",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8029,
      "bar": "",
      "�װ����": "Aviaexport Airways",
      "bar__1": "Aviaexport Airways",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Georgia",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 9344,
      "bar": "",
      "�װ����": "Aviair",
      "bar__1": "Aviair",
      "IATA": "GD",
      "bar__2": "",
      "ICAO": "Australia",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 9348,
      "bar": "",
      "�װ����": "China Northwestern Cargo International Airlines",
      "bar__1": "China Northwestern Cargo International Airlines",
      "IATA": "CO",
      "bar__2": "CNW",
      "ICAO": "China",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8182,
      "bar": "",
      "�װ����": "China Postal Airlines",
      "bar__1": "China Postal Airlines",
      "IATA": "CF",
      "bar__2": "CYZ",
      "ICAO": "China",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 9349,
      "bar": "",
      "�װ����": "Chrono Aviation",
      "bar__1": "Chrono Aviation",
      "IATA": "",
      "bar__2": "NDL",
      "ICAO": "Canada",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8184,
      "bar": "",
      "�װ����": "Chukotavia",
      "bar__1": "Chukotavia",
      "IATA": "",
      "bar__2": "ADZ",
      "ICAO": "Russia",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8185,
      "bar": "",
      "�װ����": "CIACA Airlines",
      "bar__1": "CIACA Airlines",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Venezuela",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8187,
      "bar": "",
      "�װ����": "Cinnamon Air",
      "bar__1": "Cinnamon Air",
      "IATA": "C7",
      "bar__2": "CIN",
      "ICAO": "Sri Lanka",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8188,
      "bar": "",
      "�װ����": "Citilink",
      "bar__1": "Citilink",
      "IATA": "QG",
      "bar__2": "CTV",
      "ICAO": "Indonesia",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8191,
      "bar": "",
      "�װ����": "Clay Lacy Aviation",
      "bar__1": "Clay Lacy Aviation",
      "IATA": "",
      "bar__2": "CLY",
      "ICAO": "United States",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8192,
      "bar": "",
      "�װ����": "Clesh Aviation",
      "bar__1": "Clesh Aviation",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Republic of the Congo",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8193,
      "bar": "",
      "�װ����": "Club One Air",
      "bar__1": "Club One Air",
      "IATA": "",
      "bar__2": "",
      "ICAO": "India",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8194,
      "bar": "",
      "�װ����": "CM Airlines",
      "bar__1": "CM Airlines",
      "IATA": "CC",
      "bar__2": "OMT",
      "ICAO": "Honduras",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 9350,
      "bar": "",
      "�װ����": "CMA CGM AIR CARGO",
      "bar__1": "CMA CGM AIR CARGO",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Belgium",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8195,
      "bar": "",
      "�װ����": "CMC Aviation",
      "bar__1": "CMC Aviation",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Kenya",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8196,
      "bar": "",
      "�װ����": "Coastal Aviation",
      "bar__1": "Coastal Aviation",
      "IATA": "CQ",
      "bar__2": "CSV",
      "ICAO": "Tanzania",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8197,
      "bar": "",
      "�װ����": "Cobham Aviation Services",
      "bar__1": "Cobham Aviation Services",
      "IATA": "NC",
      "bar__2": "JTE",
      "ICAO": "Australia",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8198,
      "bar": "",
      "�װ����": "Colombe Airlines",
      "bar__1": "Colombe Airlines",
      "IATA": "",
      "bar__2": "CBL",
      "ICAO": "Burkina Faso",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8199,
      "bar": "",
      "�װ����": "Colorful Guizhou Airlines",
      "bar__1": "Colorful Guizhou Airlines",
      "IATA": "GY",
      "bar__2": "CGZ",
      "ICAO": "China",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8200,
      "bar": "",
      "�װ����": "Comair",
      "bar__1": "Comair",
      "IATA": "MN",
      "bar__2": "CAW",
      "ICAO": "South Africa",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 9266,
      "bar": "",
      "�װ����": "Volaris Costa Rica",
      "bar__1": "Volaris Costa Rica",
      "IATA": "Q6",
      "bar__2": "VOC",
      "ICAO": "Croatia",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 9396,
      "bar": "",
      "�װ����": "Volaris El Salvador",
      "bar__1": "Volaris El Salvador",
      "IATA": "N3",
      "bar__2": "VOS",
      "ICAO": "El Salvador",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 9267,
      "bar": "",
      "�װ����": "Voliamo",
      "bar__1": "Voliamo",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Italy",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 9268,
      "bar": "",
      "�װ����": "Vologda Air Enterprise",
      "bar__1": "Vologda Air Enterprise",
      "IATA": "",
      "bar__2": "VGV",
      "ICAO": "Russia",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 9269,
      "bar": "",
      "�װ����": "Vostok Airlines",
      "bar__1": "Vostok Airlines",
      "IATA": "",
      "bar__2": "VTK",
      "ICAO": "Russia",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 9270,
      "bar": "",
      "�װ����": "Voyageur Airways",
      "bar__1": "Voyageur Airways",
      "IATA": "VC",
      "bar__2": "VAL",
      "ICAO": "Canada",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 9271,
      "bar": "",
      "�װ����": "Vule Airways",
      "bar__1": "Vule Airways",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Uganda",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 9272,
      "bar": "",
      "�װ����": "VVB",
      "bar__1": "VVB",
      "IATA": "",
      "bar__2": "",
      "ICAO": "United Kingdom",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 9273,
      "bar": "",
      "�װ����": "Waasheshkun Airways",
      "bar__1": "Waasheshkun Airways",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Canada",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 9274,
      "bar": "",
      "�װ����": "Wabakimi Air",
      "bar__1": "Wabakimi Air",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Canada",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 9275,
      "bar": "",
      "�װ����": "Waltzing Matilda Aviation",
      "bar__1": "Waltzing Matilda Aviation",
      "IATA": "",
      "bar__2": "",
      "ICAO": "United States",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 9276,
      "bar": "",
      "�װ����": "Wamos Air",
      "bar__1": "Wamos Air",
      "IATA": "EB",
      "bar__2": "PLM",
      "ICAO": "Spain",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 9277,
      "bar": "",
      "�װ����": "Warbelow's Air Ventures",
      "bar__1": "Warbelow's Air Ventures",
      "IATA": "4W",
      "bar__2": "WAV",
      "ICAO": "United States",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 9278,
      "bar": "",
      "�װ����": "Ward Air",
      "bar__1": "Ward Air",
      "IATA": "",
      "bar__2": "",
      "ICAO": "United States",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 9279,
      "bar": "",
      "�װ����": "Wasaya Airways",
      "bar__1": "Wasaya Airways",
      "IATA": "WT",
      "bar__2": "WSG",
      "ICAO": "Canada",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 9282,
      "bar": "",
      "�װ����": "WeGo Air",
      "bar__1": "WeGo Air",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Russia",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 9283,
      "bar": "",
      "�װ����": "West Air",
      "bar__1": "West Air",
      "IATA": "",
      "bar__2": "PCM",
      "ICAO": "United States",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 9284,
      "bar": "",
      "�װ����": "West Atlantic",
      "bar__1": "West Atlantic",
      "IATA": "",
      "bar__2": "NPT",
      "ICAO": "United Kingdom",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 9285,
      "bar": "",
      "�װ����": "West Wing Aviation",
      "bar__1": "West Wing Aviation",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Australia",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 9286,
      "bar": "",
      "�װ����": "Westair Aviation",
      "bar__1": "Westair Aviation",
      "IATA": "WV",
      "bar__2": "WAA",
      "ICAO": "Namibia",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 9287,
      "bar": "",
      "�װ����": "Westair Benin",
      "bar__1": "Westair Benin",
      "IATA": "NS",
      "bar__2": "WSF",
      "ICAO": "Benin",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 9288,
      "bar": "",
      "�װ����": "Western Air",
      "bar__1": "Western Air",
      "IATA": "WT",
      "bar__2": "WST",
      "ICAO": "Bahamas",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 9289,
      "bar": "",
      "�װ����": "Western Global Airlines",
      "bar__1": "Western Global Airlines",
      "IATA": "KD",
      "bar__2": "WGN",
      "ICAO": "United States",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 9290,
      "bar": "",
      "�װ����": "WestJet Encore",
      "bar__1": "WestJet Encore",
      "IATA": "WR",
      "bar__2": "WEN",
      "ICAO": "Canada",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 9291,
      "bar": "",
      "�װ����": "Westlink",
      "bar__1": "Westlink",
      "IATA": "9L",
      "bar__2": "WLN",
      "ICAO": "Nigeria",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 9292,
      "bar": "",
      "�װ����": "Wheels UP",
      "bar__1": "Wheels UP",
      "IATA": "",
      "bar__2": "",
      "ICAO": "United States",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 9293,
      "bar": "",
      "�װ����": "Whistler Air Services",
      "bar__1": "Whistler Air Services",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Canada",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 9294,
      "bar": "",
      "�װ����": "White Airways",
      "bar__1": "White Airways",
      "IATA": "WI",
      "bar__2": "WHT",
      "ICAO": "Portugal",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 9295,
      "bar": "",
      "�װ����": "Wijet",
      "bar__1": "Wijet",
      "IATA": "",
      "bar__2": "WJT",
      "ICAO": "France",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 9296,
      "bar": "",
      "�װ����": "WIKING Helicopter Service",
      "bar__1": "WIKING Helicopter Service",
      "IATA": "",
      "bar__2": "WHS",
      "ICAO": "Germany",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 9297,
      "bar": "",
      "�װ����": "Wilderness North Air",
      "bar__1": "Wilderness North Air",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Canada",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 9397,
      "bar": "",
      "�װ����": "Wing Spirit",
      "bar__1": "Wing Spirit",
      "IATA": "",
      "bar__2": "",
      "ICAO": "United States",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 9298,
      "bar": "",
      "�װ����": "Wingaway Air",
      "bar__1": "Wingaway Air",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Australia",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 9299,
      "bar": "",
      "�װ����": "Wingo",
      "bar__1": "Wingo",
      "IATA": "P5",
      "bar__2": "RPB",
      "ICAO": "Colombia",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 9300,
      "bar": "",
      "�װ����": "Wings of Lebanon",
      "bar__1": "Wings of Lebanon",
      "IATA": "W7",
      "bar__2": "WLB",
      "ICAO": "Lebanon",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 9301,
      "bar": "",
      "�װ����": "Wings Over Africa",
      "bar__1": "Wings Over Africa",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Namibia",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 9302,
      "bar": "",
      "�װ����": "Wings Over Kississing",
      "bar__1": "Wings Over Kississing",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Canada",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 9303,
      "bar": "",
      "�װ����": "Wirakris Udara",
      "bar__1": "Wirakris Udara",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Malaysia",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 9398,
      "bar": "",
      "�װ����": "Wizz Air Abu Dhabi",
      "bar__1": "Wizz Air Abu Dhabi",
      "IATA": "5W",
      "bar__2": "WAZ",
      "ICAO": "United Arab Emirates",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 9304,
      "bar": "",
      "�װ����": "Wizz Air UK",
      "bar__1": "Wizz Air UK",
      "IATA": "W9",
      "bar__2": "WUK",
      "ICAO": "United Kingdom",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 8004,
      "bar": "",
      "�װ����": "World Cargo Airlines",
      "bar__1": "World Cargo Airlines",
      "IATA": "3G",
      "bar__2": "WCM",
      "ICAO": "Malaysia",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 9305,
      "bar": "",
      "�װ����": "World Wings Airways",
      "bar__1": "World Wings Airways",
      "IATA": "",
      "bar__2": "",
      "ICAO": "United States",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 9306,
      "bar": "",
      "�װ����": "Wright Air Service",
      "bar__1": "Wright Air Service",
      "IATA": "8V",
      "bar__2": "WRF",
      "ICAO": "United States",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 9307,
      "bar": "",
      "�װ����": "Xiongan Airlines",
      "bar__1": "Xiongan Airlines",
      "IATA": "",
      "bar__2": "",
      "ICAO": "China",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 9308,
      "bar": "",
      "�װ����": "Xugana Air",
      "bar__1": "Xugana Air",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Botswana",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 9309,
      "bar": "",
      "�װ����": "Yamal Aviation Company",
      "bar__1": "Yamal Aviation Company",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Russia",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 7143,
      "bar": "",
      "�װ����": "Yanair",
      "bar__1": "Yanair",
      "IATA": "YE",
      "bar__2": "ANR",
      "ICAO": "Ukraine",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 9310,
      "bar": "",
      "�װ����": "Yapo Aerotaxi a",
      "bar__1": "Yapo Aerotaxi a",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Brazil",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 9311,
      "bar": "",
      "�װ����": "Yellow Wings Air Services",
      "bar__1": "Yellow Wings Air Services",
      "IATA": "",
      "bar__2": "ELW",
      "ICAO": "Kenya",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 9312,
      "bar": "",
      "�װ����": "Yeti Airlines",
      "bar__1": "Yeti Airlines",
      "IATA": "YT",
      "bar__2": "NYT",
      "ICAO": "Nepal",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 9313,
      "bar": "",
      "�װ����": "YOU Wings",
      "bar__1": "YOU Wings",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Malaysia",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 9314,
      "bar": "",
      "�װ����": "Yuva JetLines Airways",
      "bar__1": "Yuva JetLines Airways",
      "IATA": "",
      "bar__2": "",
      "ICAO": "India",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 9315,
      "bar": "",
      "�װ����": "Zagros Airlines",
      "bar__1": "Zagros Airlines",
      "IATA": "ZV",
      "bar__2": "IZG",
      "ICAO": "Iran",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 9316,
      "bar": "",
      "�װ����": "Zantas Air Service",
      "bar__1": "Zantas Air Service",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Tanzania",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 9317,
      "bar": "",
      "�װ����": "Zarkani Aviation Services",
      "bar__1": "Zarkani Aviation Services",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Egypt",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 9318,
      "bar": "",
      "�װ����": "Zav Airways",
      "bar__1": "Zav Airways",
      "IATA": "",
      "bar__2": "",
      "ICAO": "India",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 9319,
      "bar": "",
      "�װ����": "ZB Air",
      "bar__1": "ZB Air",
      "IATA": "",
      "bar__2": "ZBA",
      "ICAO": "Kenya",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 9320,
      "bar": "",
      "�װ����": "Zhetysu Aviakompania",
      "bar__1": "Zhetysu Aviakompania",
      "IATA": "",
      "bar__2": "JTU",
      "ICAO": "Kazakhstan",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 9321,
      "bar": "",
      "�װ����": "Zhezair",
      "bar__1": "Zhezair",
      "IATA": "",
      "bar__2": "KZH",
      "ICAO": "Kazakhstan",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 9322,
      "bar": "",
      "�װ����": "Zhongzhou Airlines",
      "bar__1": "Zhongzhou Airlines",
      "IATA": "",
      "bar__2": "",
      "ICAO": "China",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 9324,
      "bar": "",
      "�װ����": "Zimskies Airlines",
      "bar__1": "Zimskies Airlines",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Zimbabwe",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 9325,
      "bar": "",
      "�װ����": "Zing Airlines",
      "bar__1": "Zing Airlines",
      "IATA": "",
      "bar__2": "",
      "ICAO": "Canada",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 9326,
      "bar": "",
      "�װ����": "Zipair TOKYO",
      "bar__1": "Zipair TOKYO",
      "IATA": "ZG",
      "bar__2": "TZP",
      "ICAO": "Japan",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 7190,
      "bar": "",
      "�װ����": "Zoom Air",
      "bar__1": "Zoom Air",
      "IATA": "ZO",
      "bar__2": "ZOM",
      "ICAO": "India",
      "bar__3": "",
      "������": ""
    },
    {
      "��ȣ": 9327,
      "bar": "",
      "�װ����": "Zorex Air Transport",
      "bar__1": "Zorex Air Transport",
      "IATA": "",
      "bar__2": "ORZ",
      "ICAO": "Spain",
      "bar__3": "",
      "������": ""
    }
  ]
  